(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.tablerIcons = {}, global.React));
}(this, (function (exports, React) { 'use strict';

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Icon2fa(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-2fa",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 16v-8h4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 13,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 16v-6a2 2 0 0 1 4 0v6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 13,
      x2: 21,
      y2: 13
    }));
  }

  function Icon3dCubeSphere(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-3d-cube-sphere",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 17.6l-2 -1.1v-2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 10v-2.5l2 -1.1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4.1l2 -1.1l2 1.1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6.4l2 1.1v2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 14v2.5l-2 1.12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 19.9l-2 1.1l-2 -1.1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 14,
      y2: 10.9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 8.6,
      x2: 20,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 14.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18.5,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l-2 -1.12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 8.6,
      x2: 4,
      y2: 7.5
    }));
  }

  function IconAB(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-a-b",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 6,
      x2: 12,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3"
    }));
  }

  function IconAccessPointOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-access-point-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.828 9.172a4 4 0 0 1 1.172 2.828"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.657 6.343a8 8 0 0 1 1.635 8.952"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
    }));
  }

  function IconAccessPoint(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-access-point",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.828 9.172a4 4 0 0 1 0 5.656"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.657 6.343a8 8 0 0 1 0 11.314"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
    }));
  }

  function IconAccessible(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-accessible",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7.5,
      r: 0.5,
      fill: "currentColor"
    }));
  }

  function IconActivity(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-activity",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h4l3 8l4 -16l3 8h4"
    }));
  }

  function IconAd(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ad",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 15v-4a2 2 0 0 1 4 0v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 13,
      x2: 11,
      y2: 13
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5"
    }));
  }

  function IconAdjustmentsAlt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-adjustments-alt",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 8,
      width: 4,
      height: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 4,
      x2: 6,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 6,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 14,
      width: 4,
      height: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 16,
      y: 5,
      width: 4,
      height: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 4,
      x2: 18,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 9,
      x2: 18,
      y2: 20
    }));
  }

  function IconAdjustmentsHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-adjustments-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 12,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 6,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 15,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 18,
      x2: 20,
      y2: 18
    }));
  }

  function IconAdjustments(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-adjustments",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 4,
      x2: 6,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 6,
      y2: 20
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 16,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 7,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 4,
      x2: 18,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 9,
      x2: 18,
      y2: 20
    }));
  }

  function IconAerialLift(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-aerial-lift",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 5l16 -2m-8 1v10m-5.106 -6h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12zm-1.894 6h14"
    }));
  }

  function IconAffiliate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-affiliate",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.5 5.5l1.706 5.685m5.607 5.609l5.687 1.706"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.683 12.317l6.817 -6.817"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5.5,
      cy: 5.5,
      r: 1.5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18.5,
      cy: 5.5,
      r: 1.5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18.5,
      cy: 18.5,
      r: 1.5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8.5,
      cy: 15.5,
      r: 4.5
    }));
  }

  function IconAlarm(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-alarm",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 13,
      r: 7
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 10 12 13 14 13"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 4.25,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4,
      x2: 19.75,
      y2: 6
    }));
  }

  function IconAlertCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-alert-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12.01,
      y2: 16
    }));
  }

  function IconAlertOctagon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-alert-octagon",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12.01,
      y2: 16
    }));
  }

  function IconAlertTriangle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-alert-triangle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9v2m0 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }));
  }

  function IconAlien(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-alien",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 17a2.5 2.5 0 0 0 2 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3c-4.664 0 -7.396 2.331 -7.862 5.595a11.816 11.816 0 0 0 2 8.592a10.777 10.777 0 0 0 3.199 3.064c1.666 1 3.664 1 5.33 0a10.777 10.777 0 0 0 3.199 -3.064a11.89 11.89 0 0 0 2 -8.592c-.466 -3.265 -3.198 -5.595 -7.862 -5.595z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 11,
      x2: 10,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 11,
      x2: 14,
      y2: 13
    }));
  }

  function IconAlignCenter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-align-center",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 16,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 18,
      y2: 18
    }));
  }

  function IconAlignJustified(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-align-justified",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 16,
      y2: 18
    }));
  }

  function IconAlignLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-align-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 14,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 18,
      y2: 18
    }));
  }

  function IconAlignRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-align-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 20,
      y2: 18
    }));
  }

  function IconAmbulance(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ambulance",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10h4m-2 -2v4"
    }));
  }

  function IconAnchor(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-anchor",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 6,
      r: 3
    }));
  }

  function IconAntennaBars1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-antenna-bars-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 6,
      y2: 18.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 18,
      x2: 10,
      y2: 18.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 18,
      x2: 14,
      y2: 18.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 18,
      x2: 18,
      y2: 18.01
    }));
  }

  function IconAntennaBars2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-antenna-bars-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 6,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 18,
      x2: 10,
      y2: 18.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 18,
      x2: 14,
      y2: 18.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 18,
      x2: 18,
      y2: 18.01
    }));
  }

  function IconAntennaBars3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-antenna-bars-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 6,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 18,
      x2: 10,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 18,
      x2: 14,
      y2: 18.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 18,
      x2: 18,
      y2: 18.01
    }));
  }

  function IconAntennaBars4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-antenna-bars-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 6,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 18,
      x2: 10,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 18,
      x2: 14,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 18,
      x2: 18,
      y2: 18.01
    }));
  }

  function IconAntennaBars5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-antenna-bars-5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 6,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 18,
      x2: 10,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 18,
      x2: 14,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 18,
      x2: 18,
      y2: 6
    }));
  }

  function IconAperture(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-aperture",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 15,
      x2: 14.15,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 15,
      x2: 14.15,
      y2: 15,
      transform: "rotate(72 12 12)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 15,
      x2: 14.15,
      y2: 15,
      transform: "rotate(144 12 12)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 15,
      x2: 14.15,
      y2: 15,
      transform: "rotate(216 12 12)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 15,
      x2: 14.15,
      y2: 15,
      transform: "rotate(288 12 12)"
    }));
  }

  function IconApps(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-apps",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4,
      x2: 17,
      y2: 10
    }));
  }

  function IconArchive(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-archive",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 14,
      y2: 12
    }));
  }

  function IconArrowBackUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-back-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 13l-4 -4l4 -4m-4 4h11a4 4 0 0 1 0 8h-1"
    }));
  }

  function IconArrowBack(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-back",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1"
    }));
  }

  function IconArrowBarDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 16,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 8,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 20,
      y2: 4
    }));
  }

  function IconArrowBarLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 14,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 8,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 8,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 20
    }));
  }

  function IconArrowBarRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 10,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 16,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 16,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 20
    }));
  }

  function IconArrowBarToDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-to-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 16,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 8,
      y2: 10
    }));
  }

  function IconArrowBarToLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-to-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 14,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 14,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 20
    }));
  }

  function IconArrowBarToRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-to-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 4,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 10,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 10,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 20
    }));
  }

  function IconArrowBarToUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-to-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 16,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 8,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 20,
      y2: 4
    }));
  }

  function IconArrowBarUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bar-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 16,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 8,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 20
    }));
  }

  function IconArrowBigDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-big-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z"
    }));
  }

  function IconArrowBigLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-big-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z"
    }));
  }

  function IconArrowBigRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-big-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z"
    }));
  }

  function IconArrowBigTop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-big-top",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }));
  }

  function IconArrowBottomBar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bottom-bar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 3h6"
    }));
  }

  function IconArrowBottomCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bottom-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 2
    }));
  }

  function IconArrowBottomSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bottom-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4h-4v-4z"
    }));
  }

  function IconArrowBottomTail(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-bottom-tail",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v15"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 3l3 3l3 -3"
    }));
  }

  function IconArrowDownCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-down-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 12,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 12,
      y2: 16
    }));
  }

  function IconArrowDownLeftCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-down-left-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 15 9 15 9 9"
    }));
  }

  function IconArrowDownLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-down-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 7,
      x2: 7,
      y2: 17
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 17 7 17 7 8"
    }));
  }

  function IconArrowDownRightCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-down-right-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 15,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 9 15 15 9 9"
    }));
  }

  function IconArrowDownRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-down-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 7,
      x2: 17,
      y2: 17
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "17 8 17 17 8 17"
    }));
  }

  function IconArrowDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 13,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 13,
      x2: 12,
      y2: 19
    }));
  }

  function IconArrowForwardUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-forward-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 13l4 -4l-4 -4m4 4h-11a4 4 0 0 0 0 8h1"
    }));
  }

  function IconArrowForward(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-forward",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1"
    }));
  }

  function IconArrowLeftBar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-left-bar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12h-18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 9l-3 3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 9v6"
    }));
  }

  function IconArrowLeftCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-left-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12h-14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 9l-3 3l3 3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 12,
      r: 2
    }));
  }

  function IconArrowLeftSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-left-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12h-14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 9l-3 3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 14h-4v-4h4z"
    }));
  }

  function IconArrowLeftTail(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-left-tail",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 12h-15"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 9l-3 3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 9l-3 3l3 3"
    }));
  }

  function IconArrowLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 11,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 11,
      y2: 6
    }));
  }

  function IconArrowLoopLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-loop-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 21v-13a4 4 0 1 1 4 4h-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 15l-3 -3l3 -3"
    }));
  }

  function IconArrowLoopRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-loop-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21v-13a4 4 0 1 0 -4 4h13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }));
  }

  function IconArrowNarrowDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-narrow-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 15,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 15,
      x2: 12,
      y2: 19
    }));
  }

  function IconArrowNarrowLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-narrow-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 9,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 9,
      y2: 8
    }));
  }

  function IconArrowNarrowRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-narrow-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 19,
      y2: 12
    }));
  }

  function IconArrowNarrowUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-narrow-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 9,
      x2: 12,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 9,
      x2: 12,
      y2: 5
    }));
  }

  function IconArrowRampLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-ramp-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 3,
      x2: 17,
      y2: 11.707
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 7l4 -4l4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 14l-4 -4l4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21a11 11 0 0 0 -11 -11h-3"
    }));
  }

  function IconArrowRampRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-ramp-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 3,
      x2: 7,
      y2: 11.707
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 7l-4 -4l-4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 14l4 -4l-4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 21a11 11 0 0 1 11 -11h3"
    }));
  }

  function IconArrowRightBar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-right-bar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9v6"
    }));
  }

  function IconArrowRightCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-right-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12h14"
    }));
  }

  function IconArrowRightSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-right-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 10h4v4h-4z"
    }));
  }

  function IconArrowRightTail(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-right-tail",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 15l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 21,
      y2: 12
    }));
  }

  function IconArrowRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 18,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 6,
      x2: 19,
      y2: 12
    }));
  }

  function IconArrowTopBar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-top-bar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6l-3 -3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 21,
      x2: 15,
      y2: 21
    }));
  }

  function IconArrowTopCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-top-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6l-3 -3l-3 3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 19,
      r: 2
    }));
  }

  function IconArrowTopSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-top-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6l-3 -3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 21v-4h4v4z"
    }));
  }

  function IconArrowTopTail(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-top-tail",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6l-3 -3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 21l-3 -3l-3 3"
    }));
  }

  function IconArrowUpCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-up-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 8,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 12,
      y2: 8
    }));
  }

  function IconArrowUpLeftCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-up-left-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 15,
      y2: 15
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 9 9 9 9 15"
    }));
  }

  function IconArrowUpLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-up-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 7,
      x2: 17,
      y2: 17
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 7 7 7 7 16"
    }));
  }

  function IconArrowUpRightCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-up-right-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 15 15 9 9 9"
    }));
  }

  function IconArrowUpRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-up-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 7,
      x2: 7,
      y2: 17
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 7 17 7 17 16"
    }));
  }

  function IconArrowUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 11,
      x2: 12,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 11,
      x2: 12,
      y2: 5
    }));
  }

  function IconArrowWaveLeftDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-wave-left-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 13.998h-4v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 11.998c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2"
    }));
  }

  function IconArrowWaveLeftUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-wave-left-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9.996h-4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 11.996c-.887 -1.285 -2.48 -2.033 -4 -2c-1.52 -.033 -3.113 .715 -4 2c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3 -1 -4 -2l-2 -2"
    }));
  }

  function IconArrowWaveRightDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-wave-right-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 13.998h4v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 11.998c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2"
    }));
  }

  function IconArrowWaveRightUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrow-wave-right-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 10h4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12c.887 -1.284 2.48 -2.033 4 -2c1.52 -.033 3.113 .716 4 2s2.48 2.033 4 2c1.52 .033 3 -1 4 -2l2 -2"
    }));
  }

  function IconArrowsDiagonal2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-diagonal-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 20 20 20 20 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 4 4 4 4 8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 10,
      y2: 10
    }));
  }

  function IconArrowsDiagonal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-diagonal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 4 20 4 20 8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 10,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 20 4 20 4 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 10,
      y2: 14
    }));
  }

  function IconArrowsDoubleNeSw(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-double-ne-sw",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 14l11 -11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 3h4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 17v4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 10l-11 11"
    }));
  }

  function IconArrowsDoubleNwSe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-double-nw-se",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 21l-11 -11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 14v-4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 14h4v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 3,
      x2: 21,
      y2: 14
    }));
  }

  function IconArrowsDoubleSeNw(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-double-se-nw",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 10,
      x2: 14,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 17v4h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3h-4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 14l-11 -11"
    }));
  }

  function IconArrowsDoubleSwNe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-double-sw-ne",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3l-11 11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 10v4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 10h4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 21l11 -11"
    }));
  }

  function IconArrowsDownUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-down-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 3,
      x2: 17,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 18l-3 3l-3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 21,
      x2: 7,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6l-3 -3l-3 3"
    }));
  }

  function IconArrowsDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 21,
      x2: 7,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 18l-3 3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 21,
      x2: 17,
      y2: 3
    }));
  }

  function IconArrowsHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 8 3 12 7 16"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "17 8 21 12 17 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 21,
      y2: 12
    }));
  }

  function IconArrowsJoin2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-join-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7h1.948c1.913 0 3.705 .933 4.802 2.5a5.861 5.861 0 0 0 4.802 2.5h6.448"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h1.95a5.854 5.854 0 0 0 4.798 -2.5a5.854 5.854 0 0 1 4.798 -2.5h5.454"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }));
  }

  function IconArrowsJoin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-join",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7h5l3.5 5h9.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h5l3.495 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 -3l-3 -3"
    }));
  }

  function IconArrowsLeftDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-left-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3l-4 4l4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7h11a3 3 0 0 1 3 3v11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 17l4 4l4 -4"
    }));
  }

  function IconArrowsLeftRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-left-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 17,
      x2: 3,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10l-3 -3l3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 7,
      x2: 21,
      y2: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20l3 -3l-3 -3"
    }));
  }

  function IconArrowsLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 7,
      x2: 21,
      y2: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 20l-3 -3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4l-3 3l3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 17,
      x2: 21,
      y2: 17
    }));
  }

  function IconArrowsMaximize(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-maximize",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 4 20 4 20 8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 10,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 20 4 20 4 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 10,
      y2: 14
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 20 20 20 20 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 4 4 4 4 8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 10,
      y2: 10
    }));
  }

  function IconArrowsMinimize(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-minimize",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 9 9 9 9 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 9,
      y2: 9
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 15 9 15 9 19"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "19 9 15 9 15 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 21,
      y2: 3
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "19 15 15 15 15 19"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 15,
      x2: 21,
      y2: 21
    }));
  }

  function IconArrowsRightDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-right-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17l4 4l4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 21v-11a3 3 0 0 1 3 -3h11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11l4 -4l-4 -4"
    }));
  }

  function IconArrowsRightLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-right-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 7,
      x2: 3,
      y2: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 10l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 20l-3 -3l3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 17,
      x2: 21,
      y2: 17
    }));
  }

  function IconArrowsRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 17,
      x2: 3,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 4l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 7,
      x2: 3,
      y2: 7
    }));
  }

  function IconArrowsSort(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-sort",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9l4 -4l4 4m-4 -4v14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 15l-4 4l-4 -4m4 4v-14"
    }));
  }

  function IconArrowsSplit2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-split-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 17h-5.397a5 5 0 0 1 -4.096 -2.133l-.514 -.734a5 5 0 0 0 -4.096 -2.133h-3.897"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 7h-5.395a5 5 0 0 0 -4.098 2.135l-.51 .73a5 5 0 0 1 -4.097 2.135h-3.9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 10l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20l3 -3l-3 -3"
    }));
  }

  function IconArrowsSplit(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-split",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 17h-8l-3.5 -5h-6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 7h-8l-3.495 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 10l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20l3 -3l-3 -3"
    }));
  }

  function IconArrowsUpDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-up-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 3,
      x2: 7,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6l-3 -3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 18l-3 3l-3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 21,
      x2: 17,
      y2: 3
    }));
  }

  function IconArrowsUpLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-up-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 7l-4 -4l-4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 3v11a3 3 0 0 1 -3 3h-11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 13l-4 4l4 4"
    }));
  }

  function IconArrowsUpRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-up-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21l4 -4l-4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 17h-11a3 3 0 0 1 -3 -3v-11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 7l-4 -4l-4 4"
    }));
  }

  function IconArrowsUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 3,
      x2: 17,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6l-3 -3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 3,
      x2: 7,
      y2: 21
    }));
  }

  function IconArrowsVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-arrows-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 7 12 3 16 7"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 17 12 21 16 17"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }));
  }

  function IconArtboard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-artboard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 8,
      width: 8,
      height: 8,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 8,
      x2: 4,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 16,
      x2: 4,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 21,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 21,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 21
    }));
  }

  function IconAspectRatio(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-aspect-ratio",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12v-3h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12v3h-3"
    }));
  }

  function IconAt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-at",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28"
    }));
  }

  function IconAtom2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-atom-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 21.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 9,
      x2: 3,
      y2: 9.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 9,
      x2: 21,
      y2: 9.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 20.1a9 9 0 0 1 -5 -7.1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20.1a9 9 0 0 0 5 -7.1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.2 5a9 9 0 0 1 11.4 0"
    }));
  }

  function IconAtom(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-atom",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 2a4 10 0 0 0 -4 10a4 10 0 0 0 4 10a4 10 0 0 0 4 -10a4 10 0 0 0 -4 -10",
      transform: "rotate(45 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 2a4 10 0 0 0 -4 10a4 10 0 0 0 4 10a4 10 0 0 0 4 -10a4 10 0 0 0 -4 -10",
      transform: "rotate(-45 12 12)"
    }));
  }

  function IconAward(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-award",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 9,
      r: 6
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 14.2 9 21 12 19 15 21 15 14.2",
      transform: "rotate(-30 12 9)"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 14.2 9 21 12 19 15 21 15 14.2",
      transform: "rotate(30 12 9)"
    }));
  }

  function IconBackhoe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-backhoe",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 13,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 19,
      x2: 4,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 13,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 15v-2a1 1 0 0 1 1 -1h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.12 9.88l-3.12 -4.88l-5 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
    }));
  }

  function IconBackspace(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-backspace",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 10l4 4m0 -4l-4 4"
    }));
  }

  function IconBallAmericanFootball(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-american-football",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 14,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 21a5 5 0 0 0 -5 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 3c-7.18 0 -13 5.82 -13 13a5 5 0 0 0 5 5c7.18 0 13 -5.82 13 -13a5 5 0 0 0 -5 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 3a5 5 0 0 0 5 5"
    }));
  }

  function IconBallBasketball(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-basketball",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5.65,
      y1: 5.65,
      x2: 18.35,
      y2: 18.35
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5.65,
      y1: 18.35,
      x2: 18.35,
      y2: 5.65
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a9 9 0 0 0 9 9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12a9 9 0 0 1 9 9"
    }));
  }

  function IconBallBowling(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-bowling",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 9,
      x2: 11,
      y2: 9.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 15,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 14,
      y2: 12.01
    }));
  }

  function IconBallFootballOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-football-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.041 16.046a9 9 0 0 0 -12.084 -12.09m-2.323 1.683a9 9 0 0 0 12.726 12.73"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7l4.755 3.455l-.566 1.743l-.98 3.014l-.209 .788h-6l-1.755 -5.545l1.86 -1.351l2.313 -1.681z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 17.5,
      y2: 19
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.755 10.455l3.745 -1.455"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.061 16.045l-2.561 2.955"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.245 10.455l-3.745 -1.455"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconBallFootball(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-football",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45"
    }));
  }

  function IconBallTennis(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-tennis",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 5.3a9 9 0 0 1 0 13.4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 5.3a9 9 0 0 0 0 13.4"
    }));
  }

  function IconBallVolleyball(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ball-volleyball",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5",
      transform: "rotate(120 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5",
      transform: "rotate(240 12 12)"
    }));
  }

  function IconBan(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ban",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5.7,
      y1: 5.7,
      x2: 18.3,
      y2: 18.3
    }));
  }

  function IconBandage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bandage",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 14,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 10,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 12,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
    }));
  }

  function IconBarcode(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-barcode",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 7v-1a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 17v1a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-1"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 11,
      width: 1,
      height: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 10,
      y2: 13
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 11,
      width: 1,
      height: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 11,
      x2: 19,
      y2: 13
    }));
  }

  function IconBasket(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-basket",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 10 12 4 17 10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 15,
      r: 2
    }));
  }

  function IconBattery1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 10,
      x2: 7,
      y2: 14
    }));
  }

  function IconBattery2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 10,
      x2: 7,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 10,
      y2: 14
    }));
  }

  function IconBattery3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 10,
      x2: 7,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 10,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 10,
      x2: 13,
      y2: 14
    }));
  }

  function IconBattery4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 10,
      x2: 7,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 10,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 10,
      x2: 13,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 10,
      x2: 16,
      y2: 14
    }));
  }

  function IconBatteryAutomotive(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-automotive",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 6,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6v-2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 4,
      x2: 19,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6.5,
      y1: 13,
      x2: 9.5,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 13,
      x2: 17.5,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 11.5,
      x2: 16,
      y2: 14.5
    }));
  }

  function IconBatteryCharging(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-charging",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 7h1a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 7h-2a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8l-2 4h3l-2 4"
    }));
  }

  function IconBatteryOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 7h6a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1"
    }));
  }

  function IconBattery(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-battery",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }));
  }

  function IconBed(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bed",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7v11m0 -4h18m0 4v-8a2 2 0 0 0 -2 -2h-8v6"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 10,
      r: 1
    }));
  }

  function IconBellMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v1a3 3 0 0 0 6 0v-1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 14,
      y2: 11
    }));
  }

  function IconBellOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-13a4 4 0 0 0 2 -3v-3a7 7 0 0 1 1.279 -3.716m2.072 -1.934c.209 -.127 .425 -.244 .649 -.35a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v1a3 3 0 0 0 6 0v-1"
    }));
  }

  function IconBellPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v1a3 3 0 0 0 6 0v-1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 14,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 13
    }));
  }

  function IconBellRinging2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell-ringing-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707"
    }));
  }

  function IconBellRinging(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell-ringing",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v1a3 3 0 0 0 6 0v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6.727a11.05 11.05 0 0 1 2.792 -3.727"
    }));
  }

  function IconBellX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v1a3 3 0 0 0 6 0v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.5 9.5l3 3m0 -3l-3 3"
    }));
  }

  function IconBell(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bell",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v1a3 3 0 0 0 6 0v-1"
    }));
  }

  function IconBike(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bike",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 18,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 18,
      r: 3
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 19 12 15 9 12 14 8 16 11 19 11"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 5,
      r: 1
    }));
  }

  function IconBinary(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-binary",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 10v-5h-1m8 14v-5h-1"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 15,
      y: 5,
      width: 3,
      height: 5,
      rx: 0.5
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 14,
      width: 3,
      height: 5,
      rx: 0.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10h.01m-.01 9h.01"
    }));
  }

  function IconBiohazard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-biohazard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.939 14c0 .173 .048 .351 .056 .533l0 .217a4.75 4.75 0 0 1 -4.533 4.745l-.217 0m-4.75 -4.75a4.75 4.75 0 0 1 7.737 -3.693m6.513 8.443a4.75 4.75 0 0 1 -4.69 -5.503l-.06 0m1.764 -2.944a4.75 4.75 0 0 1 7.731 3.477l0 .217m-11.195 -3.813a4.75 4.75 0 0 1 -1.828 -7.624l.164 -.172m6.718 0a4.75 4.75 0 0 1 -1.665 7.798"
    }));
  }

  function IconBlockquote(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-blockquote",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15h15"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 19h-15"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 11h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 7h-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
    }));
  }

  function IconBluetoothConnected(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bluetooth-connected",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 8 17 16 12 20 12 4 17 8 7 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 5,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 12,
      x2: 19,
      y2: 12
    }));
  }

  function IconBluetoothOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bluetooth-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4"
    }));
  }

  function IconBluetooth(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bluetooth",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 8 17 16 12 20 12 4 17 8 7 16"
    }));
  }

  function IconBold(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bold",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"
    }));
  }

  function IconBoltOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bolt-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.212 15.21l-4.212 5.79v-7h-6l3.79 -5.21m1.685 -2.32l2.525 -3.47v6m1 1h5l-2.104 2.893"
    }));
  }

  function IconBolt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bolt",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "13 3 13 10 19 10 11 21 11 14 5 14 13 3"
    }));
  }

  function IconBone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3a3 3 0 0 1 3 3a3 3 0 1 1 -2.12 5.122l-4.758 4.758a3 3 0 1 1 -5.117 2.297l-.005 -.177l-.176 -.005a3 3 0 1 1 2.298 -5.115l4.758 -4.758a3 3 0 0 1 2.12 -5.122z"
    }));
  }

  function IconBook(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-book",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 6,
      x2: 3,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 6,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 6,
      x2: 21,
      y2: 19
    }));
  }

  function IconBookmarkOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bookmark-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v3l-5 -3l-5 3v-13m1.178 -2.818c.252 -.113 .53 -.176 .822 -.176h6a2 2 0 0 1 2 2v7"
    }));
  }

  function IconBookmark(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bookmark",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
    }));
  }

  function IconBookmarks(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bookmarks",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 7a2 2 0 0 1 2 2v12l-5 -3l-5 3v-12a2 2 0 0 1 2 -2h6z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v12l-1 -.6"
    }));
  }

  function IconBorderAll(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-all",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }));
  }

  function IconBorderBottom(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-bottom",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 4,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 4,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 20,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }));
  }

  function IconBorderHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBorderInner(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-inner",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBorderLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 20,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBorderNone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-none",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 4,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 20,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBorderOuter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-outer",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }));
  }

  function IconBorderRadius(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-radius",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v-4a4 4 0 0 1 4 -4h4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 20,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBorderRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 4,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }));
  }

  function IconBorderStyle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-style",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20v-14a2 2 0 0 1 2 -2h14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 8v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20v.01"
    }));
  }

  function IconBorderTop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-top",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 4,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 20,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBorderVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-border-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 20,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 4,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 20,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 16,
      x2: 20,
      y2: 16.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 4,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 8,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 20,
      x2: 16,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 20,
      x2: 20,
      y2: 20.01
    }));
  }

  function IconBoxMargin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-margin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8h8v8h-8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 8v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v.01"
    }));
  }

  function IconBoxModel(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-model",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8h8v8h-8z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16l3.3 3.3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8l3.3 -3.3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8l-3.3 -3.3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16l-3.3 3.3"
    }));
  }

  function IconBoxMultiple0(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-0",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 6a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxMultiple1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 14v-8l-2 2"
    }));
  }

  function IconBoxMultiple2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 -.001"
    }));
  }

  function IconBoxMultiple3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10a2 2 0 1 0 -2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a2 2 0 1 0 2 -2"
    }));
  }

  function IconBoxMultiple4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 14v-8l-4 6h5"
    }));
  }

  function IconBoxMultiple5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 14h2a2 2 0 1 0 0 -4h-2v-4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxMultiple6(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-6",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8a2 2 0 1 0 -4 0v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxMultiple7(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-7",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6h4l-2 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxMultiple8(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-8",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 8,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxMultiple9(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple-9",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 8,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a2 2 0 1 0 4 0v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxMultiple(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-multiple",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 3,
      width: 14,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconBoxPadding(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box-padding",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 16v.01"
    }));
  }

  function IconBox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-box",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 20,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 4,
      y2: 7.5
    }));
  }

  function IconBraces(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-braces",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4a2 2 0 0 0 -2 2v3a2 3 0 0 1 -2 3a2 3 0 0 1 2 3v3a2 2 0 0 0 2 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4a2 2 0 0 1 2 2v3a2 3 0 0 0 2 3a2 3 0 0 0 -2 3v3a2 2 0 0 1 -2 2"
    }));
  }

  function IconBrackets(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brackets",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h-3v16h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h3v16h-3"
    }));
  }

  function IconBrandAirbnb(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-airbnb",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 10c-2 0 -3 1 -3 3c0 1.5 1.494 3.535 3 5.5c1 1 1.5 1.5 2.5 2s2.5 1 4.5 -.5s1.5 -3.5 .5 -6s-2.333 -5.5 -5 -9.5c-.834 -1 -1.5 -1.5 -2.503 -1.5c-1 0 -1.623 .45 -2.497 1.5c-2.667 4 -4 7 -5 9.5s-1.5 4.5 .5 6s3.5 1 4.5 .5s1.5 -1 2.5 -2c1.506 -1.965 3 -4 3 -5.5c0 -2 -1 -3 -3 -3z"
    }));
  }

  function IconBrandAndroid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-android",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 10,
      x2: 4,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 10,
      x2: 20,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9h10v8a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-8a5 5 0 0 1 10 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 9,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 15,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 18,
      x2: 9,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 18,
      x2: 15,
      y2: 21
    }));
  }

  function IconBrandAppleArcade(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-apple-arcade",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12.5v4.75a0.734 .734 0 0 1 -.055 .325a0.704 .704 0 0 1 -.348 .366l-5.462 2.58a4.998 4.998 0 0 1 -4.27 0l-5.462 -2.58a0.705 .705 0 0 1 -.401 -.691l-.002 -4.75"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a0.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a0.691 .691 0 0 1 .028 -1.27z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 13
    }));
  }

  function IconBrandApple(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-apple",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 7c-3 0 -4 3 -4 5.5c0 3 2 7.5 4 7.5c1.088 -.046 1.679 -.5 3 -.5c1.312 0 1.5 .5 3 .5s4 -3 4 -5c-.028 -.01 -2.472 -.403 -2.5 -3c-.019 -2.17 2.416 -2.954 2.5 -3c-1.023 -1.492 -2.951 -1.963 -3.5 -2c-1.433 -.111 -2.83 1 -3.5 1c-.68 0 -1.9 -1 -3 -1z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 4a2 2 0 0 0 2 -2a2 2 0 0 0 -2 2"
    }));
  }

  function IconBrandAppstore(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-appstore",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 14h5m2.9 0h2.1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16l-2.51 -4.518m-1.487 -2.677l-1.003 -1.805"
    }));
  }

  function IconBrandAsana(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-asana",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 16,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 16,
      r: 3
    }));
  }

  function IconBrandBehance(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-behance",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 7.5,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 6,
      x2: 19,
      y2: 6
    }));
  }

  function IconBrandBing(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-bing",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z"
    }));
  }

  function IconBrandBitbucket(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-bitbucket",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.648 4a0.64 .64 0 0 0 -.64 .744l3.14 14.528c.07 .417 .43 .724 .852 .728h10a0.644 .644 0 0 0 .642 -.539l3.35 -14.71a0.641 .641 0 0 0 -.64 -.744l-16.704 -.007z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15h-4l-1 -6h6z"
    }));
  }

  function IconBrandBooking(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-booking",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18v-9.5a4.5 4.5 0 0 1 4.5 -4.5h7a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1 -4.5 4.5h-9.5a2 2 0 0 1 -2 -2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12h3.5a2 2 0 1 1 0 4h-3.5v-7a1 1 0 0 1 1 -1h1.5a2 2 0 1 1 0 4h-1.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 16,
      x2: 16.01,
      y2: 16
    }));
  }

  function IconBrandChrome(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-chrome",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 20.4,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 20.4,
      y2: 9,
      transform: "rotate(120 12 12)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 20.4,
      y2: 9,
      transform: "rotate(240 12 12)"
    }));
  }

  function IconBrandCodepen(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-codepen",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 15l9 6l9 -6l-9 -6l-9 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9l9 6l9 -6l-9 -6l-9 6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 9,
      x2: 3,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 9,
      x2: 21,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 21
    }));
  }

  function IconBrandCodesandbox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-codesandbox",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l4 -2.25l4 -2.25"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l-4 -2.25l-4 -2.25"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12l-4 2v4.75"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12l4 2l0 4.75"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 5.25l4 2.25l4 -2.25"
    }));
  }

  function IconBrandCss3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-css3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
    }));
  }

  function IconBrandDeviantart(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-deviantart",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4z"
    }));
  }

  function IconBrandDiscord(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-discord",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.5 7.5c3.5 -1 5.5 -1 9 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 16.5c3.5 1 6.5 1 10 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-1 2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.5 17c0 1 -1.356 3 -1.832 3c-1.429 0 -2.698 -1.667 -3.333 -3c-.635 -1.667 -.476 -5.833 1.428 -11.5c1.388 -1.015 2.782 -1.34 4.237 -1.5l1 2.5"
    }));
  }

  function IconBrandDisqus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-disqus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.847 21c-2.259 0 -4.323 -.667 -5.919 -2h-3.928l1.708 -3.266c-.545 -1.174 -.759 -2.446 -.758 -3.734c0 -4.97 3.84 -9 8.898 -9c5.052 0 9.152 4.03 9.152 9c0 4.972 -4.098 9 -9.153 9z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.485 15h-1.485v-6h1.485c2.112 0 3.515 .823 3.515 2.981v.035c0 2.18 -1.403 2.984 -3.515 2.984z"
    }));
  }

  function IconBrandDocker(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-docker",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1.002 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 10h3v3h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 10h3v3h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 10h3v3h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 7h3v3h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 7h3v3h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 4h3v3h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.571 18.001c1.5 0 2.047 -.074 2.958 -.78"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 16,
      x2: 10,
      y2: 16.01
    }));
  }

  function IconBrandDribbble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-dribbble",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 3.6c5 6 7 10.5 7.5 16.2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.1 10.75c5 0 9.814 -.38 15.314 -5"
    }));
  }

  function IconBrandEdge(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-edge",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.978 11.372a9 9 0 1 0 -1.593 5.773"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.978 11.372c.21 2.993 -5.034 2.413 -6.913 1.486c1.392 -1.6 .402 -4.038 -2.274 -3.851c-1.745 .122 -2.927 1.157 -2.784 3.202c.28 3.99 4.444 6.205 10.36 4.79"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.022 12.628c-.283 -4.043 8.717 -7.228 11.248 -2.688"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.628 20.978c-2.993 .21 -5.162 -4.725 -3.567 -9.748"
    }));
  }

  function IconBrandFacebook(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-facebook",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
    }));
  }

  function IconBrandFigma(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-figma",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 3,
      width: 12,
      height: 6,
      rx: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15"
    }));
  }

  function IconBrandFirefox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-firefox",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.028 7.82a9 9 0 1 0 12.823 -3.4c-1.636 -1.02 -3.064 -1.02 -4.851 -1.02h-1.647"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.914 9.485c-1.756 -1.569 -.805 -5.38 .109 -6.17c.086 .896 .585 1.208 1.111 1.685c.88 -.275 1.313 -.282 1.867 0c.82 -.91 1.694 -2.354 2.628 -2.093c-1.082 1.741 -.07 3.733 1.371 4.173c-.17 .975 -1.484 1.913 -2.76 2.686c-1.296 .938 -.722 1.85 0 2.234c.949 .506 3.611 -.995 4.545 .354c-1.698 .102 -1.536 3.107 -3.983 2.727c2.523 .957 4.345 .462 5.458 -.34c1.965 -1.52 2.879 -3.542 2.879 -5.557c-.014 -1.398 .194 -2.695 -1.26 -4.75"
    }));
  }

  function IconBrandFlickr(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-flickr",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 12,
      r: 3
    }));
  }

  function IconBrandFoursquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-foursquare",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3h10c.644 0 1.11 .696 .978 1.33l-1.984 9.859a1.014 1.014 0 0 1 -.994 .811h-2.254c-.308 0 -.6 .141 -.793 .382l-4.144 5.25c-.599 .752 -1.809 .331 -1.809 -.632v-16c0 -.564 .44 -1 1 -1z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 17,
      y2: 9
    }));
  }

  function IconBrandFramer(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-framer",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15h12l-12 -12h12v6h-12v6l6 6v-6"
    }));
  }

  function IconBrandGithub(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-github",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"
    }));
  }

  function IconBrandGitlab(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-gitlab",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z"
    }));
  }

  function IconBrandGoogleAnalytics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-google-analytics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 9,
      width: 4,
      height: 12,
      rx: 1.105
    }), /*#__PURE__*/React.createElement("rect", {
      x: 17,
      y: 3,
      width: 4,
      height: 18,
      rx: 1.105
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 2
    }));
  }

  function IconBrandGoogleDrive(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-google-drive",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 10l-6 10l-3 -5l6 -10z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 15h12l-3 5h-12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 15l-6 -10h6l6 10z"
    }));
  }

  function IconBrandGooglePlay(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-google-play",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 3.71v16.58a0.7 .7 0 0 0 1.05 .606l14.622 -8.42a0.55 .55 0 0 0 0 -.953l-14.622 -8.419a0.7 .7 0 0 0 -1.05 .607z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 4.5,
      y2: 20.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.5,
      y1: 3.5,
      x2: 15,
      y2: 15
    }));
  }

  function IconBrandGoogle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-google",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.788 5.108a9 9 0 1 0 3.212 6.892h-8"
    }));
  }

  function IconBrandGravatar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-gravatar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714"
    }));
  }

  function IconBrandHipchat(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-hipchat",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 2.998 -3.49 2.998 -5.789c0 -4.286 -4.03 -7.764 -8.998 -7.764c-4.97 0 -9.002 3.478 -9.002 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.5 13.5c2.5 2.5 6.5 2.5 9 0"
    }));
  }

  function IconBrandHtml5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-html5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
    }));
  }

  function IconBrandInstagram(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-instagram",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.5,
      y1: 7.5,
      x2: 16.5,
      y2: 7.501
    }));
  }

  function IconBrandKickstarter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-kickstarter",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 9l2.975 -4.65c.615 -.9 1.405 -1.35 2.377 -1.35c.79 0 1.474 .286 2.054 .858c.576 .574 .866 1.256 .866 2.054c0 .588 -.153 1.109 -.46 1.559l-2.812 4.029l3.465 4.912c.356 .46 .535 .998 .535 1.613a2.92 2.92 0 0 1 -.843 2.098c-.561 .584 -1.242 .877 -2.04 .877c-.876 0 -1.545 -.29 -2.005 -.87l-4.112 -5.697v3.067c0 .876 -.313 1.69 -.611 2.175c-.543 .883 -1.35 1.325 -2.389 1.325c-.944 0 -1.753 -.327 -2.271 -.974c-.486 -.6 -.729 -1.392 -.729 -2.38v-11.371c0 -.934 .247 -1.706 .74 -2.313c.512 -.641 1.347 -.962 2.26 -.962c.868 0 1.821 .321 2.4 .962c.323 .356 .515 .714 .6 1.08c.052 .224 0 .643 0 1.26v2.698z"
    }));
  }

  function IconBrandKotlin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-kotlin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20h-16v-16h16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12l8 -8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 20,
      y2: 20
    }));
  }

  function IconBrandLinkedin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-linkedin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 11,
      x2: 8,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 8,
      x2: 8,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v-3a2 2 0 0 0 -4 0"
    }));
  }

  function IconBrandMedium(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-medium",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 9h1l3 3l3 -3h1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 15,
      x2: 10,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 15,
      x2: 16,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 15,
      y2: 15
    }));
  }

  function IconBrandMessenger(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-messenger",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13l3 -2l2 2l3 -2"
    }));
  }

  function IconBrandNetflix(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-netflix",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 20v-16l7 16v-16"
    }));
  }

  function IconBrandOpenSource(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-open-source",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z"
    }));
  }

  function IconBrandOpera(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-opera",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 12,
      cy: 12,
      rx: 3,
      ry: 5
    }));
  }

  function IconBrandPagekit(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-pagekit",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.077 20h-5.077v-16h11v14h-5.077"
    }));
  }

  function IconBrandPatreon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-patreon",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3h3v18h-3z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 9.5,
      r: 6.5
    }));
  }

  function IconBrandPaypal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-paypal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13l2.5 0c2.5 0 5 -2.5 5 -5c0 -3 -1.9 -5 -5 -5h-5.5c-.5 0 -1 .5 -1 1l-2 14c0 .5 .5 1 1 1h2.8l1.2 -5c.1 -.6 .4 -1 1 -1zm7.5 -5.8c1.7 1 2.5 2.8 2.5 4.8c0 2.5 -2.5 4.5 -5 4.5h-2.6l-.6 3.6a1 1 0 0 1 -1 .8l-2.7 0a0.5 .5 0 0 1 -.5 -.6l.2 -1.4"
    }));
  }

  function IconBrandPinterest(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-pinterest",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 20,
      x2: 12,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconBrandPocket(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-pocket",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 11 12 15 16 11"
    }));
  }

  function IconBrandProducthunt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-producthunt",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconBrandPython(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-python",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9h-7a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 15h7a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-4a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 6,
      x2: 11,
      y2: 6.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 18,
      x2: 13,
      y2: 18.01
    }));
  }

  function IconBrandReddit(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-reddit",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8c2.648 0 5.028 .826 6.675 2.14a2.5 2.5 0 0 1 2.326 4.36c0 3.59 -4.03 6.5 -9 6.5c-4.875 0 -8.845 -2.8 -9 -6.294l-1 -.206a2.5 2.5 0 0 1 2.326 -4.36c1.646 -1.313 4.026 -2.14 6.674 -2.14z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8l1 -5l6 1"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 4,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 13,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 13,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 17c.667 .333 1.333 .5 2 .5s1.333 -.167 2 -.5"
    }));
  }

  function IconBrandSafari(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-safari",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 16 10 10 16 8 14 14 8 16"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconBrandSass(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-sass",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 10.523c2.46 -.826 4.002 -.826 4.002 -2.155c0 -1.366 -1.347 -1.366 -2.735 -1.366c-1.91 0 -3.352 .49 -4.537 1.748c-.848 .902 -1.027 2.449 -.153 3.307c.973 .956 3.206 1.789 2.884 3.493c-.233 1.235 -1.469 1.823 -2.617 1.202c-.782 -.424 -.454 -1.746 .626 -2.512s2.822 -.992 4.1 -.24c.98 .575 1.046 1.724 .434 2.193"
    }));
  }

  function IconBrandSentry(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-sentry",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18a1.93 1.93 0 0 0 .306 1.076a2 2 0 0 0 1.584 .924c.646 .033 -.537 0 .11 0h3a4.992 4.992 0 0 0 -3.66 -4.81c.558 -.973 1.24 -2.149 2.04 -3.531a8.997 8.997 0 0 1 5.62 8.341h4c.663 0 2.337 .005 3 0a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-1.84 3.176c4.482 2.05 7.6 6.571 7.6 11.824"
    }));
  }

  function IconBrandShazam(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-shazam",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12l2 -2a2.828 2.828 0 0 1 4 0a2.828 2.828 0 0 1 0 4l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 12l-2 2a2.828 2.828 0 1 1 -4 -4l3 -3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconBrandSketch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-sketch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.262 10.878l8 8.789c.4 .44 1.091 .44 1.491 0l8 -8.79c.313 -.344 .349 -.859 .087 -1.243l-3.537 -5.194a1 1 0 0 0 -.823 -.436h-8.926a1 1 0 0 0 -.823 .436l-3.54 5.192c-.263 .385 -.227 .901 .087 1.246z"
    }));
  }

  function IconBrandSkype(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-skype",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a9 9 0 0 1 8.603 11.65a4.5 4.5 0 0 1 -5.953 5.953a9 9 0 0 1 -11.253 -11.253a4.5 4.5 0 0 1 5.953 -5.954a8.987 8.987 0 0 1 2.65 -.396z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 14.5c.5 2 2.358 2.5 4 2.5c2.905 0 4 -1.187 4 -2.5c0 -1.503 -1.927 -2.5 -4 -2.5s-4 -.997 -4 -2.5c0 -1.313 1.095 -2.5 4 -2.5c1.642 0 3.5 .5 4 2.5"
    }));
  }

  function IconBrandSlack(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-slack",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6"
    }));
  }

  function IconBrandSnapchat(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-snapchat",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
    }));
  }

  function IconBrandSoundcloud(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-soundcloud",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 8,
      x2: 9,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 17,
      x2: 6,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 16,
      x2: 3,
      y2: 14
    }));
  }

  function IconBrandSpotify(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-spotify",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 15c1.5 -1 4 -1 5 .5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9c2 -1 6 -2 10 .5"
    }));
  }

  function IconBrandSteam(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-steam",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.5 5a4.5 4.5 0 1 1 -.653 8.953l-4.347 3.009l0 .038a3 3 0 0 1 -2.824 2.995l-.176 .005a3.001 3.001 0 0 1 -2.94 -2.402l-2.56 -1.098v-3.5l3.51 1.755a2.989 2.989 0 0 1 2.834 -.635l2.727 -3.818a4.5 4.5 0 0 1 4.429 -5.302z"
    }), /*#__PURE__*/React.createElement("circle", {
      fill: "currentColor",
      cx: 16.5,
      cy: 9.5,
      r: 1
    }));
  }

  function IconBrandStripe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-stripe",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.453 8.056c0 -.623 .518 -.979 1.442 -.979c1.69 0 3.41 .343 4.605 .923l.5 -4c-.948 -.449 -2.82 -1 -5.5 -1c-1.895 0 -3.373 .087 -4.5 1c-1.172 .956 -2 2.33 -2 4c0 3.03 1.958 4.906 5 6c1.961 .69 3 .743 3 1.5c0 .735 -.851 1.5 -2 1.5c-1.423 0 -3.963 -.609 -5.5 -1.5l-.5 4c1.321 .734 3.474 1.5 6 1.5c2.004 0 3.957 -.468 5.084 -1.36c1.263 -.979 1.916 -2.268 1.916 -4.14c0 -3.096 -1.915 -4.547 -5.003 -5.637c-1.646 -.605 -2.544 -1.07 -2.544 -1.807z"
    }));
  }

  function IconBrandTabler(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-tabler",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 9l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 15,
      x2: 16,
      y2: 15
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 4
    }));
  }

  function IconBrandTailwind(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-tailwind",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.667 6c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 2 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968zm-4 6.5c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 1.975 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968z"
    }));
  }

  function IconBrandTelegram(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-telegram",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"
    }));
  }

  function IconBrandTidal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-tidal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 14l-2.5 2.5l2.5 2.5l2.5 -2.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
    }));
  }

  function IconBrandTiktok(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-tiktok",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12a4 4 0 1 0 4 4v-12a5 5 0 0 0 5 5"
    }));
  }

  function IconBrandTinder(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-tinder",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.918 8.174c2.56 4.982 .501 11.656 -5.38 12.626c-7.702 1.687 -12.84 -7.716 -7.054 -13.229c.309 -.305 1.161 -1.095 1.516 -1.349c0 .528 .27 3.475 1 3.167c3 0 4 -4.222 3.587 -7.389c2.7 1.411 4.987 3.376 6.331 6.174z"
    }));
  }

  function IconBrandTumblr(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-tumblr",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4"
    }));
  }

  function IconBrandTwitch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-twitch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 5v11a1 1 0 0 0 1 1h2v4l4 -4h5.584c.266 0 .52 -.105 .707 -.293l2.415 -2.414c.187 -.188 .293 -.442 .293 -.708v-8.585a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 8,
      x2: 16,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 12
    }));
  }

  function IconBrandTwitter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-twitter",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z"
    }));
  }

  function IconBrandUnsplash(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-unsplash",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z"
    }));
  }

  function IconBrandVimeo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-vimeo",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 8.5l1 1s1.5 -1.102 2 -.5c.509 .609 1.863 7.65 2.5 9c.556 1.184 1.978 2.89 4 1.5c2 -1.5 7.5 -5.5 8.5 -11.5c.444 -2.661 -1 -4 -2.5 -4c-2 0 -4.047 1.202 -4.5 4c2.05 -1.254 2.551 1.003 1.5 3c-1.052 2.005 -2 3 -2.5 3c-.49 0 -.924 -1.165 -1.5 -3.5c-.59 -2.42 -.5 -6.5 -3 -6.5s-5.5 4.5 -5.5 4.5z"
    }));
  }

  function IconBrandVk(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-vk",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6h2v12c-4.5 -1 -8 -6.5 -9 -12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6c-1 2 -3 5 -5 6h-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 18c-1 -2 -3 -5 -5 -6"
    }));
  }

  function IconBrandWhatsapp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-whatsapp",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
    }));
  }

  function IconBrandWindows(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-windows",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }));
  }

  function IconBrandYahoo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-yahoo",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 6,
      x2: 8,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 18,
      x2: 14,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 6l5.5 7v5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13l6 -5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12.5,
      y1: 8,
      x2: 17.5,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 11,
      x2: 20,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 18,
      x2: 20,
      y2: 18.01
    }));
  }

  function IconBrandYcombinator(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-ycombinator",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 7.002l4 5.998l4 -6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 13
    }));
  }

  function IconBrandYoutube(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brand-youtube",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 9l5 3l-5 3z"
    }));
  }

  function IconBriefcase(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-briefcase",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 7,
      width: 18,
      height: 13,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 13a20 20 0 0 0 18 0"
    }));
  }

  function IconBrightness2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brightness-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
    }));
  }

  function IconBrightnessDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brightness-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 5.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 7,
      x2: 17,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 12,
      x2: 19,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 17,
      x2: 17,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 12,
      y2: 19.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 17,
      x2: 7,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 5,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 7,
      x2: 7,
      y2: 7.01
    }));
  }

  function IconBrightnessHalf(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brightness-half",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9a3 3 0 0 0 0 6v-6z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
    }));
  }

  function IconBrightnessUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brightness-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 7,
      x2: 18.4,
      y2: 5.6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 17,
      x2: 18.4,
      y2: 18.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 17,
      x2: 5.6,
      y2: 18.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 4,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 7,
      x2: 5.6,
      y2: 5.6
    }));
  }

  function IconBrightness(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brightness",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 16.65,
      y2: 4.35
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14.3,
      x2: 19.37,
      y2: 6.93
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19.6,
      x2: 20.85,
      y2: 10.75
    }));
  }

  function IconBrowser(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-browser",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 20,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 8
    }));
  }

  function IconBrush(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-brush",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-4a4 4 0 1 1 4 4h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 3a16 16 0 0 0 -12.8 10.2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 3a16 16 0 0 1 -10.2 12.8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.6 9a9 9 0 0 1 4.4 4.4"
    }));
  }

  function IconBucket(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bucket",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 9l-2 9a2 2.5 0 0 1 -2 2h-6a2 2.5 0 0 1 -2 -2l-2 -9z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9a5 5 0 0 1 10 0"
    }));
  }

  function IconBug(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bug",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 9v-1a3 3 0 0 1 6 0v1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 9h8a6 6 0 0 1 1 3v3a5 5 0 0 1 -10 0v-3a6 6 0 0 1 1 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 13,
      x2: 7,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 13,
      x2: 21,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 7.35,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 19,
      x2: 16.65,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 7,
      x2: 7.75,
      y2: 9.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 7,
      x2: 16.25,
      y2: 9.4
    }));
  }

  function IconBuildingArch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-arch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 21v-8a3 3 0 0 1 6 0v8"
    }));
  }

  function IconBuildingBank(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-bank",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 10,
      x2: 21,
      y2: 10
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 6 12 3 19 6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 10,
      x2: 4,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 10,
      x2: 20,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 14,
      x2: 8,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 14,
      x2: 16,
      y2: 17
    }));
  }

  function IconBuildingBridge2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-bridge-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 7h12a2 2 0 0 1 2 2v9a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a4 4 0 0 0 -8 0v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2"
    }));
  }

  function IconBuildingBridge(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-bridge",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 5,
      x2: 6,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 5,
      x2: 18,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 2,
      y1: 15,
      x2: 22,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 12,
      y2: 15
    }));
  }

  function IconBuildingCarousel(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-carousel",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 6
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 8,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 4,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 8,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 16,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 16,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 22l4 -10l4 10"
    }));
  }

  function IconBuildingCastle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-castle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 11,
      x2: 21,
      y2: 11
    }));
  }

  function IconBuildingChurch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-church",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 21v-4a2 2 0 0 1 4 0v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 5,
      x2: 14,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 8
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7"
    }));
  }

  function IconBuildingCommunity(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-community",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 7,
      x2: 13,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 7,
      x2: 17,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 11,
      x2: 17,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 15,
      x2: 17,
      y2: 15.01
    }));
  }

  function IconBuildingCottage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-cottage",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 9,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5"
    }));
  }

  function IconBuildingFactory(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-factory",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.5 13h4.5c.025 2.612 .894 5.296 2 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 22,
      y2: 21
    }));
  }

  function IconBuildingFortress(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-fortress",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 7h0v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 10h0v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 13h0v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 7h0v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 10h0v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 13h0v.01"
    }));
  }

  function IconBuildingHospital(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-hospital",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 9,
      x2: 14,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 11
    }));
  }

  function IconBuildingLighthouse(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-lighthouse",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3l2 3l2 15h-8l2 -15z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 9,
      x2: 16,
      y2: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 11l2 -2l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 11l-2 -2l2 -2"
    }));
  }

  function IconBuildingMonument(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-monument",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 18l2 -13l2 -2l2 2l2 13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-3h14v3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }));
  }

  function IconBuildingPavilon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-pavilon",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21h7v-3a2 2 0 0 1 4 0v3h7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 21,
      x2: 6,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 21,
      x2: 18,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3"
    }));
  }

  function IconBuildingSkyscraper(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-skyscraper",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-14l8 -4v18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 21v-10l-6 -4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 9,
      y2: 9.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 9,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 9,
      y2: 15.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 18,
      x2: 9,
      y2: 18.01
    }));
  }

  function IconBuildingStore(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-store",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 21,
      x2: 5,
      y2: 10.85
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 21,
      x2: 19,
      y2: 10.85
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
    }));
  }

  function IconBuildingWarehouse(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building-warehouse",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-13l9 -4l9 4v13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 13h4v8h-10v-6h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3"
    }));
  }

  function IconBuilding(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-building",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 8,
      x2: 10,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 10,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 10,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 8,
      x2: 15,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 16,
      x2: 15,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
    }));
  }

  function IconBulbOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bulb-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9.7,
      y1: 17,
      x2: 14.3,
      y2: 17
    }));
  }

  function IconBulb(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bulb",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9.7,
      y1: 17,
      x2: 14.3,
      y2: 17
    }));
  }

  function IconBulldozer(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bulldozer",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 13,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 13v6h3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 19,
      x2: 4,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 13,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 15v-2a1 1 0 0 1 1 -1h7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 17,
      x2: 15,
      y2: 17
    }));
  }

  function IconBus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-bus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 5 17.5 12 22 12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 2,
      y1: 10,
      x2: 17,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 5,
      x2: 7,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 10
    }));
  }

  function IconBusinessplan(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-businessplan",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 16,
      cy: 6,
      rx: 5,
      ry: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 15v1m0 -8v1"
    }));
  }

  function IconCalculator(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calculator",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 3,
      width: 16,
      height: 18,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 7,
      width: 8,
      height: 3,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 14,
      x2: 8,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 14,
      x2: 16,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 17,
      x2: 8,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 17,
      x2: 16,
      y2: 17.01
    }));
  }

  function IconCalendarEvent(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar-event",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 5,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 20,
      y2: 11
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 15,
      width: 2,
      height: 2
    }));
  }

  function IconCalendarMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 5,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 20,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 16,
      x2: 14,
      y2: 16
    }));
  }

  function IconCalendarOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.175 -1.823m3.825 -.177h9a2 2 0 0 1 2 2v9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 11h7m4 0h5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 15,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconCalendarPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 5,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 20,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 16,
      x2: 14,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 18
    }));
  }

  function IconCalendarStats(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar-stats",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 14v4h4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 18,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 11h16"
    }));
  }

  function IconCalendarTime(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar-time",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 18,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 11h16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 16.496v1.504l1 1"
    }));
  }

  function IconCalendar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-calendar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 5,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 20,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 15,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 18
    }));
  }

  function IconCameraMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-camera-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 13,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h3m9 6v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 6,
      x2: 21,
      y2: 6
    }));
  }

  function IconCameraOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-camera-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.29 4.296a1 1 0 0 1 .71 -.296h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v8m-1.179 2.824c-.25 .113 -.528 .176 -.821 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1c.292 0 .568 -.062 .818 -.175"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.436 10.44a3 3 0 1 0 4.126 4.122"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconCameraPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-camera-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 13,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h2a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h2m9 7v7a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 6,
      x2: 21,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 3,
      x2: 18,
      y2: 9
    }));
  }

  function IconCameraRotate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-camera-rotate",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.245 15.904a3 3 0 0 0 3.755 -2.904m-2.25 -2.905a3 3 0 0 0 -3.75 2.905"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 13h2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13h-2v-2"
    }));
  }

  function IconCameraSelfie(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-camera-selfie",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15a3.5 3.5 0 0 0 5 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 11,
      x2: 15.01,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 11,
      x2: 9.01,
      y2: 11
    }));
  }

  function IconCamera(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-camera",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 13,
      r: 3
    }));
  }

  function IconCapture(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-capture",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }));
  }

  function IconCar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-car",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
    }));
  }

  function IconCaravan(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-caravan",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 11,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 17,
      x2: 13,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17h-5a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2h10l4 4v8"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 8,
      width: 6,
      height: 4,
      rx: 1
    }));
  }

  function IconCardboards(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cardboards",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8,
      cy: 11,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16,
      cy: 11,
      r: 1
    }));
  }

  function IconCaretDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-caret-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l-6 -6l-6 6h12",
      transform: "rotate(180 12 12)"
    }));
  }

  function IconCaretLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-caret-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l-6 -6l-6 6h12",
      transform: "rotate(270 12 12)"
    }));
  }

  function IconCaretRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-caret-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l-6 -6l-6 6h12",
      transform: "rotate(90 12 12)"
    }));
  }

  function IconCaretUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-caret-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l-6 -6l-6 6h12"
    }));
  }

  function IconCashBanknoteOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cash-banknote-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 12,
      x2: 18.01,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 6.01,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconCashBanknote(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cash-banknote",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 6,
      width: 18,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 12,
      x2: 18.01,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 6.01,
      y2: 12
    }));
  }

  function IconCash(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cash",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 9,
      width: 14,
      height: 10,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
    }));
  }

  function IconCast(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cast",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 19,
      x2: 3.01,
      y2: 19
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 19a4 4 0 0 0 -4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 19a8 8 0 0 0 -8 -8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2"
    }));
  }

  function IconCe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ce",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 4a8 8 0 1 0 0 16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 4a8 8 0 1 0 0 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 20,
      y2: 12
    }));
  }

  function IconCertificate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-certificate",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 15,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 9,
      x2: 18,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 9,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 15,
      x2: 8,
      y2: 15
    }));
  }

  function IconChargingPile(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-charging-pile",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 7,
      x2: 17,
      y2: 8
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 11.5l-1.5 2.5h3l-1.5 2.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 20,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 14,
      y2: 8
    }));
  }

  function IconChartArcs3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-arcs-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12a5 5 0 1 0 5 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.29 18.957a9 9 0 1 0 5.71 -15.957"
    }));
  }

  function IconChartArcs(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-arcs",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.924 11.132a5 5 0 1 0 -4.056 5.792"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12a9 9 0 1 0 9 -9"
    }));
  }

  function IconChartAreaLine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-area-line",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "4 19 8 13 12 15 16 10 20 14 20 19 4 19"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "4 12 7 8 11 10 16 4 20 8"
    }));
  }

  function IconChartArea(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-area",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 20,
      y2: 19
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "4 15 8 9 12 11 16 6 20 10 20 15 4 15"
    }));
  }

  function IconChartArrowsVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-arrows-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 21v-14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 15l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 21v-18"
    }));
  }

  function IconChartArrows(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-arrows",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 18,
      x2: 17,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 9l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 3,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 3l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 6,
      x2: 21,
      y2: 6
    }));
  }

  function IconChartBar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-bar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 12,
      width: 6,
      height: 8,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 8,
      width: 6,
      height: 12,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 15,
      y: 4,
      width: 6,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 18,
      y2: 20
    }));
  }

  function IconChartBubble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-bubble",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 16,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 7.5,
      r: 4.5
    }));
  }

  function IconChartCandle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-candle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 6,
      width: 4,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 4,
      x2: 6,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 11,
      x2: 6,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 14,
      width: 4,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 16,
      y: 5,
      width: 4,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 4,
      x2: 18,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 11,
      x2: 18,
      y2: 20
    }));
  }

  function IconChartCircles(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-circles",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 9.5,
      r: 5.5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 14.5,
      r: 5.5
    }));
  }

  function IconChartDonut2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-donut-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v5m4 4h5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconChartDonut3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-donut-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v5m4 4h5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.929 14.582l-3.429 2.918"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconChartDonut4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-donut-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.848 14.667l-3.348 2.833"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v5m4 4h5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.219 15.328l2.781 4.172"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }));
  }

  function IconChartDonut(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-donut",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a0.9 .9 0 0 0 -1 -.8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"
    }));
  }

  function IconChartDots(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-dots",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3v18h18"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 9,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 7,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 15,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10.16,
      y1: 10.62,
      x2: 12.5,
      y2: 13.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.088 13.328l2.837 -4.586"
    }));
  }

  function IconChartInfographic(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-infographic",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3v4h4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 17,
      x2: 9,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 14,
      x2: 17,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 13,
      x2: 13,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 12,
      x2: 21,
      y2: 21
    }));
  }

  function IconChartLine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-line",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 20,
      y2: 19
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "4 15 8 9 12 11 16 6 20 10"
    }));
  }

  function IconChartPie2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-pie-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v9h9"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconChartPie3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-pie-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l-6.5 5.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v9h9"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconChartPie4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-pie-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l-6.5 5.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v9h9"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l5 7.5"
    }));
  }

  function IconChartPie(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-pie",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a0.9 .9 0 0 0 -1 -.8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
    }));
  }

  function IconChartRadar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chart-radar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2.5 10l9.5 3l9.5 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v10l6 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 21l6 -8"
    }));
  }

  function IconCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12l5 5l10 -10"
    }));
  }

  function IconCheckbox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-checkbox",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 11 12 14 20 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"
    }));
  }

  function IconChecks(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-checks",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12l5 5l10 -10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 12l5 5m5 -5l5 -5"
    }));
  }

  function IconChevronDownLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-down-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8v8h8"
    }));
  }

  function IconChevronDownRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-down-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8v8h-8"
    }));
  }

  function IconChevronDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "6 9 12 15 18 9"
    }));
  }

  function IconChevronLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 6 9 12 15 18"
    }));
  }

  function IconChevronRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 6 15 12 9 18"
    }));
  }

  function IconChevronUpLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-up-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16v-8h8"
    }));
  }

  function IconChevronUpRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-up-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8h8v8"
    }));
  }

  function IconChevronUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevron-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "6 15 12 9 18 15"
    }));
  }

  function IconChevronsDownLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-down-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 5v8h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9v8h8"
    }));
  }

  function IconChevronsDownRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-down-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 5v8h-8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 9v8h-8"
    }));
  }

  function IconChevronsDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 7 12 12 17 7"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 13 12 18 17 13"
    }));
  }

  function IconChevronsLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "11 7 6 12 11 17"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "17 7 12 12 17 17"
    }));
  }

  function IconChevronsRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 7 12 12 7 17"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "13 7 18 12 13 17"
    }));
  }

  function IconChevronsUpLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-up-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 15v-8h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 19v-8h8"
    }));
  }

  function IconChevronsUpRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-up-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 7h8v8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 11h8v8"
    }));
  }

  function IconChevronsUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-chevrons-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 11 12 6 17 11"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 17 12 12 17 17"
    }));
  }

  function IconChristmasTree(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-christmas-tree",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3l4 4l-2 1l4 4l-3 1l4 4h-14l4 -4l-3 -1l4 -4l-2 -1z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
    }));
  }

  function IconCircle0(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-0",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 16v-8l-2 2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 -.001"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a2 2 0 1 0 -2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a2 2 0 1 0 2 -2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 16v-8l-4 6h5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle6(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-6",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10a2 2 0 1 0 -4 0v4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle7(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-7",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 8h4l-2 8"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle8(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-8",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircle9(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-9",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a2 2 0 1 0 4 0v-4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircleCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12l2 2l4 -4"
    }));
  }

  function IconCircleDashed(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-dashed",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
    }));
  }

  function IconCircleDotted(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-dotted",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.5,
      y1: 4.21,
      x2: 7.5,
      y2: 4.22
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.21,
      y1: 7.5,
      x2: 4.21,
      y2: 7.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 3,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.21,
      y1: 16.5,
      x2: 4.21,
      y2: 16.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.5,
      y1: 19.79,
      x2: 7.5,
      y2: 19.8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 21.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.5,
      y1: 19.79,
      x2: 16.5,
      y2: 19.8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.79,
      y1: 16.5,
      x2: 19.79,
      y2: 16.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 12,
      x2: 21,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.79,
      y1: 7.5,
      x2: 19.79,
      y2: 7.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.5,
      y1: 4.21,
      x2: 16.5,
      y2: 4.22
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 3.01
    }));
  }

  function IconCircleHalfVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-half-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h18"
    }));
  }

  function IconCircleHalf(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-half",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v18"
    }));
  }

  function IconCircleMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }));
  }

  function IconCircleOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconCirclePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 15
    }));
  }

  function IconCircleSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 9.5,
      r: 6.5
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 10,
      width: 11,
      height: 11,
      rx: 2
    }));
  }

  function IconCircleX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l4 4m0 -4l-4 4"
    }));
  }

  function IconCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconCircles(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-circles",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6.5,
      cy: 17,
      r: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17.5,
      cy: 17,
      r: 4
    }));
  }

  function IconClearAll(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clear-all",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 6h12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12h12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18h12"
    }));
  }

  function IconClearFormatting(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clear-formatting",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 15l4 4m0 -4l-4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 6v-1h11v1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 19,
      x2: 11,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 5,
      x2: 9,
      y2: 19
    }));
  }

  function IconClick(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-click",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 6,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.8,
      y1: 7.8,
      x2: 5.6,
      y2: 5.6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.2,
      y1: 7.8,
      x2: 18.4,
      y2: 5.6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.8,
      y1: 16.2,
      x2: 5.6,
      y2: 18.4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l9 3l-4 2l-2 4l-3 -9"
    }));
  }

  function IconClipboardCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clipboard-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 14l2 2l4 -4"
    }));
  }

  function IconClipboardList(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clipboard-list",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 9.01,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 9.01,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 16,
      x2: 15,
      y2: 16
    }));
  }

  function IconClipboardX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clipboard-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12l4 4m0 -4l-4 4"
    }));
  }

  function IconClipboard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clipboard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }));
  }

  function IconClock(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-clock",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 7 12 12 15 15"
    }));
  }

  function IconCloudDownload(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-download",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 13,
      x2: 12,
      y2: 22
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 19 12 22 15 19"
    }));
  }

  function IconCloudFog(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-fog",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 20,
      x2: 19,
      y2: 20
    }));
  }

  function IconCloudOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 18h-11c-2.598 0 -4.705 -2.015 -4.705 -4.5s2.107 -4.5 4.705 -4.5c.112 -.5 .305 -.973 .568 -1.408m2.094 -1.948c.329 -.174 .68 -.319 1.05 -.43c1.9 -.576 3.997 -.194 5.5 1c1.503 1.192 2.185 3.017 1.788 4.786h1a3.5 3.5 0 0 1 2.212 6.212"
    }));
  }

  function IconCloudRain(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-rain",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 13v2m0 3v2m4 -5v2m0 3v2"
    }));
  }

  function IconCloudSnow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-snow",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 15v.01m0 3v.01m0 3v.01m4 -4v.01m0 3v.01"
    }));
  }

  function IconCloudStorm(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-storm",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "13 14 11 18 14 18 12 22"
    }));
  }

  function IconCloudUpload(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud-upload",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 15 12 12 15 15"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 21
    }));
  }

  function IconCloud(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cloud",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
    }));
  }

  function IconCodeMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-code-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
    }));
  }

  function IconCodePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-code-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9v6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
    }));
  }

  function IconCode(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-code",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 8 3 12 7 16"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "17 8 21 12 17 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 4,
      x2: 10,
      y2: 20
    }));
  }

  function IconCoin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-coin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v2m0 8v2"
    }));
  }

  function IconColorPicker(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-color-picker",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 7l6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
    }));
  }

  function IconColorSwatch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-color-swatch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 3h-4a2 2 0 0 0 -2 2v12a4 4 0 0 0 8 0v-12a2 2 0 0 0 -2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 7.35l-2 -2a2 2 0 0 0 -2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l9 9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 17,
      x2: 17,
      y2: 17.01
    }));
  }

  function IconColumnInsertLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-column-insert-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 9,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 10,
      x2: 7,
      y2: 14
    }));
  }

  function IconColumnInsertRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-column-insert-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 12,
      x2: 19,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 10,
      x2: 17,
      y2: 14
    }));
  }

  function IconColumns(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-columns",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 9.5,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 10,
      x2: 9.5,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 14,
      x2: 9.5,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 9.5,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 10,
      x2: 20,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 14,
      x2: 20,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 18,
      x2: 20,
      y2: 18
    }));
  }

  function IconComet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-comet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 11,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 4,
      x2: 12.5,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 9,
      x2: 7.5,
      y2: 12.5
    }));
  }

  function IconCommand(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-command",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10"
    }));
  }

  function IconCompass(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-compass",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 16 10 10 16 8 14 14 8 16"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 5,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 12,
      x2: 21,
      y2: 12
    }));
  }

  function IconConfetti(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-confetti",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 5h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 4l-.5 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 5h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 9l-1 1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 13l2 -.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 18v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39z"
    }));
  }

  function IconContainer(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-container",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 8v.01"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 4,
      width: 8,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v.01"
    }));
  }

  function IconContrast(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-contrast",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17a5 5 0 0 0 0 -10v10"
    }));
  }

  function IconCopy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-copy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 8,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }));
  }

  function IconCopyleft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-copyleft",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 9a3.5 4 0 1 1 0 6"
    }));
  }

  function IconCopyright(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-copyright",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.5 9a3.5 4 0 1 0 0 6"
    }));
  }

  function IconCornerDownLeftDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-down-left-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 5v6a3 3 0 0 1 -3 3h-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 10l-4 4l4 4m-5 -8l-4 4l4 4"
    }));
  }

  function IconCornerDownLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-down-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4"
    }));
  }

  function IconCornerDownRightDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-down-right-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 5v6a3 3 0 0 0 3 3h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l4 4l-4 4m5 -8l4 4l-4 4"
    }));
  }

  function IconCornerDownRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-down-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4"
    }));
  }

  function IconCornerLeftDownDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-left-down-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 4h-6a3 3 0 0 0 -3 3v7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4"
    }));
  }

  function IconCornerLeftDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-left-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4"
    }));
  }

  function IconCornerLeftUpDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-left-up-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19h-6a3 3 0 0 1 -3 -3v-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4"
    }));
  }

  function IconCornerLeftUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-left-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4"
    }));
  }

  function IconCornerRightDownDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-right-down-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h6a3 3 0 0 1 3 3v7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l4 4l4 -4m-8 5l4 4l4 -4"
    }));
  }

  function IconCornerRightDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-right-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4"
    }));
  }

  function IconCornerRightUpDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-right-up-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h6a3 3 0 0 0 3 -3v-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13l4 -4l4 4m-8 -5l4 -4l4 4"
    }));
  }

  function IconCornerRightUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-right-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4"
    }));
  }

  function IconCornerUpLeftDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-up-left-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 18v-6a3 3 0 0 0 -3 -3h-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4"
    }));
  }

  function IconCornerUpLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-up-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4"
    }));
  }

  function IconCornerUpRightDouble(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-up-right-double",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18v-6a3 3 0 0 1 3 -3h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4"
    }));
  }

  function IconCornerUpRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-corner-up-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4"
    }));
  }

  function IconCreditCardOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-credit-card-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 11,
      x2: 11,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 11,
      x2: 21,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 15,
      x2: 7.01,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 15,
      x2: 13,
      y2: 15
    }));
  }

  function IconCreditCard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-credit-card",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 10,
      x2: 21,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 15,
      x2: 7.01,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 15,
      x2: 13,
      y2: 15
    }));
  }

  function IconCrop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-crop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 5v10a1 1 0 0 0 1 1h10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 8h10a1 1 0 0 1 1 1v10"
    }));
  }

  function IconCrosshair(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-crosshair",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 15
    }));
  }

  function IconCrownOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-crown-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 18h-13l-1.865 -9.327a0.25 .25 0 0 1 .4 -.244l4.465 3.571l1.6 -2.4m1.596 -2.394l.804 -1.206l4 6l4.464 -3.571a0.25 .25 0 0 1 .401 .244l-1.363 6.818"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconCrown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-crown",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z"
    }));
  }

  function IconCurlyLoop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-curly-loop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5"
    }));
  }

  function IconCurrencyBahraini(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-bahraini",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 19.01v-.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15.01v-.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 15h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
    }));
  }

  function IconCurrencyBath(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-bath",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 6h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18v2"
    }));
  }

  function IconCurrencyBitcoin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-bitcoin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6h8a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 6,
      x2: 8,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 14,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 3,
      x2: 9,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 3,
      x2: 13,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 18,
      x2: 9,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 18,
      x2: 13,
      y2: 21
    }));
  }

  function IconCurrencyCent(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-cent",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a5.996 5.996 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4.004 -1.536"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 20v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v-2"
    }));
  }

  function IconCurrencyDinar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-dinar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 20.01v-.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 13l2.386 -.9a1 1 0 0 0 -.095 -1.902l-1.514 -.404a1 1 0 0 1 -.102 -1.9l2.325 -.894"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 14v1a3 3 0 0 0 3 3h4.161a3 3 0 0 0 2.983 -3.32l-1.144 -10.68"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 17l1 1h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
    }));
  }

  function IconCurrencyDirham(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-dirham",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.5 19h-3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 13.01v-.01"
    }));
  }

  function IconCurrencyDollarAustralian(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-dollar-australian",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18l3.279 -11.476a0.75 .75 0 0 1 1.442 0l3.279 11.476"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 20v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 14h5"
    }));
  }

  function IconCurrencyDollarCanadian(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-dollar-canadian",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 18h-1a6 6 0 1 1 0 -12h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 20v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6v-2"
    }));
  }

  function IconCurrencyDollarSingapore(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-dollar-singapore",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6h-4a3 3 0 1 0 0 6h1a3 3 0 0 1 0 6h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 20v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6v-2"
    }));
  }

  function IconCurrencyDollar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-dollar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v3m0 12v3"
    }));
  }

  function IconCurrencyEthereum(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-ethereum",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12l6 -9l6 9l-6 9z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12l6 -3l6 3l-6 2z"
    }));
  }

  function IconCurrencyEuro(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-euro",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.2 7a6 7 0 1 0 0 10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 10h-8m0 4h8"
    }));
  }

  function IconCurrencyForint(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-forint",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 4h-4a3 3 0 0 0 -3 3v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 11h-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4v13a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 9h-5"
    }));
  }

  function IconCurrencyFrank(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-frank",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 5h-6a2 2 0 0 0 -2 2v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 15h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 11h7"
    }));
  }

  function IconCurrencyKroneCzech(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-krone-czech",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12c3.5 0 6 -3 6 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12c3.5 0 6 3 6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 6l-2 2l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 12h-2a3 3 0 0 0 0 6h2"
    }));
  }

  function IconCurrencyKroneDanish(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-krone-danish",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12c3.5 0 6 -3 6 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12c3.5 0 6 3 6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10v8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 10a4 4 0 0 0 -4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 18.01v-.01"
    }));
  }

  function IconCurrencyKroneSwedish(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-krone-swedish",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12c3.5 0 6 -3 6 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12c3.5 0 6 3 6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10v8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 10a4 4 0 0 0 -4 4"
    }));
  }

  function IconCurrencyLeu(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-leu",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 18h-7a3 3 0 0 1 -3 -3v-10"
    }));
  }

  function IconCurrencyLira(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-lira",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5v15a7 7 0 0 0 7 -7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15l8 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 7l-8 4"
    }));
  }

  function IconCurrencyLitecoin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-litecoin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 9l-9 4"
    }));
  }

  function IconCurrencyNaira(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-naira",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 10h14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 14h14"
    }));
  }

  function IconCurrencyPound(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-pound",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7"
    }));
  }

  function IconCurrencyReal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-real",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 20v-2"
    }));
  }

  function IconCurrencyRenminbi(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-renminbi",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 9v8a2 2 0 1 0 4 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 9h-14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 5h-14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 9v4c0 2.5 -.667 4 -2 6"
    }));
  }

  function IconCurrencyRipple(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-ripple",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 7,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12h3l2 -2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 14.5l-2 -2.5"
    }));
  }

  function IconCurrencyRiyal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-riyal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 9v2a2 2 0 1 1 -4 0v-1v1a2 2 0 1 1 -4 0v-1v4a2 2 0 1 1 -4 0v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 12.01v-.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 10v1a5 5 0 0 1 -5 5"
    }));
  }

  function IconCurrencyRubel(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-rubel",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 19v-14h6a3 3 0 0 1 0 6h-8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15h-8"
    }));
  }

  function IconCurrencyRupee(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-rupee",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 9,
      x2: 18,
      y2: 9
    }));
  }

  function IconCurrencyShekel(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-shekel",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 18v-12h4a4 4 0 0 1 4 4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 6v12h-4a4 4 0 0 1 -4 -4v-4"
    }));
  }

  function IconCurrencyTaka(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-taka",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16.5,
      cy: 15.5,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11h6"
    }));
  }

  function IconCurrencyTugrik(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-tugrik",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 6h10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 17l8 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 10l-8 3"
    }));
  }

  function IconCurrencyWon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-won",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6l3.245 11.358a0.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a0.85 .85 0 0 0 1.624 -.035l3.245 -11.358"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 10h-18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 14h-18"
    }));
  }

  function IconCurrencyYen(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-yen",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 19v-7l-5 -7m10 0l-5 7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 17,
      x2: 16,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 13,
      x2: 16,
      y2: 13
    }));
  }

  function IconCurrencyZloty(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-currency-zloty",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18h-7l7 -7h-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 18v-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 14.5l6 -3.5"
    }));
  }

  function IconCurrentLocation(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-current-location",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 2,
      x2: 12,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 22
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 22,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 2,
      y1: 12,
      x2: 4,
      y2: 12
    }));
  }

  function IconCursorText(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cursor-text",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3"
    }));
  }

  function IconCut(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-cut",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9.15,
      y1: 14.85,
      x2: 18,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 4,
      x2: 14.85,
      y2: 14.85
    }));
  }

  function IconDashboard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dashboard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 13,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13.45,
      y1: 11.55,
      x2: 15.5,
      y2: 9.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.4 20a9 9 0 1 1 11.2 0z"
    }));
  }

  function IconDatabaseExport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-database-export",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 12,
      cy: 6,
      rx: 8,
      ry: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v6c0 1.657 3.582 3 8 3a19.84 19.84 0 0 0 3.302 -.267m4.698 -2.733v-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v6c0 1.599 3.335 2.905 7.538 2.995m8.462 -6.995v-2m-6 7h7m-3 -3l3 3l-3 3"
    }));
  }

  function IconDatabaseImport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-database-import",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 12,
      cy: 6,
      rx: 8,
      ry: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v8m5.009 .783c.924 .14 1.933 .217 2.991 .217c4.418 0 8 -1.343 8 -3v-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.252 20.987c.246 .009 .496 .013 .748 .013c4.418 0 8 -1.343 8 -3v-6m-18 7h7m-3 -3l3 3l-3 3"
    }));
  }

  function IconDatabaseOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-database-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconDatabase(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-database",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 12,
      cy: 6,
      rx: 8,
      ry: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v6a8 3 0 0 0 16 0v-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v6a8 3 0 0 0 16 0v-6"
    }));
  }

  function IconDetails(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-details",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v16"
    }));
  }

  function IconDeviceAnalytics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-analytics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 12,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 9,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12l3 -3l2 2l3 -3"
    }));
  }

  function IconDeviceAudioTape(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-audio-tape",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17l4 -3h10l4 3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7.5,
      cy: 9.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16.5,
      cy: 9.5,
      r: 0.5,
      fill: "currentColor"
    }));
  }

  function IconDeviceCctv(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-cctv",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 3,
      width: 18,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 7v7a7 7 0 0 1 -14 0v-7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12.01,
      y2: 14
    }));
  }

  function IconDeviceComputerCameraOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-computer-camera-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.15 6.153a7 7 0 0 0 9.696 9.696m2.003 -2.001a7 7 0 0 0 -9.699 -9.695"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.13 9.122a3 3 0 0 0 3.743 3.749m2.001 -2.009a3 3 0 0 0 -3.737 -3.736"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconDeviceComputerCamera(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-computer-camera",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 7
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
    }));
  }

  function IconDeviceDesktopAnalytics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-desktop-analytics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 12,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20h10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 16v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 16v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 12v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v-1"
    }));
  }

  function IconDeviceDesktopOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-desktop-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h12a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1m-4 0h-12a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 9,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconDeviceDesktop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-desktop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 12,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 9,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 15,
      y2: 20
    }));
  }

  function IconDeviceFloppy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-floppy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "14 4 14 8 8 8 8 4"
    }));
  }

  function IconDeviceGamepad(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-gamepad",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 6,
      width: 20,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12h4m-2 -2v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 11,
      x2: 15,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 13,
      x2: 18,
      y2: 13.01
    }));
  }

  function IconDeviceLaptop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-laptop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 19,
      x2: 21,
      y2: 19
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 6,
      width: 14,
      height: 10,
      rx: 1
    }));
  }

  function IconDeviceMobileMessage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-mobile-message",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 3h10v8h-3l-4 2v-2h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 18v.01"
    }));
  }

  function IconDeviceMobileRotated(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-mobile-rotated",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("g", {
      transform: "rotate(90 12 12)"
    }, /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 4,
      width: 10,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 5,
      x2: 13,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 17.01
    })));
  }

  function IconDeviceMobileVibration(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-mobile-vibration",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 10,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 5,
      x2: 10,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 17,
      x2: 9,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6l-2 3l2 3l-2 3l2 3"
    }));
  }

  function IconDeviceMobile(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-mobile",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 4,
      width: 10,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 5,
      x2: 13,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 17.01
    }));
  }

  function IconDeviceSpeaker(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-speaker",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 3,
      width: 14,
      height: 18,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 7.01
    }));
  }

  function IconDeviceTablet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-tablet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 3,
      width: 14,
      height: 18,
      rx: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 17,
      r: 1
    }));
  }

  function IconDeviceTv(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-tv",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 7,
      width: 18,
      height: 13,
      rx: 2
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 3 12 7 8 3"
    }));
  }

  function IconDeviceWatch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-device-watch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 6,
      width: 12,
      height: 12,
      rx: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18v3h6v-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 6v-3h6v3"
    }));
  }

  function IconDevices2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-devices-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 13,
      y: 4,
      width: 8,
      height: 16,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 19,
      x2: 10,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 8,
      x2: 17,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 16,
      r: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 9,
      y2: 19
    }));
  }

  function IconDevicesPc(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-devices-pc",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 5h6v14h-6z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9h10v7h-10z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 19h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 16v3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 13v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 16v.01"
    }));
  }

  function IconDevices(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-devices",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 13,
      y: 8,
      width: 8,
      height: 12,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 9,
      x2: 18,
      y2: 9
    }));
  }

  function IconDiamond(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-diamond",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 5h12l3 5l-8.5 9.5a0.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12l-2 -2.2l.6 -1"
    }));
  }

  function IconDice(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dice",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8.5,
      cy: 8.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15.5,
      cy: 8.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15.5,
      cy: 15.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8.5,
      cy: 15.5,
      r: 0.5,
      fill: "currentColor"
    }));
  }

  function IconDimensions(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dimensions",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 5h11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7l2 -2l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 3l-2 2l2 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 10v11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 19l2 2l2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12l-2 -2l-2 2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 10,
      width: 11,
      height: 11,
      rx: 2
    }));
  }

  function IconDirectionHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-direction-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 9l-3 3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 9l3 3l-3 3"
    }));
  }

  function IconDirection(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-direction",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 10l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 14l3 3l3 -3"
    }));
  }

  function IconDirections(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-directions",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h10l2 2l-2 2h-10a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 13h-7l-2 2l2 2h7a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 22,
      x2: 12,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 13,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 3
    }));
  }

  function IconDisabled2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-disabled-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 11a5 5 0 1 0 3.95 7.95"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1"
    }));
  }

  function IconDisabled(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-disabled",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 11,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "11 7 11 15 15 15 19 20"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 11,
      x2: 16,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 11.5a5 5 0 1 0 6 7.5"
    }));
  }

  function IconDisc(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-disc",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12a5 5 0 0 1 5 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17a5 5 0 0 0 5 -5"
    }));
  }

  function IconDiscount2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-discount-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 15,
      y2: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 9.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 14.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }));
  }

  function IconDiscount(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-discount",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 15,
      y2: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 9.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 14.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconDivide(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-divide",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      fill: "currentColor",
      cx: 12,
      cy: 6,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      fill: "currentColor",
      cx: 12,
      cy: 18,
      r: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }));
  }

  function IconDna(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dna",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      transform: "rotate(-45 12 12)",
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.828 3.515a4 4 0 1 0 5.657 5.657"
    }));
  }

  function IconDotsCircleHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dots-circle-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }));
  }

  function IconDotsDiagonal2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dots-diagonal-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 7,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 1
    }));
  }

  function IconDotsDiagonal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dots-diagonal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 7,
      r: 1
    }));
  }

  function IconDotsVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dots-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 1
    }));
  }

  function IconDots(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-dots",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 12,
      r: 1
    }));
  }

  function IconDownload(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-download",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 11 12 16 17 11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 16
    }));
  }

  function IconDragDrop2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-drag-drop-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 8,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 4.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 4,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 4,
      y2: 16.01
    }));
  }

  function IconDragDrop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-drag-drop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 13l9 3l-4 2l-2 4l-3 -9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 3,
      y2: 3.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 3,
      x2: 7,
      y2: 3.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 3,
      x2: 11,
      y2: 3.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 3,
      x2: 15,
      y2: 3.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 7,
      x2: 3,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 11,
      x2: 3,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 15,
      x2: 3,
      y2: 15.01
    }));
  }

  function IconDroneOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-drone-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 14h-4v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l-3.5 -3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.957 5.95a3.503 3.503 0 0 0 -2.917 -2.91m-3.02 .989a3.5 3.5 0 0 0 1.98 5.936"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10l3.5 -3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9.965a3.5 3.5 0 1 0 -3.966 -3.965"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 17.5,
      y2: 17.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.035 18a3.5 3.5 0 0 0 5.936 1.98m.987 -3.026a3.503 3.503 0 0 0 -2.918 -2.913"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 6.5,
      y2: 17.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 14.035a3.5 3.5 0 1 0 3.966 3.965"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconDrone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-drone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10h4v4h-4z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 6.5,
      y2: 6.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10l3.5 -3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 17.5,
      y2: 17.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 6.5,
      y2: 17.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
    }));
  }

  function IconDropletFilled2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-droplet-filled-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 14h12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.305 17.695l3.695 -3.695"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.26 19.74l5.74 -5.74l-5.74 5.74z"
    }));
  }

  function IconDropletFilled(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-droplet-filled",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v17"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l3.544 -3.544"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17.3l5.558 -5.558"
    }));
  }

  function IconDropletHalf2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-droplet-half-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 14h12"
    }));
  }

  function IconDropletHalf(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-droplet-half",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v17"
    }));
  }

  function IconDropletOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-droplet-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.454 8.458l-1.653 2.545a6 6 0 0 0 10.32 6.123"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 14a5.971 5.971 0 0 0 -.803 -3l-5.197 -8l-1.968 3.03"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconDroplet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-droplet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }));
  }

  function IconEarOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ear-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10c0 -1.146 .277 -2.245 .78 -3.219m1.792 -2.208a7 7 0 0 1 10.428 9.027a10 10 0 0 1 -.633 .762m-2.045 1.96a8 8 0 0 0 -1.322 2.278a4.5 4.5 0 0 1 -6.8 1.4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.42 7.414a3 3 0 0 1 4.131 4.13"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconEar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ear",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10a3 3 0 1 1 5 2.2"
    }));
  }

  function IconEditCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-edit-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 5l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 7.07a7.002 7.002 0 0 0 1 13.93a7.002 7.002 0 0 0 6.929 -5.999"
    }));
  }

  function IconEdit(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-edit",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 5,
      x2: 19,
      y2: 8
    }));
  }

  function IconEgg(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-egg",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.514 14.639c0 3.513 2.904 6.361 6.486 6.361s6.486 -2.848 6.486 -6.361a12.574 12.574 0 0 0 -3.243 -9.012a4.025 4.025 0 0 0 -3.243 -1.627a4.025 4.025 0 0 0 -3.243 1.627a12.574 12.574 0 0 0 -3.243 9.012"
    }));
  }

  function IconEmphasis(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-emphasis",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 5h-8v10h8m-1 -5h-7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 20,
      x2: 6,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 20,
      x2: 10,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 20,
      x2: 14,
      y2: 20.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 20,
      x2: 18,
      y2: 20.01
    }));
  }

  function IconEqualNot(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-equal-not",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 9h14m-14 6h14m0 -10l-14 14"
    }));
  }

  function IconEqual(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-equal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 9h14m-14 6h14"
    }));
  }

  function IconEraser(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-eraser",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 19h-11l-4 -4a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9 9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 12.3,
      x2: 11.7,
      y2: 6
    }));
  }

  function IconExchange(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-exchange",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"
    }));
  }

  function IconExposure(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-exposure",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.6,
      y1: 19.4,
      x2: 19.4,
      y2: 4.6
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9h4m-2 -2v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 16,
      x2: 17,
      y2: 16
    }));
  }

  function IconExternalLink(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-external-link",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 4 20 4 20 9"
    }));
  }

  function IconEyeCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-eye-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 19c-4 0 -7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7c-.42 .736 -.858 1.414 -1.311 2.033"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 19l2 2l4 -4"
    }));
  }

  function IconEyeOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-eye-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.584 10.587a2 2 0 0 0 2.828 2.83"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"
    }));
  }

  function IconEye(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-eye",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"
    }));
  }

  function IconEyeglass2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-eyeglass-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h-2l-3 10v2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2l3 10v2.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 16,
      x2: 14,
      y2: 16
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17.5,
      cy: 16.5,
      r: 3.5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6.5,
      cy: 16.5,
      r: 3.5
    }));
  }

  function IconEyeglass(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-eyeglass",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h-2l-3 10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2l3 10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 16,
      x2: 14,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }));
  }

  function IconFaceId(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-face-id",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15a3.5 3.5 0 0 0 5 0"
    }));
  }

  function IconFall(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-fall",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 21l1 -5l-1 -4l-3 -4h4l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 16l-1 -4l3 -4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.5 12h2.5l4 2"
    }));
  }

  function IconFeather(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-feather",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4"
    }));
  }

  function IconFileAlert(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-alert",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12.01,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 11,
      x2: 12,
      y2: 14
    }));
  }

  function IconFileAnalytics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-analytics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 17,
      x2: 9,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 17,
      x2: 15,
      y2: 14
    }));
  }

  function IconFileCertificate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-certificate",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 14,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5"
    }));
  }

  function IconFileCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 15l2 2l4 -4"
    }));
  }

  function IconFileCode2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-code-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12h-1v5h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 12h1v5h-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }));
  }

  function IconFileCode(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-code",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13l-1 2l1 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 13l1 2l-1 2"
    }));
  }

  function IconFileDiff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-diff",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 12,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 14,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 17,
      x2: 14,
      y2: 17
    }));
  }

  function IconFileDislike(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-dislike",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 14,
      width: 3,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5"
    }));
  }

  function IconFileDownload(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-download",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 11,
      x2: 12,
      y2: 17
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 14 12 17 15 14"
    }));
  }

  function IconFileExport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-export",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"
    }));
  }

  function IconFileHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 5v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
    }));
  }

  function IconFileImport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-import",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3"
    }));
  }

  function IconFileInfo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-info",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 14h1v4h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11h.01"
    }));
  }

  function IconFileInvoice(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-invoice",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 7,
      x2: 10,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 13,
      x2: 15,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 17,
      x2: 15,
      y2: 17
    }));
  }

  function IconFileLike(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-like",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 16,
      width: 3,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3"
    }));
  }

  function IconFileMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 14,
      x2: 15,
      y2: 14
    }));
  }

  function IconFileMusic(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-music",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 11,
      cy: 16,
      r: 1
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 16 12 11 14 12"
    }));
  }

  function IconFileOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
    }));
  }

  function IconFilePhone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-phone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
    }));
  }

  function IconFilePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 11,
      x2: 12,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 14,
      x2: 15,
      y2: 14
    }));
  }

  function IconFileReport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-report",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 13v4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2m0 3v4"
    }));
  }

  function IconFileSearch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-search",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4.5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16.5,
      cy: 17.5,
      r: 2.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18.5,
      y1: 19.5,
      x2: 21,
      y2: 22
    }));
  }

  function IconFileShredder(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-shredder",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 16,
      x2: 6,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 16,
      x2: 10,
      y2: 22
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 16,
      x2: 14,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 16,
      x2: 18,
      y2: 20
    }));
  }

  function IconFileSymlink(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-symlink",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-4a3 3 0 0 1 3 -3h5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17l3 -3l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5"
    }));
  }

  function IconFileText(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-text",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 10,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 13,
      x2: 15,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 17,
      x2: 15,
      y2: 17
    }));
  }

  function IconFileUpload(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-upload",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 11,
      x2: 12,
      y2: 17
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 14 12 11 15 14"
    }));
  }

  function IconFileX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12l4 4m0 -4l-4 4"
    }));
  }

  function IconFileZip(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file-zip",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 5,
      x2: 10,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 7,
      x2: 12,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 9,
      x2: 10,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 11,
      x2: 12,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 13,
      x2: 10,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 15,
      x2: 12,
      y2: 15
    }));
  }

  function IconFile(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-file",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }));
  }

  function IconFilesOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-files-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconFiles(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-files",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconFilterOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-filter-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h9.5a1 1 0 0 1 .5 1.5l-4.049 4.454m-.951 3.046v5l-4 -3v-4l-5 -5.5a1 1 0 0 1 .18 -1.316"
    }));
  }

  function IconFilter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-filter",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"
    }));
  }

  function IconFingerprint(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-fingerprint",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11v2a14 14 0 0 0 2.5 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 15a18 18 0 0 0 1.8 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95"
    }));
  }

  function IconFiretruck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-firetruck",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18v-11h3"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 17 3 12 12 12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 9,
      x2: 21,
      y2: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 6,
      y2: 8
    }));
  }

  function IconFlag2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flag-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 14h14v-9h-14v16"
    }));
  }

  function IconFlag3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flag-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16"
    }));
  }

  function IconFlag(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flag",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 5,
      x2: 5,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 5,
      x2: 19,
      y2: 14
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 14a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
    }));
  }

  function IconFlame(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flame",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z"
    }));
  }

  function IconFlare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flare",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h4m5 -9v4m5 5h4m-9 5v4m-4.5 -13.5l1 1m8 -1l-1 1m0 7l1 1m-8 -1l-1 1"
    }));
  }

  function IconFlask(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flask",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 3,
      x2: 15,
      y2: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 9,
      x2: 14,
      y2: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 3v6l-4 11a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-4 -11v-6"
    }));
  }

  function IconFlipHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flip-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 16 17 16 7 21 7 16"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 8 17 8 7 3 7 8"
    }));
  }

  function IconFlipVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-flip-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 7 16 17 21 17 16 7"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 7 8 17 3 17 8 7"
    }));
  }

  function IconFloatCenter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-float-center",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      width: 6,
      height: 6,
      x: 9,
      y: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 7,
      x2: 5,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 5,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 11,
      x2: 20,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 20,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 20,
      y2: 19
    }));
  }

  function IconFloatLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-float-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      width: 6,
      height: 6,
      x: 4,
      y: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 11,
      x2: 20,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 20,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 20,
      y2: 19
    }));
  }

  function IconFloatNone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-float-none",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      width: 6,
      height: 6,
      x: 4,
      y: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 20,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 20,
      y2: 19
    }));
  }

  function IconFloatRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-float-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      width: 6,
      height: 6,
      x: 14,
      y: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 7,
      x2: 10,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 10,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 20,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 19,
      x2: 20,
      y2: 19
    }));
  }

  function IconFocus2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-focus-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 5,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 12,
      x2: 21,
      y2: 12
    }));
  }

  function IconFocus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-focus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconFoldDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-fold-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11v8l3 -3m-6 0l3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 7,
      x2: 10,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 7,
      x2: 15,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 7,
      x2: 5,
      y2: 7
    }));
  }

  function IconFoldUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-fold-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 13v-8l-3 3m6 0l-3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 17,
      x2: 10,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 17,
      x2: 15,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 17,
      x2: 20,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 17,
      x2: 5,
      y2: 17
    }));
  }

  function IconFold(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-fold",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v6l3 -3m-6 0l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21v-6l3 3m-6 0l3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 5,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 10,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 12,
      x2: 20,
      y2: 12
    }));
  }

  function IconFolderMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-folder-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 13,
      x2: 15,
      y2: 13
    }));
  }

  function IconFolderOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-folder-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 19h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.172 -1.821m3.828 -.179h1l3 3h7a2 2 0 0 1 2 2v8"
    }));
  }

  function IconFolderPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-folder-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10,
      x2: 12,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 13,
      x2: 15,
      y2: 13
    }));
  }

  function IconFolderX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-folder-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 11l4 4m0 -4l-4 4"
    }));
  }

  function IconFolder(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-folder",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
    }));
  }

  function IconFolders(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-folders",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconForbid2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-forbid-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 15,
      y2: 9
    }));
  }

  function IconForbid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-forbid",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 15,
      y2: 15
    }));
  }

  function IconForklift(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-forklift",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 17,
      x2: 12,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17v-6h13v6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 11v-4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 11v-6h4l3 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 15h-3v-10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 13,
      x2: 19,
      y2: 13
    }));
  }

  function IconForms(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-forms",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 12h.01"
    }));
  }

  function IconFrame(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-frame",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 17,
      x2: 20,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 7,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4,
      x2: 17,
      y2: 20
    }));
  }

  function IconFriends(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-friends",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
    }));
  }

  function IconGasStation(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-gas-station",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 20,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 7v1a1 1 0 0 0 1 1h1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 11,
      x2: 14,
      y2: 11
    }));
  }

  function IconGauge(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-gauge",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13.41,
      y1: 10.59,
      x2: 16,
      y2: 8
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12a5 5 0 0 1 5 -5"
    }));
  }

  function IconGeometry(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-geometry",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 5v-2"
    }));
  }

  function IconGhost(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ghost",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 10.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 10,
      x2: 14.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a3.5 3.5 0 0 0 4 0"
    }));
  }

  function IconGift(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-gift",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 8,
      width: 18,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
    }));
  }

  function IconGitBranch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-git-branch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 8,
      x2: 7,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18h6a2 2 0 0 0 2 -2v-5"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "14 14 17 11 20 14"
    }));
  }

  function IconGitCommit(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-git-commit",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 21
    }));
  }

  function IconGitCompare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-git-compare",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h5a2 2 0 0 1 2 2v8"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "14 9 11 6 14 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 18h-5a2 2 0 0 1 -2 -2v-8"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "10 15 13 18 10 21"
    }));
  }

  function IconGitFork(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-git-fork",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 16
    }));
  }

  function IconGitMerge(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-git-merge",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 8,
      x2: 7,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 8a4 4 0 0 0 4 4h4"
    }));
  }

  function IconGitPullRequest(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-git-pull-request",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 8,
      x2: 6,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h5a2 2 0 0 1 2 2v8"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "14 9 11 6 14 3"
    }));
  }

  function IconGlassFull(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-glass-full",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 16,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10a5.001 5.001 0 0 1 6 0a5.001 5.001 0 0 0 6 0"
    }));
  }

  function IconGlassOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-glass-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 16,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 3h10l1 7a4.511 4.511 0 0 1 -1.053 2.94m-2.386 1.625a7.48 7.48 0 0 1 -2.561 .435c-3.314 0 -6 -1.988 -6 -5l.5 -3.495"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconGlass(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-glass",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 16,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
    }));
  }

  function IconGlobe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-globe",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.75 16a8.015 8.015 0 1 0 9.25 -13"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12,
      y2: 22
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 22,
      x2: 16,
      y2: 22
    }));
  }

  function IconGolf(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-golf",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18v-15l7 4l-7 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
    }));
  }

  function IconGps(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-gps",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17l-1 -4l-4 -1l9 -4z"
    }));
  }

  function IconGrain(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-grain",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4.5,
      cy: 9.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 4.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 14.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4.5,
      cy: 19.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 9.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19.5,
      cy: 4.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 19.5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19.5,
      cy: 14.5,
      r: 1
    }));
  }

  function IconGridDots(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-grid-dots",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 19,
      r: 1
    }));
  }

  function IconGripHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-grip-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 9,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 15,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 9,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 15,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 9,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 15,
      r: 1
    }));
  }

  function IconGripVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-grip-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 19,
      r: 1
    }));
  }

  function IconGrowth(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-growth",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.5 15a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m-4 3.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m0 -7.5v6"
    }));
  }

  function IconH1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-h-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 18v-8l-2 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h2"
    }));
  }

  function IconH2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-h-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 -.001"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h2"
    }));
  }

  function IconH3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-h-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 14a2 2 0 1 0 -2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 16a2 2 0 1 0 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h2"
    }));
  }

  function IconH4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-h-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 18v-8l-4 6h5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h2"
    }));
  }

  function IconH5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-h-5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h2"
    }));
  }

  function IconH6(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-h-6",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      transform: "rotate(180 19 16)",
      cx: 19,
      cy: 16,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12a2 2 0 1 0 -4 0v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6v12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 6h2"
    }));
  }

  function IconHandFinger(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-finger",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }));
  }

  function IconHandLittleFinger(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-little-finger",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12v-5.5a1.5 1.5 0 0 1 3 0v9.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }));
  }

  function IconHandMiddleFinger(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-middle-finger",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11.5v-8a1.5 1.5 0 1 1 3 0v8.5"
    }));
  }

  function IconHandOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13.5v-5.5m.44 -3.562a1.5 1.5 0 0 1 2.56 1.062v1.5m0 4.008v.992m0 -6.5v-2a1.5 1.5 0 1 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2c-2.114 -.292 -3.956 -1.397 -5 -3l-2.7 -5.25a1.7 1.7 0 0 1 2.75 -2l.9 1.75"
    }));
  }

  function IconHandRingFinger(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-ring-finger",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 12v-6.5a1.5 1.5 0 0 1 3 0v6.5"
    }));
  }

  function IconHandRock(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-rock",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12v-6.5a1.5 1.5 0 0 1 3 0v10.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }));
  }

  function IconHandStop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-stop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }));
  }

  function IconHandThreeFingers(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-three-fingers",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
    }));
  }

  function IconHandTwoFingers(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hand-two-fingers",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
    }));
  }

  function IconHanger(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hanger",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 7a3 3 0 1 0 -3 3v2m0 0l-8.624 5.488a0.82 .82 0 0 0 .44 1.512h16.368a0.82 .82 0 0 0 .44 -1.512l-8.624 -5.488z"
    }));
  }

  function IconHash(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hash",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 9,
      x2: 19,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 15,
      x2: 19,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 4,
      x2: 7,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4,
      x2: 13,
      y2: 20
    }));
  }

  function IconHeading(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-heading",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12h10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4v16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4v16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 20h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 20h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4"
    }));
  }

  function IconHeadphonesOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-headphones-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 13,
      width: 5,
      height: 7,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 13h1a2 2 0 0 1 2 2v1m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-1a2 2 0 0 1 -2 -2v-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 15v-3c0 -2.21 .896 -4.21 2.344 -5.658m2.369 -1.638a8 8 0 0 1 11.287 7.296v3"
    }));
  }

  function IconHeadphones(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-headphones",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 13,
      rx: 2,
      width: 5,
      height: 7
    }), /*#__PURE__*/React.createElement("rect", {
      x: 15,
      y: 13,
      rx: 2,
      width: 5,
      height: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 15v-3a8 8 0 0 1 16 0v3"
    }));
  }

  function IconHeadset(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-headset",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 13,
      rx: 2,
      width: 4,
      height: 6
    }), /*#__PURE__*/React.createElement("rect", {
      x: 16,
      y: 13,
      rx: 2,
      width: 4,
      height: 6
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 15v-3a8 8 0 0 1 16 0v3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19a6 3 0 0 1 -6 3"
    }));
  }

  function IconHeartBroken(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-heart-broken",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.5 13.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7l-2 4l4 3l-2 4v3"
    }));
  }

  function IconHeart(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-heart",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.5 13.572l-7.5 7.428l-7.5 -7.428m0 0a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
    }));
  }

  function IconHelicopterLanding(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-helicopter-landing",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 8,
      x2: 9,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 15,
      y2: 16
    }));
  }

  function IconHelicopter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-helicopter",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 10l1 2h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 9,
      x2: 13,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 9.1v3.9h5.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 19,
      x2: 15,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 19,
      x2: 11,
      y2: 19
    }));
  }

  function IconHelp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-help",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
    }));
  }

  function IconHexagonOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hexagon-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconHexagon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hexagon",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573z"
    }));
  }

  function IconHierarchy2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hierarchy-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 3h4v4h-4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h4v4h-4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h4v4h-4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 17l5 -4l5 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 13
    }));
  }

  function IconHierarchy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-hierarchy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.5 17.5l5.5 -4.5l5.5 4.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 13
    }));
  }

  function IconHistory(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-history",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 8 12 12 14 14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
    }));
  }

  function IconHome2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-home-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 12 3 12 12 3 21 12 19 12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 12,
      width: 4,
      height: 4
    }));
  }

  function IconHome(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-home",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 12 3 12 12 3 21 12 19 12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
    }));
  }

  function IconIceCream2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ice-cream-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.657 11.004a6 6 0 1 0 -11.315 -.002"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.342 11l5.658 11l5.657 -10.996z"
    }));
  }

  function IconIceCream(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ice-cream",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21.5v-4.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 17h8v-10a4 4 0 1 0 -8 0v10z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 10.5l8 -3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 14.5l8 -3.5"
    }));
  }

  function IconId(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-id",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 16,
      rx: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 17,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 12,
      x2: 17,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 16,
      x2: 17,
      y2: 16
    }));
  }

  function IconInbox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-inbox",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 13h3l3 3h4l3 -3h3"
    }));
  }

  function IconIndentDecrease(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-indent-decrease",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 6,
      x2: 13,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 11,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 18,
      x2: 13,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8l-4 4l4 4"
    }));
  }

  function IconIndentIncrease(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-indent-increase",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 6,
      x2: 9,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 12,
      x2: 13,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 18,
      x2: 9,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8l4 4l-4 4"
    }));
  }

  function IconInfinity(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-infinity",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828"
    }));
  }

  function IconInfoCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-info-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12.01,
      y2: 8
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "11 12 12 12 12 16 13 16"
    }));
  }

  function IconInfoSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-info-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12.01,
      y2: 8
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "11 12 12 12 12 16 13 16"
    }));
  }

  function IconItalic(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-italic",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 5,
      x2: 17,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 19,
      x2: 13,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 5,
      x2: 10,
      y2: 19
    }));
  }

  function IconJumpRope(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-jump-rope",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 16,
      y: 3,
      width: 4,
      height: 7,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 4,
      height: 7,
      rx: 2
    }));
  }

  function IconKarate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-karate",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 4,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9l4.5 1l3 2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 21v-8l3 -5.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4.5l4 2l4 1l4 3.5l-2 3.5"
    }));
  }

  function IconKey(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-key",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8,
      cy: 15,
      r: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10.85,
      y1: 12.15,
      x2: 19,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 5,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 17,
      y2: 10
    }));
  }

  function IconKeyboardHide(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-keyboard-hide",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 3,
      width: 20,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 7,
      x2: 6,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 7,
      x2: 10,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 7,
      x2: 14,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 7,
      x2: 18,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 11,
      x2: 6,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 11,
      x2: 18,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 14,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 21l2 -2l2 2"
    }));
  }

  function IconKeyboardOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-keyboard-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 10,
      x2: 6,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 10,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 10,
      x2: 14,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 10,
      x2: 18,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 14,
      x2: 6,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 14,
      x2: 18,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 14,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconKeyboardShow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-keyboard-show",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 3,
      width: 20,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 7,
      x2: 6,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 7,
      x2: 10,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 7,
      x2: 14,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 7,
      x2: 18,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 11,
      x2: 6,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 11,
      x2: 18,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 14,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 19l2 2l2 -2"
    }));
  }

  function IconKeyboard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-keyboard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 6,
      width: 20,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 10,
      x2: 6,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 10,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 10,
      x2: 14,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 10,
      x2: 18,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 14,
      x2: 6,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 14,
      x2: 18,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 14,
      y2: 14
    }));
  }

  function IconLanguage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-language",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7h7m-2 -2v2a5 8 0 0 1 -5 8m1 -4a7 4 0 0 0 6.7 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 19l4 -9l4 9m-.9 -2h-6.2"
    }));
  }

  function IconLayersDifference(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layers-difference",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "10 8 8 8 8 10"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 14 8 16 10 16"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "14 8 16 8 16 10"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 14 16 16 14 16"
    }));
  }

  function IconLayersIntersect(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layers-intersect",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 4,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 8,
      width: 12,
      height: 12,
      rx: 2
    }));
  }

  function IconLayersLinked(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layers-linked",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 8.268a2 2 0 0 1 1 1.732v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.003 15.734a2 2 0 0 1 -1.003 -1.734v-8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3"
    }));
  }

  function IconLayersSubtract(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layers-subtract",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 4,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
    }));
  }

  function IconLayersUnion(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layers-union",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
    }));
  }

  function IconLayout2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 5,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 13,
      width: 6,
      height: 7,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 4,
      width: 6,
      height: 7,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 15,
      width: 6,
      height: 5,
      rx: 2
    }));
  }

  function IconLayoutAlignBottom(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-align-bottom",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 4,
      width: 6,
      height: 12,
      rx: 2
    }));
  }

  function IconLayoutAlignCenter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-align-center",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 9,
      width: 12,
      height: 6,
      rx: 2
    }));
  }

  function IconLayoutAlignLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-align-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 9,
      width: 12,
      height: 6,
      rx: 2
    }));
  }

  function IconLayoutAlignMiddle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-align-middle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 9,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 6,
      width: 6,
      height: 12,
      rx: 2
    }));
  }

  function IconLayoutAlignRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-align-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 9,
      width: 12,
      height: 6,
      rx: 2
    }));
  }

  function IconLayoutAlignTop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-align-top",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 8,
      width: 6,
      height: 12,
      rx: 2
    }));
  }

  function IconLayoutBottombar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-bottombar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 20,
      y2: 15
    }));
  }

  function IconLayoutCards(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-cards",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 4,
      width: 6,
      height: 10,
      rx: 2
    }));
  }

  function IconLayoutColumns(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-columns",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }));
  }

  function IconLayoutDistributeHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-distribute-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 9,
      width: 12,
      height: 6,
      rx: 2
    }));
  }

  function IconLayoutDistributeVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-distribute-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 4,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 4,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 6,
      width: 6,
      height: 12,
      rx: 2
    }));
  }

  function IconLayoutGridAdd(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-grid-add",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 17h6m-3 -3v6"
    }));
  }

  function IconLayoutGrid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-grid",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }));
  }

  function IconLayoutKanban(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-kanban",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 4,
      x2: 10,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 4,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 8,
      width: 6,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 8,
      width: 6,
      height: 6,
      rx: 2
    }));
  }

  function IconLayoutList(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-list",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 6,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 16,
      height: 6,
      rx: 2
    }));
  }

  function IconLayoutNavbar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-navbar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 9,
      x2: 20,
      y2: 9
    }));
  }

  function IconLayoutRows(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-rows",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }));
  }

  function IconLayoutSidebarRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-sidebar-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 4,
      x2: 15,
      y2: 20
    }));
  }

  function IconLayoutSidebar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout-sidebar",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 4,
      x2: 9,
      y2: 20
    }));
  }

  function IconLayout(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-layout",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 5,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 13,
      width: 6,
      height: 7,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 4,
      width: 6,
      height: 16,
      rx: 2
    }));
  }

  function IconLeaf(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-leaf",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21c.5 -4.5 2.5 -8 7 -10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z"
    }));
  }

  function IconLego(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-lego",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9.5,
      y1: 11,
      x2: 9.51,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 11,
      x2: 14.51,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15a3.5 3.5 0 0 0 5 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3"
    }));
  }

  function IconLetterA(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-a",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 13,
      x2: 17,
      y2: 13
    }));
  }

  function IconLetterB(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-b",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 13,
      y2: 12
    }));
  }

  function IconLetterC(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-c",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5"
    }));
  }

  function IconLetterCaseLower(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-case-lower",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6.5,
      cy: 15.5,
      r: 3.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12v7"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17.5,
      cy: 15.5,
      r: 3.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12v7"
    }));
  }

  function IconLetterCaseToggle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-case-toggle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6.5,
      cy: 15.5,
      r: 3.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 13h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12v7"
    }));
  }

  function IconLetterCaseUpper(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-case-upper",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 13h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 13h7"
    }));
  }

  function IconLetterCase(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-case",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17.5,
      cy: 15.5,
      r: 3.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 13h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12v7"
    }));
  }

  function IconLetterD(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-d",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16"
    }));
  }

  function IconLetterE(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-e",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4h-10v16h10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 15,
      y2: 12
    }));
  }

  function IconLetterF(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-f",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4h-10v16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 15,
      y2: 12
    }));
  }

  function IconLetterG(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-g",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-2h-4"
    }));
  }

  function IconLetterH(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-h",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 17,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 7,
      y2: 20
    }));
  }

  function IconLetterI(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-i",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }));
  }

  function IconLetterJ(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-j",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4"
    }));
  }

  function IconLetterK(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-k",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 7,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12h2l8 -8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 17,
      y2: 20
    }));
  }

  function IconLetterL(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-l",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4v16h10"
    }));
  }

  function IconLetterM(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-m",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 20v-16l6 14l6 -14v16"
    }));
  }

  function IconLetterN(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-n",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20v-16l10 16v-16"
    }));
  }

  function IconLetterO(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-o",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
    }));
  }

  function IconLetterP(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-p",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
    }));
  }

  function IconLetterQ(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-q",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 15,
      x2: 18,
      y2: 20
    }));
  }

  function IconLetterR(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-r",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 13,
      x2: 17,
      y2: 20
    }));
  }

  function IconLetterS(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-s",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4"
    }));
  }

  function IconLetterSpacing(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-spacing",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 4l3 8l3 -8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 18h14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 20l2 -2l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 16l-2 2l2 2"
    }));
  }

  function IconLetterT(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-t",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 4,
      x2: 18,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }));
  }

  function IconLetterU(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-u",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11"
    }));
  }

  function IconLetterV(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-v",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4l6 16l6 -16"
    }));
  }

  function IconLetterW(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-w",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4l4 16l4 -14l4 14l4 -16"
    }));
  }

  function IconLetterX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4,
      x2: 7,
      y2: 20
    }));
  }

  function IconLetterY(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-y",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4l5 9l5 -9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 13,
      x2: 12,
      y2: 20
    }));
  }

  function IconLetterZ(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letter-z",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4h10l-10 16h10"
    }));
  }

  function IconLettersCase(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-letters-case",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 16,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 13,
      x2: 21,
      y2: 19
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19v-10a4 4 0 0 1 4 -4a4 4 0 0 1 4 4v10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 13,
      x2: 11,
      y2: 13
    }));
  }

  function IconLicense(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-license",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 7,
      x2: 13,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 11,
      x2: 13,
      y2: 11
    }));
  }

  function IconLifebuoy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-lifebuoy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 15,
      x2: 18.35,
      y2: 18.35
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 5.65,
      y2: 18.35
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5.65,
      y1: 5.65,
      x2: 9,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18.35,
      y1: 5.65,
      x2: 15,
      y2: 9
    }));
  }

  function IconLineDashed(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-line-dashed",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 12h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 12h2"
    }));
  }

  function IconLineDotted(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-line-dotted",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 12v.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v.01"
    }));
  }

  function IconLineHeight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-line-height",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 8 6 5 9 8"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 16 6 19 9 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 5,
      x2: 6,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 18,
      x2: 20,
      y2: 18
    }));
  }

  function IconLine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-line",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.5,
      y1: 16.5,
      x2: 16.5,
      y2: 7.5
    }));
  }

  function IconLink(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-link",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
    }));
  }

  function IconListCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-list-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.5 5.5l1.5 1.5l2.5 -2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.5 11.5l1.5 1.5l2.5 -2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.5 17.5l1.5 1.5l2.5 -2.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 18,
      x2: 20,
      y2: 18
    }));
  }

  function IconListSearch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-list-search",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 15,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.5 18.5l2.5 2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6h16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18h4"
    }));
  }

  function IconList(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-list",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 18,
      x2: 20,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 6,
      x2: 5,
      y2: 6.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 5,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 18,
      x2: 5,
      y2: 18.01
    }));
  }

  function IconLivePhoto(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-live-photo",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15.9,
      y1: 20.11,
      x2: 15.9,
      y2: 20.12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.04,
      y1: 17.61,
      x2: 19.04,
      y2: 17.62
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20.77,
      y1: 14,
      x2: 20.77,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20.77,
      y1: 10,
      x2: 20.77,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.04,
      y1: 6.39,
      x2: 19.04,
      y2: 6.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15.9,
      y1: 3.89,
      x2: 15.9,
      y2: 3.9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 3.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.1,
      y1: 3.89,
      x2: 8.1,
      y2: 3.9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.96,
      y1: 6.39,
      x2: 4.96,
      y2: 6.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.23,
      y1: 10,
      x2: 3.23,
      y2: 10.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.23,
      y1: 14,
      x2: 3.23,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.96,
      y1: 17.61,
      x2: 4.96,
      y2: 17.62
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.1,
      y1: 20.11,
      x2: 8.1,
      y2: 20.12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 21.01
    }));
  }

  function IconLiveView(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-live-view",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 11,
      x2: 12,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
    }));
  }

  function IconLoaderQuarter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-loader-quarter",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 6,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 3,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.75,
      y1: 7.75,
      x2: 5.6,
      y2: 5.6
    }));
  }

  function IconLoader(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-loader",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 6,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.25,
      y1: 7.75,
      x2: 18.4,
      y2: 5.6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.25,
      y1: 16.25,
      x2: 18.4,
      y2: 18.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.75,
      y1: 16.25,
      x2: 5.6,
      y2: 18.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 12,
      x2: 3,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.75,
      y1: 7.75,
      x2: 5.6,
      y2: 5.6
    }));
  }

  function IconLocation(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-location",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
    }));
  }

  function IconLockAccess(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-lock-access",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 11,
      width: 8,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 11v-2a2 2 0 1 1 4 0v2"
    }));
  }

  function IconLockOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-lock-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4m4 0h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 16,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11v-3m.712 -3.278a4 4 0 0 1 7.288 2.278v4"
    }));
  }

  function IconLockOpen(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-lock-open",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 11,
      width: 14,
      height: 10,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 16,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11v-5a4 4 0 0 1 8 0"
    }));
  }

  function IconLock(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-lock",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 11,
      width: 14,
      height: 10,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 16,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11v-4a4 4 0 0 1 8 0v4"
    }));
  }

  function IconLogin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-login",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12h-13l3 -3m0 6l-3 -3"
    }));
  }

  function IconLogout(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-logout",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12h14l-3 -3m0 6l3 -3"
    }));
  }

  function IconMacro(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-macro",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15a6 6 0 1 0 12 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15a6 6 0 0 0 -6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21a6 6 0 0 0 -6 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21v-10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11a5 5 0 0 1 -5 -5v-3l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -5 5z"
    }));
  }

  function IconMagnet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-magnet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 9,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 19,
      y2: 8
    }));
  }

  function IconMailForward(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mail-forward",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6l9 6l9 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 18h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 15l3 3l-3 3"
    }));
  }

  function IconMailOpened(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mail-opened",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 9 12 15 21 9 12 3 3 9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 19,
      x2: 9,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 13,
      x2: 21,
      y2: 19
    }));
  }

  function IconMail(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mail",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 7 12 13 21 7"
    }));
  }

  function IconMailbox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mailbox",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18v-6a4 4 0 0 0 -4 -4h-10.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11v-8h4l2 2l-2 2h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15h1"
    }));
  }

  function IconMan(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-man",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
    }));
  }

  function IconManualGearbox(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-manual-gearbox",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 6,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 18,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 8,
      x2: 5,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 8v2a2 2 0 0 1 -2 2h-12"
    }));
  }

  function IconMap2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-map-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 6,
      x2: 18,
      y2: 6.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 4,
      x2: 9,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 15,
      x2: 15,
      y2: 20
    }));
  }

  function IconMapPinOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-map-pin-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.44 9.435a3 3 0 0 0 4.126 4.124m1.434 -2.559a3 3 0 0 0 -3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.048 4.042a8 8 0 0 1 10.912 10.908m-1.8 2.206l-3.745 3.744a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 0 1 -.48 -10.79"
    }));
  }

  function IconMapPin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-map-pin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 11,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
    }));
  }

  function IconMapPins(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-map-pins",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 7,
      x2: 8,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 15,
      x2: 16,
      y2: 15.01
    }));
  }

  function IconMap(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-map",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 7 9 4 15 7 21 4 21 17 15 20 9 17 3 20 3 7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 4,
      x2: 9,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 7,
      x2: 15,
      y2: 20
    }));
  }

  function IconMarkdown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-markdown",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 15v-6l2 2l2 -2v6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 13l2 2l2 -2m-2 2v-6"
    }));
  }

  function IconMarquee2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-marquee-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2"
    }));
  }

  function IconMarquee(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-marquee",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6a2 2 0 0 1 2 -2m3 0h1.5m3 0h1.5m3 0a2 2 0 0 1 2 2m0 3v1.5m0 3v1.5m0 3a2 2 0 0 1 -2 2m-3 0h-1.5m-3 0h-1.5m-3 0a2 2 0 0 1 -2 -2m0 -3v-1.5m0 -3v-1.5m0 -3"
    }));
  }

  function IconMars(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mars",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10,
      cy: 14,
      r: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 5,
      x2: 13.6,
      y2: 10.4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 5,
      x2: 14,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 5,
      x2: 19,
      y2: 10
    }));
  }

  function IconMaskOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mask-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.42 19.41a2 2 0 0 1 -1.42 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.055 .588 -1.417m3.412 -.583h10a2 2 0 0 1 2 2v10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.885 9.872a3 3 0 1 0 4.245 4.24m.582 -3.396a3.012 3.012 0 0 0 -1.438 -1.433"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconMask(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mask",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconMassage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-massage",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4,
      cy: 17,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 22l4 -2v-3h12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 20h9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 14l3 -2l1 -4c3 1 3 4 3 6"
    }));
  }

  function IconMathFunction(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-math-function",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 17c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9s1.5 -9 3 -9s2 .5 2 2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 11,
      y2: 12
    }));
  }

  function IconMathSymbols(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-math-symbols",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.5,
      y1: 4.5,
      x2: 19.5,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.5,
      y1: 4.5,
      x2: 16.5,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 4,
      x2: 6,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 8,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 16,
      x2: 18.01,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 20,
      x2: 18.01,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 8,
      y2: 18
    }));
  }

  function IconMath(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-math",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 13l4 4m0 -4l-4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 5h-7l-4 14l-3 -6h-2"
    }));
  }

  function IconMaximize(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-maximize",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 8v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-2"
    }));
  }

  function IconMedal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-medal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 4v3m-4 -3v6m8 -6v6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
    }));
  }

  function IconMedicalCross(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-medical-cross",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 3a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1 -1.366 .366l-3.928 -2.269v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l3.928 2.267v-4.535a1 1 0 0 1 1 -1h2z"
    }));
  }

  function IconMenu2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-menu-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 20,
      y2: 18
    }));
  }

  function IconMenu(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-menu",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 20,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 20,
      y2: 16
    }));
  }

  function IconMessage2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 9,
      x2: 16,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 13,
      x2: 14,
      y2: 13
    }));
  }

  function IconMessageCircle2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-circle-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }));
  }

  function IconMessageCircleOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-circle-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.585 4.581c3.225 -1.181 7.032 -.616 9.66 1.626c2.983 2.543 3.602 6.525 1.634 9.662m-1.908 2.108c-2.786 2.19 -6.89 2.665 -10.271 1.023l-4.7 1l1.3 -3.9c-2.237 -3.308 -1.489 -7.54 1.714 -10.084"
    }));
  }

  function IconMessageCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 12,
      x2: 16,
      y2: 12.01
    }));
  }

  function IconMessageDots(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-dots",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 11,
      x2: 12,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 11,
      x2: 8,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 11,
      x2: 16,
      y2: 11.01
    }));
  }

  function IconMessageOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-9l-4 4v-13c0 -1.086 .577 -2.036 1.44 -2.563m3.561 -.437h8a3 3 0 0 1 3 3v6c0 .575 -.162 1.112 -.442 1.568"
    }));
  }

  function IconMessagePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 14,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 13
    }));
  }

  function IconMessageReport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message-report",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 12,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 14.01
    }));
  }

  function IconMessage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-message",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 9,
      x2: 16,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 13,
      x2: 14,
      y2: 13
    }));
  }

  function IconMessagesOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-messages-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11a1 1 0 0 1 -1 -1m0 -3.968v-2.032a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10l-3 -3h-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
    }));
  }

  function IconMessages(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-messages",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
    }));
  }

  function IconMicrophoneOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-microphone-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 10a7 7 0 0 0 10.846 5.85m2.002 -2a6.967 6.967 0 0 0 1.152 -3.85"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 16,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 21
    }));
  }

  function IconMicrophone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-microphone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 2,
      width: 6,
      height: 11,
      rx: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 10a7 7 0 0 0 14 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 16,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 21
    }));
  }

  function IconMinimize(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-minimize",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 19v-2a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 5v2a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 15h2a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 9h2a2 2 0 0 0 2 -2v-2"
    }));
  }

  function IconMinusVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-minus-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 5v14"
    }));
  }

  function IconMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }));
  }

  function IconMist(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mist",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 5h3m4 0h9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 10h11m4 0h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 15h5m4 0h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 20h9m4 0h3"
    }));
  }

  function IconMoodBoy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-boy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 16a3.5 3.5 0 0 0 5 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.5 2c1.5 1 2.5 3.5 2.5 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.5 2c1.5 2 2 3.5 2 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 9.01,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 12,
      x2: 15.01,
      y2: 12
    }));
  }

  function IconMoodConfuzed(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-confuzed",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 16a10 10 0 0 1 6 -1.5"
    }));
  }

  function IconMoodCrazyHappy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-crazy-happy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 8.5,
      x2: 10,
      y2: 11.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 11.5l3 -3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 8.5,
      x2: 17,
      y2: 11.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 11.5l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15a3.5 3.5 0 0 0 5 0"
    }));
  }

  function IconMoodCry(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-cry",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.566 17.606a2 2 0 1 0 2.897 .03l-1.463 -1.636l-1.434 1.606z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.865 13.517a8.937 8.937 0 0 0 .135 -1.517a9 9 0 1 0 -9 9c.69 0 1.36 -.076 2 -.222"
    }));
  }

  function IconMoodEmpty(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-empty",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 15,
      y2: 15
    }));
  }

  function IconMoodHappy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-happy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 9.01,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 15.01,
      y2: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13a4 4 0 1 0 8 0m0 0h-8"
    }));
  }

  function IconMoodKid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-kid",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15a3.5 3.5 0 0 0 5 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a2 2 0 0 0 0 4"
    }));
  }

  function IconMoodNeutral(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-neutral",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }));
  }

  function IconMoodSad(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-sad",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
    }));
  }

  function IconMoodSmile(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-smile",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.5 15a3.5 3.5 0 0 0 5 0"
    }));
  }

  function IconMoodSuprised(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-suprised",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 9.01,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 15.01,
      y2: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 15,
      r: 2
    }));
  }

  function IconMoodTongue(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mood-tongue",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 10,
      x2: 15.01,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7"
    }));
  }

  function IconMoon2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-moon-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.418 4.157a8 8 0 0 0 0 15.686"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconMoonStars(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-moon-stars",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 11h2m-1 -1v2"
    }));
  }

  function IconMoon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-moon",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
    }));
  }

  function IconMoped(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-moped",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 9,
      x2: 9,
      y2: 9
    }));
  }

  function IconMotorbike(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-motorbike",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 16,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 16,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 6h2l1.5 3l2 4"
    }));
  }

  function IconMouse(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mouse",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 3,
      width: 12,
      height: 18,
      rx: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 11
    }));
  }

  function IconMovie(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-movie",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 4,
      x2: 16,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 8,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 8,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 8,
      x2: 20,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 16,
      x2: 20,
      y2: 16
    }));
  }

  function IconMug(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-mug",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.083 5h10.834a1.08 1.08 0 0 1 1.083 1.077v8.615c0 2.38 -1.94 4.308 -4.333 4.308h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.288 -1.12 2.333 -2.5 2.333h-2.5"
    }));
  }

  function IconMusic(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-music",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "9 17 9 4 19 4 19 17"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 8,
      x2: 19,
      y2: 8
    }));
  }

  function IconNewSection(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-new-section",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5"
    }));
  }

  function IconNews(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-news",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 8,
      x2: 12,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 16,
      x2: 12,
      y2: 16
    }));
  }

  function IconNfc(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-nfc",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 20a3 3 0 0 1 -3 -3v-11l5 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 4a3 3 0 0 1 3 3v11l-5 -5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 3
    }));
  }

  function IconNote(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-note",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 20,
      x2: 20,
      y2: 13
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7"
    }));
  }

  function IconNotebook(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-notebook",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 8,
      x2: 15,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 12,
      x2: 15,
      y2: 12
    }));
  }

  function IconNotes(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-notes",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 3,
      width: 14,
      height: 18,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 7,
      x2: 15,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 11,
      x2: 15,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 13,
      y2: 15
    }));
  }

  function IconNotification(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-notification",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 7,
      r: 3
    }));
  }

  function IconNumber0(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-0",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 16v-8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z"
    }));
  }

  function IconNumber1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 20v-16l-5 5"
    }));
  }

  function IconNumber2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8"
    }));
  }

  function IconNumber3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a4 4 0 1 0 -4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16a4 4 0 1 0 4 -4"
    }));
  }

  function IconNumber4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 20v-15l-8 11h10"
    }));
  }

  function IconNumber5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8"
    }));
  }

  function IconNumber6(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-6",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8a4 4 0 1 0 -8 0v8"
    }));
  }

  function IconNumber7(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-7",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h8l-4 16"
    }));
  }

  function IconNumber8(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-8",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 8,
      r: 4
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 16,
      r: 4
    }));
  }

  function IconNumber9(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-number-9",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16a4 4 0 1 0 8 0v-8"
    }));
  }

  function IconOctagonOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-octagon-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.647 3.653l.353 -.353c.2 -.2 .4 -.3 .7 -.3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-.35 .35m-1.997 1.997l-2.353 2.353c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l2.35 -2.35"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconOctagon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-octagon",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
    }));
  }

  function IconOld(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-old",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 21l-1 -4l-2 -3v-6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 14l-1 -3l4 -3l3 2l3 .5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8,
      cy: 4,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 17l-2 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
    }));
  }

  function IconOlympics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-olympics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 9,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 9,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 9,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 15,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 15,
      r: 3
    }));
  }

  function IconOmega(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-omega",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5"
    }));
  }

  function IconOutlet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-outlet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 12,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 12,
      r: 0.5,
      fill: "currentColor"
    }));
  }

  function IconOverline(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-overline",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 9v5a5 5 0 0 0 10 0v-5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 5h14"
    }));
  }

  function IconPackage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-package",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 20,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 4,
      y2: 7.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 5.25,
      x2: 8,
      y2: 9.75
    }));
  }

  function IconPacman(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pacman",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 11.5,
      cy: 7.5,
      r: 1,
      fill: "currentColor"
    }));
  }

  function IconPageBreak(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-page-break",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 3v4a1 1 0 0 0 1 1h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 14h3m4.5 0h3m4.5 0h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2"
    }));
  }

  function IconPaint(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-paint",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 3,
      width: 14,
      height: 6,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 15,
      width: 4,
      height: 6,
      rx: 1
    }));
  }

  function IconPalette(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-palette",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21a9 9 0 1 1 0 -18a9 8 0 0 1 9 8a4.5 4 0 0 1 -4.5 4h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7.5,
      cy: 10.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16.5,
      cy: 10.5,
      r: 0.5,
      fill: "currentColor"
    }));
  }

  function IconPanoramaHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-panorama-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.338 5.53c5.106 1.932 10.211 1.932 15.317 .002a1 1 0 0 1 1.345 .934v11c0 .692 -.692 1.2 -1.34 .962c-5.107 -1.932 -10.214 -1.932 -15.321 0c-.648 .246 -1.339 -.242 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935z"
    }));
  }

  function IconPanoramaVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-panorama-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.463 4.338c-1.932 5.106 -1.932 10.211 0 15.317a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.932 -5.107 1.932 -10.214 0 -15.321c-.246 -.648 .243 -1.339 .935 -1.339h11.028c.693 0 1.18 .691 .935 1.338z"
    }));
  }

  function IconPaperclip(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-paperclip",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5"
    }));
  }

  function IconParachute(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-parachute",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 12a10 10 0 1 0 -20 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3c0 -1.66 -1.57 -3 -3.5 -3s-3.5 1.34 -3.5 3c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 12l10 10l-3.5 -10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.5 12l-3.5 10l10 -10"
    }));
  }

  function IconParentheses(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-parentheses",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4a12.25 12.25 0 0 0 0 16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4a12.25 12.25 0 0 1 0 16"
    }));
  }

  function IconParking(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-parking",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 16v-8h4a2 2 0 0 1 0 4h-4"
    }));
  }

  function IconPeace(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-peace",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 18.3,
      y2: 18.3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 5.7,
      y2: 18.3
    }));
  }

  function IconPencil(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pencil",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13.5,
      y1: 6.5,
      x2: 17.5,
      y2: 10.5
    }));
  }

  function IconPennant(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pennant",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 21,
      x2: 10,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l9 4l-9 4"
    }));
  }

  function IconPercentage(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-percentage",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 7,
      r: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 18,
      x2: 18,
      y2: 6
    }));
  }

  function IconPerspective(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-perspective",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z"
    }));
  }

  function IconPhoneCall(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-call",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 7a2 2 0 0 1 2 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 3a6 6 0 0 1 6 6"
    }));
  }

  function IconPhoneCalling(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-calling",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 7,
      x2: 15,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 7,
      x2: 18,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 7,
      x2: 21,
      y2: 7.01
    }));
  }

  function IconPhoneCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6l2 2l4 -4"
    }));
  }

  function IconPhoneIncoming(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-incoming",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 5 15 9 19 9"
    }));
  }

  function IconPhoneOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.831 14.161a15.946 15.946 0 0 1 -2.831 -8.161a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5c.108 .22 .223 .435 .345 .645m1.751 2.277c.843 .84 1.822 1.544 2.904 2.078l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a15.963 15.963 0 0 1 -10.344 -4.657"
    }));
  }

  function IconPhoneOutgoing(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-outgoing",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 9,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 4 20 4 20 8"
    }));
  }

  function IconPhonePause(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-pause",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 3,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 7
    }));
  }

  function IconPhonePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6h6m-3 -3v6"
    }));
  }

  function IconPhoneX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4l4 4m0 -4l-4 4"
    }));
  }

  function IconPhone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-phone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }));
  }

  function IconPhotoOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-photo-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 15.01,
      y2: 8
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.121 19.122a3 3 0 0 1 -2.121 .878h-10a3 3 0 0 1 -3 -3v-10c0 -.833 .34 -1.587 .888 -2.131m3.112 -.869h9a3 3 0 0 1 3 3v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l5 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.32 12.34c.577 -.059 1.162 .162 1.68 .66l2 2"
    }));
  }

  function IconPhoto(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-photo",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 8,
      x2: 15.01,
      y2: 8
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 15l4 -4a3 5 0 0 1 3 0l5 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 14l1 -1a3 5 0 0 1 3 0l2 2"
    }));
  }

  function IconPhysotherapist(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-physotherapist",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 15l-1 -3l4 -2l4 1h3.5"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 6,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17v-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 20h7l1 -4l4 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20h3"
    }));
  }

  function IconPictureInPictureOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-picture-in-picture-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 14,
      width: 7,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 9,
      x2: 11,
      y2: 13
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12v-3h3"
    }));
  }

  function IconPictureInPictureOn(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-picture-in-picture-on",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 14,
      width: 7,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 9,
      x2: 11,
      y2: 13
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13h3v-3"
    }));
  }

  function IconPictureInPicture(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-picture-in-picture",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 14,
      width: 7,
      height: 5,
      rx: 1
    }));
  }

  function IconPill(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pill",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.5,
      y1: 8.5,
      x2: 15.5,
      y2: 15.5
    }));
  }

  function IconPin(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pin",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 4.5,
      y2: 19.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 4,
      x2: 20,
      y2: 9.5
    }));
  }

  function IconPinnedOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pinned-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4.5l-3.249 3.249m-2.57 1.433l-2.181 .818l-1.5 1.5l7 7l1.5 -1.5l.82 -2.186m1.43 -2.563l3.25 -3.251"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 4.5,
      y2: 19.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 4,
      x2: 20,
      y2: 9.5
    }));
  }

  function IconPinned(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pinned",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 4v6l-2 4v2h10v-2l-2 -4v-6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 16,
      y2: 4
    }));
  }

  function IconPizza(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pizza",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.2 15.772a14.939 14.939 0 0 0 6.995 1.728a14.944 14.944 0 0 0 6.638 -1.545"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 11.01,
      x2: 13,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 14,
      x2: 11,
      y2: 13.99
    }));
  }

  function IconPlaneArrival(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plane-arrival",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 12h5a2 2 0 0 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3z",
      transform: "rotate(15 12 12) translate(0 -1)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }));
  }

  function IconPlaneDeparture(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plane-departure",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 12h5a2 2 0 0 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3z",
      transform: "rotate(-15 12 12) translate(0 -1)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }));
  }

  function IconPlane(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plane",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z"
    }));
  }

  function IconPlanet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-planet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 7
    }));
  }

  function IconPlant2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plant-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 9a10 10 0 1 0 20 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 19a10 10 0 0 1 10 -10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 9a10 10 0 0 1 10 10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 4a9.7 9.7 0 0 1 2.99 7.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
    }));
  }

  function IconPlant(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plant",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 9
    }));
  }

  function IconPlayCard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-play-card",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      transform: "rotate(90 12 12)",
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 6,
      x2: 8.01,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 18,
      x2: 16.01,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 16l-3 -4l3 -4l3 4z"
    }));
  }

  function IconPlayerPause(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-pause",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 5,
      width: 4,
      height: 14,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 5,
      width: 4,
      height: 14,
      rx: 1
    }));
  }

  function IconPlayerPlay(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-play",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 4v16l13 -8z"
    }));
  }

  function IconPlayerRecord(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-record",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 7
    }));
  }

  function IconPlayerSkipBack(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-skip-back",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 5v14l-12 -7z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 5,
      x2: 4,
      y2: 19
    }));
  }

  function IconPlayerSkipForward(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-skip-forward",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 5v14l12 -7z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 5,
      x2: 20,
      y2: 19
    }));
  }

  function IconPlayerStop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-stop",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 5,
      width: 14,
      height: 14,
      rx: 2
    }));
  }

  function IconPlayerTrackNext(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-track-next",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 5v14l8 -7z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 5v14l8 -7z"
    }));
  }

  function IconPlayerTrackPrev(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-player-track-prev",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 5v14l-8 -7z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 5v14l-8 -7z"
    }));
  }

  function IconPlaylist(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-playlist",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17v-13h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 5h-10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 9,
      x2: 13,
      y2: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 13h-6"
    }));
  }

  function IconPlug(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plug",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 7h10v6a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3v-6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 3,
      x2: 9,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 3,
      x2: 15,
      y2: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 16v2a2 2 0 0 0 2 2h3"
    }));
  }

  function IconPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }));
  }

  function IconPoint(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-point",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }));
  }

  function IconPokeball(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pokeball",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 9,
      r: 9,
      transform: "translate(3 3)"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h6m6 0h6"
    }));
  }

  function IconPolaroid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-polaroid",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 20,
      y2: 16
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 7,
      x2: 14.01,
      y2: 7
    }));
  }

  function IconPool(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pool",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 12v-7.5a1.5 1.5 0 0 1 3 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12v-7.5a1.5 1.5 0 0 0 -3 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 5,
      x2: 9,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 15,
      y2: 10
    }));
  }

  function IconPower(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-power",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 6a7.75 7.75 0 1 0 10 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 12
    }));
  }

  function IconPray(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pray",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 20h8l-4 -4v-7l4 3l2 -2"
    }));
  }

  function IconPresentationAnalytics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-presentation-analytics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 12v-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 4h18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 16v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 20h6"
    }));
  }

  function IconPresentation(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-presentation",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 4,
      x2: 21,
      y2: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 16,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 20,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12l3 -3l2 2l3 -3"
    }));
  }

  function IconPrinter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-printer",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 13,
      width: 10,
      height: 8,
      rx: 2
    }));
  }

  function IconPrompt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-prompt",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 7 10 12 5 17"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 17,
      x2: 19,
      y2: 17
    }));
  }

  function IconPropeller(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-propeller",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 13,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1.006 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.664 12.999c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
    }));
  }

  function IconPuzzle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-puzzle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1"
    }));
  }

  function IconPyramid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-pyramid",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17l9 4l9 -4l-9 -14z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v18"
    }));
  }

  function IconQrcode(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-qrcode",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 17,
      x2: 7,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("rect", {
      x: 14,
      y: 4,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 7,
      x2: 7,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 7,
      x2: 17,
      y2: 7.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 17,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 14,
      x2: 20,
      y2: 14.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 14,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 17,
      x2: 20,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 17,
      x2: 20,
      y2: 20
    }));
  }

  function IconQuestionMark(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-question-mark",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 12,
      y2: 19.01
    }));
  }

  function IconRadioactive(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-radioactive",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.5 14.6l3 5.19a9 9 0 0 0 4.5 -7.79h-6a3 3 0 0 1 -1.5 2.6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.5 9.4l3 -5.19a9 9 0 0 0 -9 0l3 5.19a3 3 0 0 1 3 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
    }));
  }

  function IconRadiusBottomLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-radius-bottom-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 19h-6a8 8 0 0 1 -8 -8v-6"
    }));
  }

  function IconRadiusBottomRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-radius-bottom-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 5v6a8 8 0 0 1 -8 8h-6"
    }));
  }

  function IconRadiusTopLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-radius-top-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19v-6a8 8 0 0 1 8 -8h6"
    }));
  }

  function IconRadiusTopRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-radius-top-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 5h6a8 8 0 0 1 8 8v6"
    }));
  }

  function IconRainbow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rainbow",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 17a6 6 0 1 0 -12 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 17a2 2 0 1 0 -4 0"
    }));
  }

  function IconReceipt2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-receipt-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
    }));
  }

  function IconReceiptOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-receipt-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 7,
      x2: 15,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 11,
      x2: 11,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 15,
      x2: 15,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 11,
      x2: 15,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconReceiptRefund(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-receipt-refund",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 14v-2a2 2 0 0 0 -2 -2h-4l2 -2m0 4l-2 -2"
    }));
  }

  function IconReceiptTax(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-receipt-tax",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 14,
      x2: 15,
      y2: 8
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9.5,
      cy: 8.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 14.5,
      cy: 13.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }));
  }

  function IconReceipt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-receipt",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2"
    }));
  }

  function IconRecharging(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-recharging",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.038 4.5a9 9 0 0 0 -2.495 2.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.186 10.209a9 9 0 0 0 0 3.508"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 16.962a9 9 0 0 0 2.47 2.495"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.209 20.814a9 9 0 0 0 3.5 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.962 19.5a9 9 0 0 0 2.495 -2.47"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.814 13.791a9 9 0 0 0 0 -3.508"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.5 7.038a9 9 0 0 0 -2.47 -2.495"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.791 3.186a9 9 0 0 0 -3.508 -.02"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8l-2 4h4l-2 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21a9 9 0 0 0 0 -18"
    }));
  }

  function IconRecordMail(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-record-mail",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 15,
      x2: 17,
      y2: 15
    }));
  }

  function IconRectangleVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rectangle-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 3,
      width: 14,
      height: 18,
      rx: 2
    }));
  }

  function IconRectangle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rectangle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }));
  }

  function IconRecycle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-recycle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1",
      transform: "rotate(120 12 13)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1",
      transform: "rotate(240 12 13)"
    }));
  }

  function IconRefreshAlert(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-refresh-alert",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12.01,
      y2: 15
    }));
  }

  function IconRefresh(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-refresh",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
    }));
  }

  function IconRegistered(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-registered",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 16v-8h4a2 2 0 0 1 0 4h-4m3 0l3 4"
    }));
  }

  function IconRelationManyToMany(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-relation-many-to-many",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 14v-4l3 4v-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 14v-4l3 4v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10.5,
      x2: 12,
      y2: 10.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 13.5,
      x2: 12,
      y2: 13.51
    }));
  }

  function IconRelationOneToMany(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-relation-one-to-many",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 10h1v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 14v-4l3 4v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 10.5,
      x2: 11,
      y2: 10.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 13.5,
      x2: 11,
      y2: 13.51
    }));
  }

  function IconRelationOneToOne(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-relation-one-to-one",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 10h1v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10h1v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 10.5,
      x2: 12,
      y2: 10.51
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 13.5,
      x2: 12,
      y2: 13.51
    }));
  }

  function IconRepeatOnce(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-repeat-once",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 11l1 -1v4"
    }));
  }

  function IconRepeat(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-repeat",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
    }));
  }

  function IconReplace(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-replace",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 3,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 15,
      y: 15,
      width: 6,
      height: 6,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
    }));
  }

  function IconReportAnalytics(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-report-analytics",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 17v-5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17v-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 17v-3"
    }));
  }

  function IconReportMedical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-report-medical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 14,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 16
    }));
  }

  function IconReportMoney(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-report-money",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17v1m0 -8v1"
    }));
  }

  function IconReport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-report",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 14v4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 11v-4a2 2 0 0 0 -2 -2h-2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 3,
      width: 6,
      height: 4,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 18,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 11h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 15h3"
    }));
  }

  function IconResize(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-resize",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 11v8a1 1 0 0 0 1 1h8m-9 -14v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h7a1 1 0 0 1 1 1v7"
    }));
  }

  function IconRipple(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ripple",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7c3 -2 6 -2 9 0s6 2 9 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17c3 -2 6 -2 9 0s6 2 9 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12c3 -2 6 -2 9 0s6 2 9 0"
    }));
  }

  function IconRoadSign(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-road-sign",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 14v-2c0 -.59 .414 -1 1 -1h5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 9l2 2l-2 2"
    }));
  }

  function IconRocket(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rocket",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 9,
      r: 1
    }));
  }

  function IconRotate2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rotate-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18.37,
      y1: 7.16,
      x2: 18.37,
      y2: 7.17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 19.94,
      x2: 13,
      y2: 19.95
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16.84,
      y1: 18.37,
      x2: 16.84,
      y2: 18.38
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.37,
      y1: 15.1,
      x2: 19.37,
      y2: 15.11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.94,
      y1: 11,
      x2: 19.94,
      y2: 11.01
    }));
  }

  function IconRotateClockwise2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rotate-clockwise-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5.63,
      y1: 7.16,
      x2: 5.63,
      y2: 7.17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.06,
      y1: 11,
      x2: 4.06,
      y2: 11.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.63,
      y1: 15.1,
      x2: 4.63,
      y2: 15.11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.16,
      y1: 18.37,
      x2: 7.16,
      y2: 18.38
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 19.94,
      x2: 11,
      y2: 19.95
    }));
  }

  function IconRotateClockwise(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rotate-clockwise",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"
    }));
  }

  function IconRotateRectangle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rotate-rectangle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.3 5h.7a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h5l-2.82 -2.82m0 5.64l2.82 -2.82",
      transform: "rotate(-45 12 12)"
    }));
  }

  function IconRotate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rotate",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
    }));
  }

  function IconRoute(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-route",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 19h4.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h3.5"
    }));
  }

  function IconRouter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-router",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 13,
      width: 18,
      height: 8,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 17,
      x2: 17,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 17,
      x2: 13,
      y2: 17.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 13,
      x2: 15,
      y2: 11
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.75 8.75a4 4 0 0 1 6.5 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.5 6.5a8 8 0 0 1 13 0"
    }));
  }

  function IconRowInsertBottom(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-row-insert-bottom",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 15,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 17,
      x2: 10,
      y2: 17
    }));
  }

  function IconRowInsertTop(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-row-insert-top",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9v-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 7,
      x2: 14,
      y2: 7
    }));
  }

  function IconRss(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-rss",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4a16 16 0 0 1 16 16"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 11a9 9 0 0 1 9 9"
    }));
  }

  function IconRuler2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ruler-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 3l4 4l-14 14l-4 -4z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 7l-1.5 -1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 10l-1.5 -1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13l-1.5 -1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 16l-1.5 -1.5"
    }));
  }

  function IconRuler(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ruler",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 6,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 7,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 16,
      x2: 6,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 4,
      x2: 8,
      y2: 6
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 4 12 7 "
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 4 16 6 "
    }));
  }

  function IconRun(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-run",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 13,
      cy: 4,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 17l5 1l.75 -1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 21l0 -4l-4 -3l1 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 12l0 -3l5 -1l3 3l3 1"
    }));
  }

  function IconSailboat(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sailboat",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18l-1 -3h18l-1 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 12h7l-7 -9v9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 7,
      x2: 6,
      y2: 12
    }));
  }

  function IconSatellite(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-satellite",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10l-3 3l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6l3 -3l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 13.5,
      y2: 13.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 21a6 6 0 0 0 6 -6"
    }));
  }

  function IconScale(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-scale",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 6l6 -1l6 1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0"
    }));
  }

  function IconScan(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-scan",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 7v-1a2 2 0 0 1 2 -2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 17v1a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h2a2 2 0 0 0 2 -2v-1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }));
  }

  function IconSchool(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-school",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 9l-10 -4l-10 4l10 4l10 -4v6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"
    }));
  }

  function IconScissors(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-scissors",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 7,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.6,
      y1: 8.6,
      x2: 19,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.6,
      y1: 15.4,
      x2: 19,
      y2: 5
    }));
  }

  function IconScooterElectric(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-scooter-electric",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l-2 4h3l-2 4"
    }));
  }

  function IconScooter(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-scooter",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
    }));
  }

  function IconScreenShareOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-screen-share-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 9,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 8l4 -4m-4 0l4 4"
    }));
  }

  function IconScreenShare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-screen-share",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 20,
      x2: 17,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 16,
      x2: 9,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 16,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4h4v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 9l5 -5"
    }));
  }

  function IconScubaMask(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-scuba-mask",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 7h12a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1 -2.5 2.5h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 17a2 2 0 0 0 2 2h3.5a5.5 5.5 0 0 0 5.5 -5.5v-9.5"
    }));
  }

  function IconSearch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-search",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10,
      cy: 10,
      r: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 21,
      x2: 15,
      y2: 15
    }));
  }

  function IconSection(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-section",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 20h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 20h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 20h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 20h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 4h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 4h.01"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4l0 0"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 8,
      width: 16,
      height: 8,
      rx: 1
    }));
  }

  function IconSeeding(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-seeding",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 10
    }));
  }

  function IconSelect(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-select",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 11l3 3l3 -3"
    }));
  }

  function IconSelector(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-selector",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 9 12 5 16 9"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 15 12 19 8 15"
    }));
  }

  function IconSend(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-send",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 14,
      x2: 21,
      y2: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
    }));
  }

  function IconSeparatorHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-separator-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 8 12 4 16 8"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 16 12 20 8 16"
    }));
  }

  function IconSeparatorVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-separator-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 20
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 8 4 12 8 16"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 16 20 12 16 8"
    }));
  }

  function IconSeparator(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-separator",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 3,
      y2: 12.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 17,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 12,
      x2: 21,
      y2: 12.01
    }));
  }

  function IconServer(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-server",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 8,
      rx: 3
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 12,
      width: 18,
      height: 8,
      rx: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 8,
      x2: 7,
      y2: 8.01
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 16,
      x2: 7,
      y2: 16.01
    }));
  }

  function IconServicemark(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-servicemark",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 15v-6l3 4l3 -4v6"
    }));
  }

  function IconSettingsAutomation(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-settings-automation",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 9v6l5 -3z"
    }));
  }

  function IconSettings(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-settings",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }));
  }

  function IconShadowOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shadow-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 12h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 15h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 18h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 9h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 6h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconShadow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shadow",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 12h5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 15h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 18h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 9h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 6h1"
    }));
  }

  function IconShape2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shape-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.5 17.5l11 -11m-12.5 .5v10m14 -10v10"
    }));
  }

  function IconShape3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shape-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 5h10m-12 2v10m14 -10v10"
    }));
  }

  function IconShape(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shape",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 7,
      x2: 5,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 5,
      x2: 17,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 19,
      x2: 17,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 7,
      x2: 19,
      y2: 17
    }));
  }

  function IconShare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-share",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 6,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 18,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.7,
      y1: 10.7,
      x2: 15.3,
      y2: 7.3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8.7,
      y1: 13.3,
      x2: 15.3,
      y2: 16.7
    }));
  }

  function IconShieldCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shield-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12l2 2l4 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }));
  }

  function IconShieldLock(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shield-lock",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 11,
      r: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 14.5
    }));
  }

  function IconShieldOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shield-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.669 17.669a12 12 0 0 1 -5.669 3.331a12 12 0 0 1 -8.5 -15c.797 .036 1.589 0 2.366 -.126m3.092 -.912a12 12 0 0 0 3.042 -1.962a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.117 9.379"
    }));
  }

  function IconShieldX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shield-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l4 4m0 -4l-4 4"
    }));
  }

  function IconShield(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shield",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }));
  }

  function IconShip(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ship",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18l-1 -5h18l-2 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 13v-6h8l4 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 7v-4h-1"
    }));
  }

  function IconShirt(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shirt",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
    }));
  }

  function IconShoppingCartDiscount(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shopping-cart-discount",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-11v-14h-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6l-1 7h-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l6 -6"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10.5,
      cy: 4.5,
      r: 0.5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15.5,
      cy: 9.5,
      r: 0.5
    }));
  }

  function IconShoppingCartOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shopping-cart-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17a2 2 0 1 0 2 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-11v-11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconShoppingCartPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shopping-cart-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-11v-14h-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 5l6.005 .429m7.138 6.573l-.143 .998h-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 6h6m-3 -3v6"
    }));
  }

  function IconShoppingCartX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shopping-cart-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-11v-14h-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 5l7.999 .571m5.43 4.43l-.429 2.999h-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 3l4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 3l-4 4"
    }));
  }

  function IconShoppingCart(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shopping-cart",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 17h-11v-14h-2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 5l14 1l-1 7h-13"
    }));
  }

  function IconShredder(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-shredder",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 10,
      width: 16,
      height: 5,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 10v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4m5 5v5m4 -5v2m-8 -2v3"
    }));
  }

  function IconSignature(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-signature",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2"
    }));
  }

  function IconSitemap(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sitemap",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 15,
      width: 6,
      height: 6,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 15,
      y: 15,
      width: 6,
      height: 6,
      rx: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 9,
      y: 3,
      width: 6,
      height: 6,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 12
    }));
  }

  function IconSkateboard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-skateboard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 15,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 15,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1"
    }));
  }

  function IconSlice(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-slice",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4"
    }));
  }

  function IconSlideshow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-slideshow",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 6,
      x2: 15.01,
      y2: 6
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 3,
      width: 18,
      height: 14,
      rx: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 13l4 -4a3 5 0 0 1 3 0l4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 12l2 -2a3 5 0 0 1 3 0l3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 8.01,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12.01,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 21,
      x2: 16.01,
      y2: 21
    }));
  }

  function IconSmartHome(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-smart-home",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 15c-2.21 1.333 -5.792 1.333 -8 0"
    }));
  }

  function IconSmokingNo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-smoking-no",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 13,
      x2: 8,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 13h3a1 1 0 0 1 1 1v2c0 .28 -.115 .533 -.3 .714m-3.7 .286h-13a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h9"
    }));
  }

  function IconSmoking(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-smoking",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 13,
      width: 18,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 13,
      x2: 8,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
    }));
  }

  function IconSnowflake(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-snowflake",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
      transform: "rotate(60 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
      transform: "rotate(120 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
      transform: "rotate(180 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
      transform: "rotate(240 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
      transform: "rotate(300 12 12)"
    }));
  }

  function IconSoccerField(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-soccer-field",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9h3v6h-3z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 9h3v6h-3z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 5,
      width: 18,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }));
  }

  function IconSocial(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-social",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 19,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 7,
      x2: 12,
      y2: 11
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6.7,
      y1: 17.8,
      x2: 9.5,
      y2: 15.8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17.3,
      y1: 17.8,
      x2: 14.5,
      y2: 15.8
    }));
  }

  function IconSock(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sock",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 3v6l4.798 5.142a4 4 0 0 1 -5.441 5.86l-6.736 -6.41a2 2 0 0 1 -.621 -1.451v-9.141h8z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.895 15.768c.708 -.721 1.105 -1.677 1.105 -2.768a4 4 0 0 0 -4 -4"
    }));
  }

  function IconSortAscending2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sort-ascending-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 9l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 5,
      width: 5,
      height: 5,
      rx: 0.5
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 14,
      width: 5,
      height: 5,
      rx: 0.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 6v12"
    }));
  }

  function IconSortAscending(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sort-ascending",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 11,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 11,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 13,
      y2: 18
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 9 18 6 21 9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 6,
      x2: 18,
      y2: 18
    }));
  }

  function IconSortDescending2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sort-descending-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 5,
      width: 5,
      height: 5,
      rx: 0.5
    }), /*#__PURE__*/React.createElement("rect", {
      x: 5,
      y: 14,
      width: 5,
      height: 5,
      rx: 0.5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15l3 3l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 18v-12"
    }));
  }

  function IconSortDescending(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sort-descending",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 13,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 11,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 11,
      y2: 18
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 15 18 18 21 15"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 6,
      x2: 18,
      y2: 18
    }));
  }

  function IconSpace(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-space",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3"
    }));
  }

  function IconSpeakerphone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-speakerphone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 8a3 3 0 0 1 0 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8h0l4.524 -3.77a0.9 .9 0 0 1 1.476 .692v12.156a0.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"
    }));
  }

  function IconSpeedboat(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-speedboat",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h13.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h0h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-3.73h0h-1l-1.5 4z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 13,
      x2: 7.5,
      y2: 8
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 8h8l2 3"
    }));
  }

  function IconSportBillard(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sport-billard",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 8
    }));
  }

  function IconSquare0(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-0",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 16v-8l-2 2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 -.001"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12a2 2 0 1 0 -2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a2 2 0 1 0 2 -2"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 16v-8l-4 6h5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare5(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-5",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare6(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-6",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      transform: "rotate(180 12 14)",
      cx: 12,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10a2 2 0 1 0 -4 0v4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare7(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-7",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 8h4l-2 8"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare8(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-8",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 14,
      r: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquare9(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-9",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 10,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a2 2 0 1 0 4 0v-4"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquareCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 12l2 2l4 -4"
    }));
  }

  function IconSquareDot(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-dot",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }));
  }

  function IconSquareForbid2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-forbid-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 15,
      x2: 15,
      y2: 9
    }));
  }

  function IconSquareForbid(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-forbid",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 9,
      x2: 15,
      y2: 15
    }));
  }

  function IconSquareMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }));
  }

  function IconSquareOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a1.994 1.994 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconSquarePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 12,
      x2: 15,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 9,
      x2: 12,
      y2: 15
    }));
  }

  function IconSquareRoot2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-root-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 12h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 19c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h1l3 8l3 -16h10"
    }));
  }

  function IconSquareRoot(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-root",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h2l4 8l4 -16h8"
    }));
  }

  function IconSquareRotatedOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-rotated-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.964 16.952l-3.462 3.461c-.782 .783 -2.222 .783 -3.004 0l-6.911 -6.91c-.783 -.783 -.783 -2.223 0 -3.005l3.455 -3.456m2.003 -2.003l1.453 -1.452c.782 -.783 2.222 -.783 3.004 0l6.911 6.91c.783 .783 .783 2.223 0 3.005l-1.448 1.45"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconSquareRotated(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-rotated",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
    }));
  }

  function IconSquareToggleHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-toggle-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M22 12h-20"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20a2 2 0 0 0 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18a2 2 0 0 0 2 2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 20,
      x2: 10,
      y2: 20
    }));
  }

  function IconSquareToggle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-toggle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 2,
      x2: 12,
      y2: 22
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6a2 2 0 0 0 -2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20a2 2 0 0 0 2 -2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 10,
      x2: 20,
      y2: 14
    }));
  }

  function IconSquareX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 10l4 4m0 -4l-4 4"
    }));
  }

  function IconSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }));
  }

  function IconSquaresDiagonal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-squares-diagonal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 8,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.586 19.414l10.827 -10.827"
    }));
  }

  function IconSquaresFilled(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-squares-filled",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 8,
      y: 8,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 14.5l6.492 -6.492"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.496 20.004l6.504 -6.504l-6.504 6.504z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.586 19.414l10.827 -10.827"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }));
  }

  function IconStack2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stack-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6l-8 4l8 4l8 -4l-8 -4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 14l8 4l8 -4"
    }));
  }

  function IconStack(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stack",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 4 4 8 12 12 20 8 12 4"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "4 12 12 16 20 12"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "4 16 12 20 20 16"
    }));
  }

  function IconStairsDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stairs-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20h4v-4h4v-4h4v-4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 4l-7 7v-4m4 4h-4"
    }));
  }

  function IconStairsUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stairs-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 20h4v-4h4v-4h4v-4h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 11l7 -7v4m-4 -4h4"
    }));
  }

  function IconStairs(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stairs",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 18h4v-4h4v-4h4v-4h4"
    }));
  }

  function IconStarHalf(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-star-half",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253z"
    }));
  }

  function IconStarOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-star-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.012 6.016l1.981 -4.014l3.086 6.253l6.9 1l-4.421 4.304m.012 4.01l.588 3.426l-6.158 -3.245l-6.172 3.245l1.179 -6.873l-5 -4.867l6.327 -.917"
    }));
  }

  function IconStar(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-star",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
    }));
  }

  function IconStars(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stars",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.8 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.2 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }));
  }

  function IconSteeringWheel(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-steering-wheel",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 12,
      x2: 3.25,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 20.75,
      y2: 10
    }));
  }

  function IconStepInto(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-step-into",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 11,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 11,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 20,
      r: 1
    }));
  }

  function IconStepOut(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-step-out",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 7,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 7,
      x2: 12,
      y2: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 20,
      r: 1
    }));
  }

  function IconStethoscope(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-stethoscope",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 15a6 6 0 1 0 12 0v-3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 3v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 3v2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 20,
      cy: 10,
      r: 2
    }));
  }

  function IconSticker(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sticker",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12a8 8 0 1 1 -8 -8"
    }));
  }

  function IconStrikethrough(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-strikethrough",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 5v9a5 5 0 0 0 10 0v-9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h16"
    }));
  }

  function IconSubmarine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-submarine",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 11v6h2l1 -1.5l3 1.5h10a3 3 0 0 0 0 -6h-10h0l-3 1.5l-1 -1.5h-2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 11l-1 -3h-5l-1 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 8v-2a1 1 0 0 1 1 -1h1"
    }));
  }

  function IconSubscript(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-subscript",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7l8 10m-8 0l8 -10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
    }));
  }

  function IconSubtask(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-subtask",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 9,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 5,
      x2: 8,
      y2: 5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 5v11a1 1 0 0 0 1 1h5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 12,
      y: 7,
      width: 8,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 12,
      y: 15,
      width: 8,
      height: 4,
      rx: 1
    }));
  }

  function IconSum(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sum",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2"
    }));
  }

  function IconSunOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sun-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 12a4 4 0 0 0 -4 -4m-2.834 1.177a4 4 0 0 0 5.66 5.654"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
    }));
  }

  function IconSun(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sun",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
    }));
  }

  function IconSunset(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sunset",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 9v-6l3 3m-6 0l3 -3"
    }));
  }

  function IconSunshine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-sunshine",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 21,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3v6l3 -3m-6 0l3 3"
    }));
  }

  function IconSuperscript(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-superscript",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7l8 10m-8 0l8 -10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
    }));
  }

  function IconSwimming(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-swimming",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16,
      cy: 9,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 11l4 -2l3.5 3l-1.5 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"
    }));
  }

  function IconSwitch2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-switch-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h5l1.67 -2.386m3.66 -5.227l1.67 -2.387h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 4l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7h5l7 10h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20l3 -3l-3 -3"
    }));
  }

  function IconSwitch3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-switch-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 4l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 20l3 -3l-3 -3"
    }));
  }

  function IconSwitchHorizontal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-switch-horizontal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 3 20 7 16 11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "8 13 4 17 8 21"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 17,
      x2: 13,
      y2: 17
    }));
  }

  function IconSwitchVertical(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-switch-vertical",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 8 7 4 11 8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 7,
      y2: 13
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "13 16 17 20 21 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 10,
      x2: 17,
      y2: 20
    }));
  }

  function IconSwitch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-switch",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 4 19 4 19 8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.75,
      y1: 9.25,
      x2: 19,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 19,
      x2: 9,
      y2: 15
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "15 19 19 19 19 15"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 5,
      x2: 19,
      y2: 19
    }));
  }

  function IconTableExport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-table-export",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7.5m-16 -3.5h16m-10 -6v16m4 -1h7m-3 -3l3 3l-3 3"
    }));
  }

  function IconTableImport(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-table-import",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 13.5v-7.5a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6m-8 -10h16m-10 -6v11.5m-8 3.5h7m-3 -3l3 3l-3 3"
    }));
  }

  function IconTableOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-table-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 4h10a2 2 0 0 1 2 2v10m-.588 3.417c-.362 .36 -.86 .583 -1.412 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.053 .586 -1.414"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 10h6m4 0h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 4v2m0 4v10"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconTable(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-table",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 16,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 10,
      x2: 20,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 4,
      x2: 10,
      y2: 20
    }));
  }

  function IconTag(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tag",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 3l9 9a1.5 1.5 0 0 1 0 2l-6 6a1.5 1.5 0 0 1 -2 0l-9 -9v-4a4 4 0 0 1 4 -4h4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 9,
      r: 2
    }));
  }

  function IconTallymark1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tallymark-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }));
  }

  function IconTallymark2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tallymark-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 5,
      x2: 10,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 5,
      x2: 14,
      y2: 19
    }));
  }

  function IconTallymark3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tallymark-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 5,
      x2: 8,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 5,
      x2: 12,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 5,
      x2: 16,
      y2: 19
    }));
  }

  function IconTallymark4(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tallymark-4",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 5,
      x2: 6,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 5,
      x2: 10,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 5,
      x2: 14,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 5,
      x2: 18,
      y2: 19
    }));
  }

  function IconTallymarks(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tallymarks",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 5,
      x2: 6,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 5,
      x2: 10,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 5,
      x2: 14,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 5,
      x2: 18,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 17,
      x2: 21,
      y2: 7
    }));
  }

  function IconTank(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tank",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 12,
      width: 18,
      height: 6,
      rx: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12l1 -5h5l3 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 9,
      x2: 13.2,
      y2: 9
    }));
  }

  function IconTarget(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-target",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }));
  }

  function IconTemperatureCelsius(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-temperature-celsius",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 8,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 9a3 3 0 0 0 -3 -3h-1a3 3 0 0 0 -3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3"
    }));
  }

  function IconTemperatureFahrenheit(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-temperature-fahrenheit",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 8,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 12,
      x2: 18,
      y2: 12
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6h-6a1 1 0 0 0 -1 1v11"
    }));
  }

  function IconTemperatureMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-temperature-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 9,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 9,
      x2: 22,
      y2: 9
    }));
  }

  function IconTemperaturePlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-temperature-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 9,
      x2: 12,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 9,
      x2: 22,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 6,
      x2: 19,
      y2: 12
    }));
  }

  function IconTemperature(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-temperature",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 9,
      x2: 14,
      y2: 9
    }));
  }

  function IconTemplate(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-template",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 4,
      width: 16,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 12,
      width: 6,
      height: 8,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 12,
      x2: 20,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 16,
      x2: 20,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 20,
      x2: 20,
      y2: 20
    }));
  }

  function IconTent(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tent",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11 14l4 6h6l-9 -16l-9 16h6l4 -6"
    }));
  }

  function IconTerminal2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-terminal-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 9l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 15,
      x2: 16,
      y2: 15
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 4,
      width: 18,
      height: 16,
      rx: 2
    }));
  }

  function IconTerminal(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-terminal",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7l5 5l-5 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 19,
      x2: 19,
      y2: 19
    }));
  }

  function IconTestPipe(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-test-pipe",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4l3 3l-12.35 12.35a1.5 1.5 0 0 1 -3 -3l12.35 -12.35"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 10,
      x2: 16,
      y2: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6"
    }));
  }

  function IconTextDirectionLtr(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-text-direction-ltr",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 21l2 -2l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15v-11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 15v-11"
    }));
  }

  function IconTextDirectionRtl(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-text-direction-rtl",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 15v-11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 15v-11"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 21l-2 -2l2 -2"
    }));
  }

  function IconTextWrapDisabled(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-text-wrap-disabled",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 14,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 14,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h17l-3 -3m0 6l3 -3"
    }));
  }

  function IconTextWrap(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-text-wrap",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 6,
      x2: 20,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 18,
      x2: 9,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"
    }));
  }

  function IconThumbDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-thumb-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
    }));
  }

  function IconThumbUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-thumb-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
    }));
  }

  function IconTicket(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-ticket",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 5,
      x2: 15,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 11,
      x2: 15,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 17,
      x2: 15,
      y2: 19
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
    }));
  }

  function IconTiltShift(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tilt-shift",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 2
    }));
  }

  function IconTir(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tir",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18h8m4 0h2v-6a5 7 0 0 0 -5 -7h-1l1.5 7h4.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 18v-13h3"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 17 3 12 12 12"
    }));
  }

  function IconToggleLeft(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-toggle-left",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 8,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 6,
      width: 20,
      height: 12,
      rx: 6
    }));
  }

  function IconToggleRight(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-toggle-right",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16,
      cy: 12,
      r: 2
    }), /*#__PURE__*/React.createElement("rect", {
      x: 2,
      y: 6,
      width: 20,
      height: 12,
      rx: 6
    }));
  }

  function IconTool(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tool",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
    }));
  }

  function IconToolsKitchen2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tools-kitchen-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3"
    }));
  }

  function IconToolsKitchen(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tools-kitchen",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 3h8l-1 9h-6z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 18h2v3h-2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 15v6h-1v-3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 12,
      x2: 8,
      y2: 18
    }));
  }

  function IconTools(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tools",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14.5,
      y1: 5.5,
      x2: 18.5,
      y2: 9.5
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "12 8 7 3 3 7 8 12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 8,
      x2: 5.5,
      y2: 9.5
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "16 12 21 17 17 21 12 16"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 17,
      x2: 14.5,
      y2: 18.5
    }));
  }

  function IconTornado(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tornado",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 4,
      x2: 3,
      y2: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 16,
      x2: 7,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 11,
      y1: 20,
      x2: 15,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 8,
      x2: 20,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 12,
      x2: 16,
      y2: 12
    }));
  }

  function IconTournament(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tournament",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 7h4a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-4"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 12,
      x2: 20,
      y2: 12
    }));
  }

  function IconTrack(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-track",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7"
    }));
  }

  function IconTractor(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tractor",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 15,
      r: 4
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 15,
      x2: 7,
      y2: 15.01
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10.5,
      y1: 17,
      x2: 17,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 5h-1a1 1 0 0 0 -1 1v4"
    }));
  }

  function IconTrademark(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trademark",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4.5 9h5m-2.5 0v6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 15v-6l3 4l3 -4v6"
    }));
  }

  function IconTrafficCone(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-traffic-cone",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9.4,
      y1: 10,
      x2: 14.6,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7.8,
      y1: 15,
      x2: 16.2,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 20l5 -15h2l5 15"
    }));
  }

  function IconTrafficLights(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-traffic-lights",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 7,
      y: 2,
      width: 10,
      height: 20,
      rx: 5
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 17,
      r: 1
    }));
  }

  function IconTrain(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-train",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 15h16a2 2 0 0 0 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6v5h17.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 10,
      x2: 3,
      y2: 14
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 11,
      x2: 8,
      y2: 6
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 11,
      x2: 13,
      y2: 6.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 19,
      x2: 21,
      y2: 19
    }));
  }

  function IconTrashOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trash-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 7h3m4 0h9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 10,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 14,
      x2: 14,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18.384,
      y1: 14.373,
      x2: 19,
      y2: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
    }));
  }

  function IconTrash(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trash",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 7,
      x2: 20,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 11,
      x2: 10,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 11,
      x2: 14,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
    }));
  }

  function IconTree(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-tree",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 13l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12l2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21v-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h.001h-4z"
    }));
  }

  function IconTrees(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trees",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 21,
      x2: 15,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 13l-2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12l2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 21v-13"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h.001h-4z"
    }));
  }

  function IconTrendingDown2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trending-down-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h5l7 10h6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19l3 -3l-3 -3"
    }));
  }

  function IconTrendingDown3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trending-down-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19l3 -3l-3 -3"
    }));
  }

  function IconTrendingDown(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trending-down",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 7 9 13 13 9 21 17"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "21 10 21 17 14 17"
    }));
  }

  function IconTrendingUp2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trending-up-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 5l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h5l7 -10h6"
    }));
  }

  function IconTrendingUp3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trending-up-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 5l3 3l-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18h2.397a5 5 0 0 0 4.096 -2.133l4.014 -5.734a5 5 0 0 1 4.096 -2.133h3.397"
    }));
  }

  function IconTrendingUp(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trending-up",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "3 17 9 11 13 15 21 7"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "14 7 21 7 21 14"
    }));
  }

  function IconTriangleOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-triangle-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14m1.986 -2.014a2 2 0 0 0 -.146 -.736l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.825 1.424m-1.467 2.53l-4.808 8.296a2 2 0 0 0 1.75 2.75"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3l18 18"
    }));
  }

  function IconTriangleSquareCircle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-triangle-square-circle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3l-4 7h8z"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 3
    }), /*#__PURE__*/React.createElement("rect", {
      x: 4,
      y: 14,
      width: 6,
      height: 6,
      rx: 1
    }));
  }

  function IconTriangle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-triangle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }));
  }

  function IconTrident(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trident",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21v-18l-2 2m4 0l-2 -2"
    }));
  }

  function IconTrophy(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-trophy",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 21,
      x2: 16,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 17,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4,
      x2: 17,
      y2: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 4v8a5 5 0 0 1 -10 0v-8"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 5,
      cy: 9,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 9,
      r: 2
    }));
  }

  function IconTruckDelivery(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-truck-delivery",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 9,
      x2: 7,
      y2: 9
    }));
  }

  function IconTruckOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-truck-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.585 15.586a2 2 0 0 0 2.826 2.831"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconTruckReturn(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-truck-return",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 17,
      x2: 15,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 6h5l3 5v6h-2"
    }));
  }

  function IconTruck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-truck",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 7,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
    }));
  }

  function IconTypography(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-typography",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 7,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 14,
      y1: 20,
      x2: 21,
      y2: 20
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6.9,
      y1: 15,
      x2: 13.8,
      y2: 15
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10.2,
      y1: 6.3,
      x2: 16,
      y2: 20
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "5 20 11 4 13 4 20 20"
    }));
  }

  function IconUmbrella(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-umbrella",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 12a8 8 0 0 1 16 0z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12v6a2 2 0 0 0 4 0"
    }));
  }

  function IconUnderline(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-underline",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 5v5a5 5 0 0 0 10 0v-5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 19h14"
    }));
  }

  function IconUnlink(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-unlink",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 21,
      x2: 16,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 16,
      x2: 21,
      y2: 16
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 8,
      x2: 5,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 3,
      x2: 8,
      y2: 5
    }));
  }

  function IconUpload(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-upload",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "7 9 12 4 17 9"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 4,
      x2: 12,
      y2: 16
    }));
  }

  function IconUrgent(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-urgent",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16v-4a4 4 0 0 1 8 0v4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 6,
      y: 16,
      width: 12,
      height: 4,
      rx: 1
    }));
  }

  function IconUserCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 11l2 2l4 -4"
    }));
  }

  function IconUserExclamation(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user-exclamation",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 7,
      x2: 19,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 14,
      x2: 19,
      y2: 14.01
    }));
  }

  function IconUserMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 16,
      y1: 11,
      x2: 22,
      y2: 11
    }));
  }

  function IconUserOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.274 10.291a4 4 0 1 0 -5.554 -5.58m-.548 3.453a4.01 4.01 0 0 0 2.62 2.65"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 1.147 .167m2.685 2.681a4 4 0 0 1 .168 1.152v2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconUserPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 11h6m-3 -3v6"
    }));
  }

  function IconUserX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 9l4 4m0 -4l-4 4"
    }));
  }

  function IconUser(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-user",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }));
  }

  function IconUsers(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-users",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 3.13a4 4 0 0 1 0 7.75"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 21v-2a4 4 0 0 0 -3 -3.85"
    }));
  }

  function IconVaccine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-vaccine",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 3l4 4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 5l-4.5 4.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 6.5l6 6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.5 11.5l-6.5 6.5h-4v-4l6.5 -6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.5 12.5l1.5 1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.5 9.5l1.5 1.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21l3 -3"
    }));
  }

  function IconVariable(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-variable",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }));
  }

  function IconVectorBeizer2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-vector-beizer-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 3,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 17,
      y: 17,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 5,
      x2: 14,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 19,
      x2: 17,
      y2: 19
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 9,
      cy: 19,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 15,
      cy: 5,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"
    }));
  }

  function IconVectorBeizer(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-vector-beizer",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 14,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 17,
      y: 14,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 6,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 8.5a6 6 0 0 0 -5 5.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 8.5a6 6 0 0 1 5 5.5"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 8,
      x2: 4,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 20,
      y1: 8,
      x2: 14,
      y2: 8
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 3,
      cy: 8,
      r: 1
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 21,
      cy: 8,
      r: 1
    }));
  }

  function IconVectorTriangle(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-vector-triangle",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 4,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 17,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 17,
      y: 17,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6.5,
      y1: 17.1,
      x2: 11.5,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17.5,
      y1: 17.1,
      x2: 12.5,
      y2: 8
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 19,
      x2: 17,
      y2: 19
    }));
  }

  function IconVector(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-vector",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 3,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 17,
      y: 3,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 17,
      y: 17,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 17,
      width: 4,
      height: 4,
      rx: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 7,
      x2: 5,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19,
      y1: 7,
      x2: 19,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 5,
      x2: 17,
      y2: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 19,
      x2: 17,
      y2: 19
    }));
  }

  function IconVenus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-venus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 9,
      r: 5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 14,
      x2: 12,
      y2: 21
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 18,
      x2: 15,
      y2: 18
    }));
  }

  function IconVersions(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-versions",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 10,
      y: 5,
      width: 10,
      height: 14,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 7,
      x2: 7,
      y2: 17
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 8,
      x2: 4,
      y2: 16
    }));
  }

  function IconVideoMinus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-video-minus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 6,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 11,
      y2: 12
    }));
  }

  function IconVideoOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-video-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 11v-1l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -.675 .946"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 6h3a2 2 0 0 1 2 2v3m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
    }));
  }

  function IconVideoPlus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-video-plus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 6,
      width: 12,
      height: 12,
      rx: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 12,
      x2: 11,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 9,
      y1: 10,
      x2: 9,
      y2: 14
    }));
  }

  function IconVideo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-video",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: 3,
      y: 6,
      width: 12,
      height: 12,
      rx: 2
    }));
  }

  function IconView360(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-view-360",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 12,
      cy: 12,
      rx: 4,
      ry: 9
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: 12,
      cy: 12,
      rx: 4,
      ry: 9,
      transform: "rotate(90 12 12)"
    }));
  }

  function IconViewfinder(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-viewfinder",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 7,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 12,
      x2: 18,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 12,
      x2: 12,
      y2: 12.01
    }));
  }

  function IconViewportNarrow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-viewport-narrow",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h7l-3 -3m0 6l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12h-7l3 -3m0 6l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 6v-3h6v3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 18v3h6v-3"
    }));
  }

  function IconViewportWide(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-viewport-wide",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 12h-7l3 -3m0 6l-3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 12h7l-3 -3m0 6l3 -3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 6v-3h18v3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 18v3h18v-3"
    }));
  }

  function IconVirusOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-virus-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.469 8.46a5 5 0 0 0 7.058 7.084m1.386 -2.608a5 5 0 0 0 -5.826 -5.853"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(45 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(90 12 12)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 13,
      y2: 3,
      transform: "rotate(135 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(180 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(225 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(270 12 12)"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 11,
      y2: 3,
      transform: "rotate(315 12 12)"
    }));
  }

  function IconVirusSearch(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-virus-search",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 12a5 5 0 1 0 -5 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(45 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(90 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(180 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(225 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(270 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(315 12 12)"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 17.5,
      cy: 17.5,
      r: 2.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 19.5,
      y1: 19.5,
      x2: 22,
      y2: 22
    }));
  }

  function IconVirus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-virus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 5
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(45 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(90 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(135 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(180 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(225 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(270 12 12)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7v-4m-1 0h2",
      transform: "rotate(315 12 12)"
    }));
  }

  function IconVolume2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-volume-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 8a5 5 0 0 1 0 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
    }));
  }

  function IconVolume3(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-volume-3",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 10l4 4m0 -4l-4 4"
    }));
  }

  function IconVolume(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-volume",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 8a5 5 0 0 1 0 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.7 5a9 9 0 0 1 0 14"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
    }));
  }

  function IconWalk(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-walk",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 13,
      cy: 4,
      r: 1
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 21,
      x2: 10,
      y2: 17
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 21l-2 -4l-3 -3l1 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 12l2 -3l4 -1l3 3l3 1"
    }));
  }

  function IconWallet(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wallet",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 12v4h-4a2 2 0 0 1 0 -4h4"
    }));
  }

  function IconWand(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wand",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("polyline", {
      points: "6 21 21 6 18 3 3 18 6 21"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 15,
      y1: 6,
      x2: 18,
      y2: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }));
  }

  function IconWaveSawTool(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wave-saw-tool",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h5l4 8v-16l4 8h5"
    }));
  }

  function IconWaveSine(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wave-sine",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2"
    }));
  }

  function IconWaveSquare(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wave-square",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h5v8h4v-16h4v8h5"
    }));
  }

  function IconWifi0(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wifi-0",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12.01,
      y2: 18
    }));
  }

  function IconWifi1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wifi-1",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12.01,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.172 15.172a4 4 0 0 1 5.656 0"
    }));
  }

  function IconWifi2(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wifi-2",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12.01,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.172 15.172a4 4 0 0 1 5.656 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.343 12.343a8 8 0 0 1 11.314 0"
    }));
  }

  function IconWifiOff(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wifi-off",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12.01,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.172 15.172a4 4 0 0 1 5.656 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 3,
      x2: 21,
      y2: 21
    }));
  }

  function IconWifi(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wifi",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 12.01,
      y2: 18
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.172 15.172a4 4 0 0 1 5.656 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.343 12.343a8 8 0 0 1 11.314 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
    }));
  }

  function IconWind(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wind",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
    }));
  }

  function IconWindmill(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-windmill",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12c2.76 0 5 -2.01 5 -4.5s-2.24 -4.5 -5 -4.5v9z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12c0 2.76 2.01 5 4.5 5s4.5 -2.24 4.5 -5h-9z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12c0 -2.76 -2.01 -5 -4.5 -5s-4.5 2.24 -4.5 5h9z"
    }));
  }

  function IconWindow(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-window",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3c-3.866 0 -7 3.272 -7 7v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-10c0 -3.728 -3.134 -7 -7 -7z"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 13,
      x2: 19,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }));
  }

  function IconWiperWash(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wiper-wash",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 20,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 20,
      x2: 12,
      y2: 6
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 6a4 4 0 0 1 .4 -1.8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 2.1a4 4 0 0 1 2 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6a4 4 0 0 0 -.4 -1.8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 6a4 4 0 0 1 .4 -1.8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 2.1a4 4 0 0 1 2 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 6a4 4 0 0 0 -.4 -1.8"
    }));
  }

  function IconWiper(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wiper",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 18,
      r: 1
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 9l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 18,
      x2: 9.8,
      y2: 5.2
    }));
  }

  function IconWoman(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-woman",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 5,
      r: 2
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
    }));
  }

  function IconWorldLatitude(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-world-latitude",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.6,
      y1: 7,
      x2: 19.4,
      y2: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3,
      y1: 12,
      x2: 21,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4.6,
      y1: 17,
      x2: 19.4,
      y2: 17
    }));
  }

  function IconWorldLongitude(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-world-longitude",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 3a11.2 11.2 0 0 0 0 18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.5 3a11.2 11.2 0 0 1 0 18"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 3,
      x2: 12,
      y2: 21
    }));
  }

  function IconWorld(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-world",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 9,
      x2: 20.4,
      y2: 9
    }), /*#__PURE__*/React.createElement("line", {
      x1: 3.6,
      y1: 15,
      x2: 20.4,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.5 3a17 17 0 0 0 0 18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.5 3a17 17 0 0 1 0 18"
    }));
  }

  function IconWreckingBall(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-wrecking-ball",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 19,
      cy: 13,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 4,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 13,
      cy: 17,
      r: 2
    }), /*#__PURE__*/React.createElement("line", {
      x1: 13,
      y1: 19,
      x2: 4,
      y2: 19
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 15,
      x2: 13,
      y2: 15
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 15v-2a1 1 0 0 1 1 -1h7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 11v-7l-6 7"
    }));
  }

  function IconWritingSign(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-writing-sign",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 7h4"
    }));
  }

  function IconWriting(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-writing",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 7h4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
    }));
  }

  function IconX(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-x",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 18,
      y1: 6,
      x2: 6,
      y2: 18
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6,
      y1: 6,
      x2: 18,
      y2: 18
    }));
  }

  function IconYinYang(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-yin-yang",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 7.5,
      r: 0.5,
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 16.5,
      r: 0.5,
      fill: "currentColor"
    }));
  }

  function IconZodiacAquarius(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-aquarius",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3"
    }));
  }

  function IconZodiacAries(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-aries",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 5a5 5 0 1 0 -4 8"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 13a5 5 0 1 0 -4 -8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 21,
      x2: 12,
      y2: 5
    }));
  }

  function IconZodiacCancer(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-cancer",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 18,
      cy: 12,
      r: 3
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 12a10 6.5 0 0 1 14 -6.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 12a10 6.5 0 0 1 -14 6.5"
    }));
  }

  function IconZodiacCapricorn(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-capricorn",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M4 4a3 3 0 0 1 3 3v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 16,
      cy: 17,
      r: 3
    }));
  }

  function IconZodiacGemini(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-gemini",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 3a21 21 0 0 0 18 0"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 21a21 21 0 0 1 18 0"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 4.5,
      x2: 7,
      y2: 19.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: 17,
      y1: 4.5,
      x2: 17,
      y2: 19.5
    }));
  }

  function IconZodiacLeo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-leo",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 17a4 4 0 1 0 8 0"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 6,
      cy: 16,
      r: 3
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 11,
      cy: 7,
      r: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 7c0 3 2 5 2 9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15 7c0 4 -2 6 -2 10"
    }));
  }

  function IconZodiacLibra(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-libra",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 20,
      x2: 19,
      y2: 20
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5"
    }));
  }

  function IconZodiacPisces(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-pisces",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 3a21 21 0 0 1 0 18"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19 3a21 21 0 0 0 0 18"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 5,
      y1: 12,
      x2: 19,
      y2: 12
    }));
  }

  function IconZodiacSagittarius(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-sagittarius",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 4,
      y1: 20,
      x2: 20,
      y2: 4
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13 4h7v7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: 6.5,
      y1: 12.5,
      x2: 11.5,
      y2: 17.5
    }));
  }

  function IconZodiacScorpio(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-scorpio",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 4a2 2 0 0 1 2 2v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 6a2 2 0 0 1 4 0v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 6a2 2 0 0 1 4 0v10a3 3 0 0 0 3 3h5l-3 -3m0 6l3 -3"
    }));
  }

  function IconZodiacTaurus(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-taurus",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6 3a6 6 0 0 0 12 0"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 12,
      cy: 15,
      r: 6
    }));
  }

  function IconZodiacVirgo(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zodiac-virgo",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 4a2 2 0 0 1 2 2v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5 6a2 2 0 0 1 4 0v9"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0"
    }));
  }

  function IconZoomCancel(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zoom-cancel",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10,
      cy: 10,
      r: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 8,
      y1: 8,
      x2: 12,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 12,
      y1: 8,
      x2: 8,
      y2: 12
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 21,
      x2: 15,
      y2: 15
    }));
  }

  function IconZoomCheck(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zoom-check",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10,
      cy: 10,
      r: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 21l-6 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 10l2 2l4 -4"
    }));
  }

  function IconZoomIn(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zoom-in",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10,
      cy: 10,
      r: 7
    }), /*#__PURE__*/React.createElement("line", {
      x1: 7,
      y1: 10,
      x2: 13,
      y2: 10
    }), /*#__PURE__*/React.createElement("line", {
      x1: 10,
      y1: 7,
      x2: 10,
      y2: 13
    }), /*#__PURE__*/React.createElement("line", {
      x1: 21,
      y1: 21,
      x2: 15,
      y2: 15
    }));
  }

  function IconZoomMoney(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$stroke = _ref.stroke,
        stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
        props = _objectWithoutProperties(_ref, ["size", "color", "stroke"]);

    return /*#__PURE__*/React.createElement("svg", _extends({
      className: "icon icon-tabler icon-tabler-zoom-money",
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      strokeWidth: stroke,
      stroke: color,
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: 10,
      cy: 10,
      r: 7
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21 21l-6 -6"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 7h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 13v1m0 -8v1"
    }));
  }

  exports.Icon2fa = Icon2fa;
  exports.Icon3dCubeSphere = Icon3dCubeSphere;
  exports.IconAB = IconAB;
  exports.IconAccessPoint = IconAccessPoint;
  exports.IconAccessPointOff = IconAccessPointOff;
  exports.IconAccessible = IconAccessible;
  exports.IconActivity = IconActivity;
  exports.IconAd = IconAd;
  exports.IconAdjustments = IconAdjustments;
  exports.IconAdjustmentsAlt = IconAdjustmentsAlt;
  exports.IconAdjustmentsHorizontal = IconAdjustmentsHorizontal;
  exports.IconAerialLift = IconAerialLift;
  exports.IconAffiliate = IconAffiliate;
  exports.IconAlarm = IconAlarm;
  exports.IconAlertCircle = IconAlertCircle;
  exports.IconAlertOctagon = IconAlertOctagon;
  exports.IconAlertTriangle = IconAlertTriangle;
  exports.IconAlien = IconAlien;
  exports.IconAlignCenter = IconAlignCenter;
  exports.IconAlignJustified = IconAlignJustified;
  exports.IconAlignLeft = IconAlignLeft;
  exports.IconAlignRight = IconAlignRight;
  exports.IconAmbulance = IconAmbulance;
  exports.IconAnchor = IconAnchor;
  exports.IconAntennaBars1 = IconAntennaBars1;
  exports.IconAntennaBars2 = IconAntennaBars2;
  exports.IconAntennaBars3 = IconAntennaBars3;
  exports.IconAntennaBars4 = IconAntennaBars4;
  exports.IconAntennaBars5 = IconAntennaBars5;
  exports.IconAperture = IconAperture;
  exports.IconApps = IconApps;
  exports.IconArchive = IconArchive;
  exports.IconArrowBack = IconArrowBack;
  exports.IconArrowBackUp = IconArrowBackUp;
  exports.IconArrowBarDown = IconArrowBarDown;
  exports.IconArrowBarLeft = IconArrowBarLeft;
  exports.IconArrowBarRight = IconArrowBarRight;
  exports.IconArrowBarToDown = IconArrowBarToDown;
  exports.IconArrowBarToLeft = IconArrowBarToLeft;
  exports.IconArrowBarToRight = IconArrowBarToRight;
  exports.IconArrowBarToUp = IconArrowBarToUp;
  exports.IconArrowBarUp = IconArrowBarUp;
  exports.IconArrowBigDown = IconArrowBigDown;
  exports.IconArrowBigLeft = IconArrowBigLeft;
  exports.IconArrowBigRight = IconArrowBigRight;
  exports.IconArrowBigTop = IconArrowBigTop;
  exports.IconArrowBottomBar = IconArrowBottomBar;
  exports.IconArrowBottomCircle = IconArrowBottomCircle;
  exports.IconArrowBottomSquare = IconArrowBottomSquare;
  exports.IconArrowBottomTail = IconArrowBottomTail;
  exports.IconArrowDown = IconArrowDown;
  exports.IconArrowDownCircle = IconArrowDownCircle;
  exports.IconArrowDownLeft = IconArrowDownLeft;
  exports.IconArrowDownLeftCircle = IconArrowDownLeftCircle;
  exports.IconArrowDownRight = IconArrowDownRight;
  exports.IconArrowDownRightCircle = IconArrowDownRightCircle;
  exports.IconArrowForward = IconArrowForward;
  exports.IconArrowForwardUp = IconArrowForwardUp;
  exports.IconArrowLeft = IconArrowLeft;
  exports.IconArrowLeftBar = IconArrowLeftBar;
  exports.IconArrowLeftCircle = IconArrowLeftCircle;
  exports.IconArrowLeftSquare = IconArrowLeftSquare;
  exports.IconArrowLeftTail = IconArrowLeftTail;
  exports.IconArrowLoopLeft = IconArrowLoopLeft;
  exports.IconArrowLoopRight = IconArrowLoopRight;
  exports.IconArrowNarrowDown = IconArrowNarrowDown;
  exports.IconArrowNarrowLeft = IconArrowNarrowLeft;
  exports.IconArrowNarrowRight = IconArrowNarrowRight;
  exports.IconArrowNarrowUp = IconArrowNarrowUp;
  exports.IconArrowRampLeft = IconArrowRampLeft;
  exports.IconArrowRampRight = IconArrowRampRight;
  exports.IconArrowRight = IconArrowRight;
  exports.IconArrowRightBar = IconArrowRightBar;
  exports.IconArrowRightCircle = IconArrowRightCircle;
  exports.IconArrowRightSquare = IconArrowRightSquare;
  exports.IconArrowRightTail = IconArrowRightTail;
  exports.IconArrowTopBar = IconArrowTopBar;
  exports.IconArrowTopCircle = IconArrowTopCircle;
  exports.IconArrowTopSquare = IconArrowTopSquare;
  exports.IconArrowTopTail = IconArrowTopTail;
  exports.IconArrowUp = IconArrowUp;
  exports.IconArrowUpCircle = IconArrowUpCircle;
  exports.IconArrowUpLeft = IconArrowUpLeft;
  exports.IconArrowUpLeftCircle = IconArrowUpLeftCircle;
  exports.IconArrowUpRight = IconArrowUpRight;
  exports.IconArrowUpRightCircle = IconArrowUpRightCircle;
  exports.IconArrowWaveLeftDown = IconArrowWaveLeftDown;
  exports.IconArrowWaveLeftUp = IconArrowWaveLeftUp;
  exports.IconArrowWaveRightDown = IconArrowWaveRightDown;
  exports.IconArrowWaveRightUp = IconArrowWaveRightUp;
  exports.IconArrowsDiagonal = IconArrowsDiagonal;
  exports.IconArrowsDiagonal2 = IconArrowsDiagonal2;
  exports.IconArrowsDoubleNeSw = IconArrowsDoubleNeSw;
  exports.IconArrowsDoubleNwSe = IconArrowsDoubleNwSe;
  exports.IconArrowsDoubleSeNw = IconArrowsDoubleSeNw;
  exports.IconArrowsDoubleSwNe = IconArrowsDoubleSwNe;
  exports.IconArrowsDown = IconArrowsDown;
  exports.IconArrowsDownUp = IconArrowsDownUp;
  exports.IconArrowsHorizontal = IconArrowsHorizontal;
  exports.IconArrowsJoin = IconArrowsJoin;
  exports.IconArrowsJoin2 = IconArrowsJoin2;
  exports.IconArrowsLeft = IconArrowsLeft;
  exports.IconArrowsLeftDown = IconArrowsLeftDown;
  exports.IconArrowsLeftRight = IconArrowsLeftRight;
  exports.IconArrowsMaximize = IconArrowsMaximize;
  exports.IconArrowsMinimize = IconArrowsMinimize;
  exports.IconArrowsRight = IconArrowsRight;
  exports.IconArrowsRightDown = IconArrowsRightDown;
  exports.IconArrowsRightLeft = IconArrowsRightLeft;
  exports.IconArrowsSort = IconArrowsSort;
  exports.IconArrowsSplit = IconArrowsSplit;
  exports.IconArrowsSplit2 = IconArrowsSplit2;
  exports.IconArrowsUp = IconArrowsUp;
  exports.IconArrowsUpDown = IconArrowsUpDown;
  exports.IconArrowsUpLeft = IconArrowsUpLeft;
  exports.IconArrowsUpRight = IconArrowsUpRight;
  exports.IconArrowsVertical = IconArrowsVertical;
  exports.IconArtboard = IconArtboard;
  exports.IconAspectRatio = IconAspectRatio;
  exports.IconAt = IconAt;
  exports.IconAtom = IconAtom;
  exports.IconAtom2 = IconAtom2;
  exports.IconAward = IconAward;
  exports.IconBackhoe = IconBackhoe;
  exports.IconBackspace = IconBackspace;
  exports.IconBallAmericanFootball = IconBallAmericanFootball;
  exports.IconBallBasketball = IconBallBasketball;
  exports.IconBallBowling = IconBallBowling;
  exports.IconBallFootball = IconBallFootball;
  exports.IconBallFootballOff = IconBallFootballOff;
  exports.IconBallTennis = IconBallTennis;
  exports.IconBallVolleyball = IconBallVolleyball;
  exports.IconBan = IconBan;
  exports.IconBandage = IconBandage;
  exports.IconBarcode = IconBarcode;
  exports.IconBasket = IconBasket;
  exports.IconBattery = IconBattery;
  exports.IconBattery1 = IconBattery1;
  exports.IconBattery2 = IconBattery2;
  exports.IconBattery3 = IconBattery3;
  exports.IconBattery4 = IconBattery4;
  exports.IconBatteryAutomotive = IconBatteryAutomotive;
  exports.IconBatteryCharging = IconBatteryCharging;
  exports.IconBatteryOff = IconBatteryOff;
  exports.IconBed = IconBed;
  exports.IconBell = IconBell;
  exports.IconBellMinus = IconBellMinus;
  exports.IconBellOff = IconBellOff;
  exports.IconBellPlus = IconBellPlus;
  exports.IconBellRinging = IconBellRinging;
  exports.IconBellRinging2 = IconBellRinging2;
  exports.IconBellX = IconBellX;
  exports.IconBike = IconBike;
  exports.IconBinary = IconBinary;
  exports.IconBiohazard = IconBiohazard;
  exports.IconBlockquote = IconBlockquote;
  exports.IconBluetooth = IconBluetooth;
  exports.IconBluetoothConnected = IconBluetoothConnected;
  exports.IconBluetoothOff = IconBluetoothOff;
  exports.IconBold = IconBold;
  exports.IconBolt = IconBolt;
  exports.IconBoltOff = IconBoltOff;
  exports.IconBone = IconBone;
  exports.IconBook = IconBook;
  exports.IconBookmark = IconBookmark;
  exports.IconBookmarkOff = IconBookmarkOff;
  exports.IconBookmarks = IconBookmarks;
  exports.IconBorderAll = IconBorderAll;
  exports.IconBorderBottom = IconBorderBottom;
  exports.IconBorderHorizontal = IconBorderHorizontal;
  exports.IconBorderInner = IconBorderInner;
  exports.IconBorderLeft = IconBorderLeft;
  exports.IconBorderNone = IconBorderNone;
  exports.IconBorderOuter = IconBorderOuter;
  exports.IconBorderRadius = IconBorderRadius;
  exports.IconBorderRight = IconBorderRight;
  exports.IconBorderStyle = IconBorderStyle;
  exports.IconBorderTop = IconBorderTop;
  exports.IconBorderVertical = IconBorderVertical;
  exports.IconBox = IconBox;
  exports.IconBoxMargin = IconBoxMargin;
  exports.IconBoxModel = IconBoxModel;
  exports.IconBoxMultiple = IconBoxMultiple;
  exports.IconBoxMultiple0 = IconBoxMultiple0;
  exports.IconBoxMultiple1 = IconBoxMultiple1;
  exports.IconBoxMultiple2 = IconBoxMultiple2;
  exports.IconBoxMultiple3 = IconBoxMultiple3;
  exports.IconBoxMultiple4 = IconBoxMultiple4;
  exports.IconBoxMultiple5 = IconBoxMultiple5;
  exports.IconBoxMultiple6 = IconBoxMultiple6;
  exports.IconBoxMultiple7 = IconBoxMultiple7;
  exports.IconBoxMultiple8 = IconBoxMultiple8;
  exports.IconBoxMultiple9 = IconBoxMultiple9;
  exports.IconBoxPadding = IconBoxPadding;
  exports.IconBraces = IconBraces;
  exports.IconBrackets = IconBrackets;
  exports.IconBrandAirbnb = IconBrandAirbnb;
  exports.IconBrandAndroid = IconBrandAndroid;
  exports.IconBrandApple = IconBrandApple;
  exports.IconBrandAppleArcade = IconBrandAppleArcade;
  exports.IconBrandAppstore = IconBrandAppstore;
  exports.IconBrandAsana = IconBrandAsana;
  exports.IconBrandBehance = IconBrandBehance;
  exports.IconBrandBing = IconBrandBing;
  exports.IconBrandBitbucket = IconBrandBitbucket;
  exports.IconBrandBooking = IconBrandBooking;
  exports.IconBrandChrome = IconBrandChrome;
  exports.IconBrandCodepen = IconBrandCodepen;
  exports.IconBrandCodesandbox = IconBrandCodesandbox;
  exports.IconBrandCss3 = IconBrandCss3;
  exports.IconBrandDeviantart = IconBrandDeviantart;
  exports.IconBrandDiscord = IconBrandDiscord;
  exports.IconBrandDisqus = IconBrandDisqus;
  exports.IconBrandDocker = IconBrandDocker;
  exports.IconBrandDribbble = IconBrandDribbble;
  exports.IconBrandEdge = IconBrandEdge;
  exports.IconBrandFacebook = IconBrandFacebook;
  exports.IconBrandFigma = IconBrandFigma;
  exports.IconBrandFirefox = IconBrandFirefox;
  exports.IconBrandFlickr = IconBrandFlickr;
  exports.IconBrandFoursquare = IconBrandFoursquare;
  exports.IconBrandFramer = IconBrandFramer;
  exports.IconBrandGithub = IconBrandGithub;
  exports.IconBrandGitlab = IconBrandGitlab;
  exports.IconBrandGoogle = IconBrandGoogle;
  exports.IconBrandGoogleAnalytics = IconBrandGoogleAnalytics;
  exports.IconBrandGoogleDrive = IconBrandGoogleDrive;
  exports.IconBrandGooglePlay = IconBrandGooglePlay;
  exports.IconBrandGravatar = IconBrandGravatar;
  exports.IconBrandHipchat = IconBrandHipchat;
  exports.IconBrandHtml5 = IconBrandHtml5;
  exports.IconBrandInstagram = IconBrandInstagram;
  exports.IconBrandKickstarter = IconBrandKickstarter;
  exports.IconBrandKotlin = IconBrandKotlin;
  exports.IconBrandLinkedin = IconBrandLinkedin;
  exports.IconBrandMedium = IconBrandMedium;
  exports.IconBrandMessenger = IconBrandMessenger;
  exports.IconBrandNetflix = IconBrandNetflix;
  exports.IconBrandOpenSource = IconBrandOpenSource;
  exports.IconBrandOpera = IconBrandOpera;
  exports.IconBrandPagekit = IconBrandPagekit;
  exports.IconBrandPatreon = IconBrandPatreon;
  exports.IconBrandPaypal = IconBrandPaypal;
  exports.IconBrandPinterest = IconBrandPinterest;
  exports.IconBrandPocket = IconBrandPocket;
  exports.IconBrandProducthunt = IconBrandProducthunt;
  exports.IconBrandPython = IconBrandPython;
  exports.IconBrandReddit = IconBrandReddit;
  exports.IconBrandSafari = IconBrandSafari;
  exports.IconBrandSass = IconBrandSass;
  exports.IconBrandSentry = IconBrandSentry;
  exports.IconBrandShazam = IconBrandShazam;
  exports.IconBrandSketch = IconBrandSketch;
  exports.IconBrandSkype = IconBrandSkype;
  exports.IconBrandSlack = IconBrandSlack;
  exports.IconBrandSnapchat = IconBrandSnapchat;
  exports.IconBrandSoundcloud = IconBrandSoundcloud;
  exports.IconBrandSpotify = IconBrandSpotify;
  exports.IconBrandSteam = IconBrandSteam;
  exports.IconBrandStripe = IconBrandStripe;
  exports.IconBrandTabler = IconBrandTabler;
  exports.IconBrandTailwind = IconBrandTailwind;
  exports.IconBrandTelegram = IconBrandTelegram;
  exports.IconBrandTidal = IconBrandTidal;
  exports.IconBrandTiktok = IconBrandTiktok;
  exports.IconBrandTinder = IconBrandTinder;
  exports.IconBrandTumblr = IconBrandTumblr;
  exports.IconBrandTwitch = IconBrandTwitch;
  exports.IconBrandTwitter = IconBrandTwitter;
  exports.IconBrandUnsplash = IconBrandUnsplash;
  exports.IconBrandVimeo = IconBrandVimeo;
  exports.IconBrandVk = IconBrandVk;
  exports.IconBrandWhatsapp = IconBrandWhatsapp;
  exports.IconBrandWindows = IconBrandWindows;
  exports.IconBrandYahoo = IconBrandYahoo;
  exports.IconBrandYcombinator = IconBrandYcombinator;
  exports.IconBrandYoutube = IconBrandYoutube;
  exports.IconBriefcase = IconBriefcase;
  exports.IconBrightness = IconBrightness;
  exports.IconBrightness2 = IconBrightness2;
  exports.IconBrightnessDown = IconBrightnessDown;
  exports.IconBrightnessHalf = IconBrightnessHalf;
  exports.IconBrightnessUp = IconBrightnessUp;
  exports.IconBrowser = IconBrowser;
  exports.IconBrush = IconBrush;
  exports.IconBucket = IconBucket;
  exports.IconBug = IconBug;
  exports.IconBuilding = IconBuilding;
  exports.IconBuildingArch = IconBuildingArch;
  exports.IconBuildingBank = IconBuildingBank;
  exports.IconBuildingBridge = IconBuildingBridge;
  exports.IconBuildingBridge2 = IconBuildingBridge2;
  exports.IconBuildingCarousel = IconBuildingCarousel;
  exports.IconBuildingCastle = IconBuildingCastle;
  exports.IconBuildingChurch = IconBuildingChurch;
  exports.IconBuildingCommunity = IconBuildingCommunity;
  exports.IconBuildingCottage = IconBuildingCottage;
  exports.IconBuildingFactory = IconBuildingFactory;
  exports.IconBuildingFortress = IconBuildingFortress;
  exports.IconBuildingHospital = IconBuildingHospital;
  exports.IconBuildingLighthouse = IconBuildingLighthouse;
  exports.IconBuildingMonument = IconBuildingMonument;
  exports.IconBuildingPavilon = IconBuildingPavilon;
  exports.IconBuildingSkyscraper = IconBuildingSkyscraper;
  exports.IconBuildingStore = IconBuildingStore;
  exports.IconBuildingWarehouse = IconBuildingWarehouse;
  exports.IconBulb = IconBulb;
  exports.IconBulbOff = IconBulbOff;
  exports.IconBulldozer = IconBulldozer;
  exports.IconBus = IconBus;
  exports.IconBusinessplan = IconBusinessplan;
  exports.IconCalculator = IconCalculator;
  exports.IconCalendar = IconCalendar;
  exports.IconCalendarEvent = IconCalendarEvent;
  exports.IconCalendarMinus = IconCalendarMinus;
  exports.IconCalendarOff = IconCalendarOff;
  exports.IconCalendarPlus = IconCalendarPlus;
  exports.IconCalendarStats = IconCalendarStats;
  exports.IconCalendarTime = IconCalendarTime;
  exports.IconCamera = IconCamera;
  exports.IconCameraMinus = IconCameraMinus;
  exports.IconCameraOff = IconCameraOff;
  exports.IconCameraPlus = IconCameraPlus;
  exports.IconCameraRotate = IconCameraRotate;
  exports.IconCameraSelfie = IconCameraSelfie;
  exports.IconCapture = IconCapture;
  exports.IconCar = IconCar;
  exports.IconCaravan = IconCaravan;
  exports.IconCardboards = IconCardboards;
  exports.IconCaretDown = IconCaretDown;
  exports.IconCaretLeft = IconCaretLeft;
  exports.IconCaretRight = IconCaretRight;
  exports.IconCaretUp = IconCaretUp;
  exports.IconCash = IconCash;
  exports.IconCashBanknote = IconCashBanknote;
  exports.IconCashBanknoteOff = IconCashBanknoteOff;
  exports.IconCast = IconCast;
  exports.IconCe = IconCe;
  exports.IconCertificate = IconCertificate;
  exports.IconChargingPile = IconChargingPile;
  exports.IconChartArcs = IconChartArcs;
  exports.IconChartArcs3 = IconChartArcs3;
  exports.IconChartArea = IconChartArea;
  exports.IconChartAreaLine = IconChartAreaLine;
  exports.IconChartArrows = IconChartArrows;
  exports.IconChartArrowsVertical = IconChartArrowsVertical;
  exports.IconChartBar = IconChartBar;
  exports.IconChartBubble = IconChartBubble;
  exports.IconChartCandle = IconChartCandle;
  exports.IconChartCircles = IconChartCircles;
  exports.IconChartDonut = IconChartDonut;
  exports.IconChartDonut2 = IconChartDonut2;
  exports.IconChartDonut3 = IconChartDonut3;
  exports.IconChartDonut4 = IconChartDonut4;
  exports.IconChartDots = IconChartDots;
  exports.IconChartInfographic = IconChartInfographic;
  exports.IconChartLine = IconChartLine;
  exports.IconChartPie = IconChartPie;
  exports.IconChartPie2 = IconChartPie2;
  exports.IconChartPie3 = IconChartPie3;
  exports.IconChartPie4 = IconChartPie4;
  exports.IconChartRadar = IconChartRadar;
  exports.IconCheck = IconCheck;
  exports.IconCheckbox = IconCheckbox;
  exports.IconChecks = IconChecks;
  exports.IconChevronDown = IconChevronDown;
  exports.IconChevronDownLeft = IconChevronDownLeft;
  exports.IconChevronDownRight = IconChevronDownRight;
  exports.IconChevronLeft = IconChevronLeft;
  exports.IconChevronRight = IconChevronRight;
  exports.IconChevronUp = IconChevronUp;
  exports.IconChevronUpLeft = IconChevronUpLeft;
  exports.IconChevronUpRight = IconChevronUpRight;
  exports.IconChevronsDown = IconChevronsDown;
  exports.IconChevronsDownLeft = IconChevronsDownLeft;
  exports.IconChevronsDownRight = IconChevronsDownRight;
  exports.IconChevronsLeft = IconChevronsLeft;
  exports.IconChevronsRight = IconChevronsRight;
  exports.IconChevronsUp = IconChevronsUp;
  exports.IconChevronsUpLeft = IconChevronsUpLeft;
  exports.IconChevronsUpRight = IconChevronsUpRight;
  exports.IconChristmasTree = IconChristmasTree;
  exports.IconCircle = IconCircle;
  exports.IconCircle0 = IconCircle0;
  exports.IconCircle1 = IconCircle1;
  exports.IconCircle2 = IconCircle2;
  exports.IconCircle3 = IconCircle3;
  exports.IconCircle4 = IconCircle4;
  exports.IconCircle5 = IconCircle5;
  exports.IconCircle6 = IconCircle6;
  exports.IconCircle7 = IconCircle7;
  exports.IconCircle8 = IconCircle8;
  exports.IconCircle9 = IconCircle9;
  exports.IconCircleCheck = IconCircleCheck;
  exports.IconCircleDashed = IconCircleDashed;
  exports.IconCircleDotted = IconCircleDotted;
  exports.IconCircleHalf = IconCircleHalf;
  exports.IconCircleHalfVertical = IconCircleHalfVertical;
  exports.IconCircleMinus = IconCircleMinus;
  exports.IconCircleOff = IconCircleOff;
  exports.IconCirclePlus = IconCirclePlus;
  exports.IconCircleSquare = IconCircleSquare;
  exports.IconCircleX = IconCircleX;
  exports.IconCircles = IconCircles;
  exports.IconClearAll = IconClearAll;
  exports.IconClearFormatting = IconClearFormatting;
  exports.IconClick = IconClick;
  exports.IconClipboard = IconClipboard;
  exports.IconClipboardCheck = IconClipboardCheck;
  exports.IconClipboardList = IconClipboardList;
  exports.IconClipboardX = IconClipboardX;
  exports.IconClock = IconClock;
  exports.IconCloud = IconCloud;
  exports.IconCloudDownload = IconCloudDownload;
  exports.IconCloudFog = IconCloudFog;
  exports.IconCloudOff = IconCloudOff;
  exports.IconCloudRain = IconCloudRain;
  exports.IconCloudSnow = IconCloudSnow;
  exports.IconCloudStorm = IconCloudStorm;
  exports.IconCloudUpload = IconCloudUpload;
  exports.IconCode = IconCode;
  exports.IconCodeMinus = IconCodeMinus;
  exports.IconCodePlus = IconCodePlus;
  exports.IconCoin = IconCoin;
  exports.IconColorPicker = IconColorPicker;
  exports.IconColorSwatch = IconColorSwatch;
  exports.IconColumnInsertLeft = IconColumnInsertLeft;
  exports.IconColumnInsertRight = IconColumnInsertRight;
  exports.IconColumns = IconColumns;
  exports.IconComet = IconComet;
  exports.IconCommand = IconCommand;
  exports.IconCompass = IconCompass;
  exports.IconConfetti = IconConfetti;
  exports.IconContainer = IconContainer;
  exports.IconContrast = IconContrast;
  exports.IconCopy = IconCopy;
  exports.IconCopyleft = IconCopyleft;
  exports.IconCopyright = IconCopyright;
  exports.IconCornerDownLeft = IconCornerDownLeft;
  exports.IconCornerDownLeftDouble = IconCornerDownLeftDouble;
  exports.IconCornerDownRight = IconCornerDownRight;
  exports.IconCornerDownRightDouble = IconCornerDownRightDouble;
  exports.IconCornerLeftDown = IconCornerLeftDown;
  exports.IconCornerLeftDownDouble = IconCornerLeftDownDouble;
  exports.IconCornerLeftUp = IconCornerLeftUp;
  exports.IconCornerLeftUpDouble = IconCornerLeftUpDouble;
  exports.IconCornerRightDown = IconCornerRightDown;
  exports.IconCornerRightDownDouble = IconCornerRightDownDouble;
  exports.IconCornerRightUp = IconCornerRightUp;
  exports.IconCornerRightUpDouble = IconCornerRightUpDouble;
  exports.IconCornerUpLeft = IconCornerUpLeft;
  exports.IconCornerUpLeftDouble = IconCornerUpLeftDouble;
  exports.IconCornerUpRight = IconCornerUpRight;
  exports.IconCornerUpRightDouble = IconCornerUpRightDouble;
  exports.IconCreditCard = IconCreditCard;
  exports.IconCreditCardOff = IconCreditCardOff;
  exports.IconCrop = IconCrop;
  exports.IconCrosshair = IconCrosshair;
  exports.IconCrown = IconCrown;
  exports.IconCrownOff = IconCrownOff;
  exports.IconCurlyLoop = IconCurlyLoop;
  exports.IconCurrencyBahraini = IconCurrencyBahraini;
  exports.IconCurrencyBath = IconCurrencyBath;
  exports.IconCurrencyBitcoin = IconCurrencyBitcoin;
  exports.IconCurrencyCent = IconCurrencyCent;
  exports.IconCurrencyDinar = IconCurrencyDinar;
  exports.IconCurrencyDirham = IconCurrencyDirham;
  exports.IconCurrencyDollar = IconCurrencyDollar;
  exports.IconCurrencyDollarAustralian = IconCurrencyDollarAustralian;
  exports.IconCurrencyDollarCanadian = IconCurrencyDollarCanadian;
  exports.IconCurrencyDollarSingapore = IconCurrencyDollarSingapore;
  exports.IconCurrencyEthereum = IconCurrencyEthereum;
  exports.IconCurrencyEuro = IconCurrencyEuro;
  exports.IconCurrencyForint = IconCurrencyForint;
  exports.IconCurrencyFrank = IconCurrencyFrank;
  exports.IconCurrencyKroneCzech = IconCurrencyKroneCzech;
  exports.IconCurrencyKroneDanish = IconCurrencyKroneDanish;
  exports.IconCurrencyKroneSwedish = IconCurrencyKroneSwedish;
  exports.IconCurrencyLeu = IconCurrencyLeu;
  exports.IconCurrencyLira = IconCurrencyLira;
  exports.IconCurrencyLitecoin = IconCurrencyLitecoin;
  exports.IconCurrencyNaira = IconCurrencyNaira;
  exports.IconCurrencyPound = IconCurrencyPound;
  exports.IconCurrencyReal = IconCurrencyReal;
  exports.IconCurrencyRenminbi = IconCurrencyRenminbi;
  exports.IconCurrencyRipple = IconCurrencyRipple;
  exports.IconCurrencyRiyal = IconCurrencyRiyal;
  exports.IconCurrencyRubel = IconCurrencyRubel;
  exports.IconCurrencyRupee = IconCurrencyRupee;
  exports.IconCurrencyShekel = IconCurrencyShekel;
  exports.IconCurrencyTaka = IconCurrencyTaka;
  exports.IconCurrencyTugrik = IconCurrencyTugrik;
  exports.IconCurrencyWon = IconCurrencyWon;
  exports.IconCurrencyYen = IconCurrencyYen;
  exports.IconCurrencyZloty = IconCurrencyZloty;
  exports.IconCurrentLocation = IconCurrentLocation;
  exports.IconCursorText = IconCursorText;
  exports.IconCut = IconCut;
  exports.IconDashboard = IconDashboard;
  exports.IconDatabase = IconDatabase;
  exports.IconDatabaseExport = IconDatabaseExport;
  exports.IconDatabaseImport = IconDatabaseImport;
  exports.IconDatabaseOff = IconDatabaseOff;
  exports.IconDetails = IconDetails;
  exports.IconDeviceAnalytics = IconDeviceAnalytics;
  exports.IconDeviceAudioTape = IconDeviceAudioTape;
  exports.IconDeviceCctv = IconDeviceCctv;
  exports.IconDeviceComputerCamera = IconDeviceComputerCamera;
  exports.IconDeviceComputerCameraOff = IconDeviceComputerCameraOff;
  exports.IconDeviceDesktop = IconDeviceDesktop;
  exports.IconDeviceDesktopAnalytics = IconDeviceDesktopAnalytics;
  exports.IconDeviceDesktopOff = IconDeviceDesktopOff;
  exports.IconDeviceFloppy = IconDeviceFloppy;
  exports.IconDeviceGamepad = IconDeviceGamepad;
  exports.IconDeviceLaptop = IconDeviceLaptop;
  exports.IconDeviceMobile = IconDeviceMobile;
  exports.IconDeviceMobileMessage = IconDeviceMobileMessage;
  exports.IconDeviceMobileRotated = IconDeviceMobileRotated;
  exports.IconDeviceMobileVibration = IconDeviceMobileVibration;
  exports.IconDeviceSpeaker = IconDeviceSpeaker;
  exports.IconDeviceTablet = IconDeviceTablet;
  exports.IconDeviceTv = IconDeviceTv;
  exports.IconDeviceWatch = IconDeviceWatch;
  exports.IconDevices = IconDevices;
  exports.IconDevices2 = IconDevices2;
  exports.IconDevicesPc = IconDevicesPc;
  exports.IconDiamond = IconDiamond;
  exports.IconDice = IconDice;
  exports.IconDimensions = IconDimensions;
  exports.IconDirection = IconDirection;
  exports.IconDirectionHorizontal = IconDirectionHorizontal;
  exports.IconDirections = IconDirections;
  exports.IconDisabled = IconDisabled;
  exports.IconDisabled2 = IconDisabled2;
  exports.IconDisc = IconDisc;
  exports.IconDiscount = IconDiscount;
  exports.IconDiscount2 = IconDiscount2;
  exports.IconDivide = IconDivide;
  exports.IconDna = IconDna;
  exports.IconDots = IconDots;
  exports.IconDotsCircleHorizontal = IconDotsCircleHorizontal;
  exports.IconDotsDiagonal = IconDotsDiagonal;
  exports.IconDotsDiagonal2 = IconDotsDiagonal2;
  exports.IconDotsVertical = IconDotsVertical;
  exports.IconDownload = IconDownload;
  exports.IconDragDrop = IconDragDrop;
  exports.IconDragDrop2 = IconDragDrop2;
  exports.IconDrone = IconDrone;
  exports.IconDroneOff = IconDroneOff;
  exports.IconDroplet = IconDroplet;
  exports.IconDropletFilled = IconDropletFilled;
  exports.IconDropletFilled2 = IconDropletFilled2;
  exports.IconDropletHalf = IconDropletHalf;
  exports.IconDropletHalf2 = IconDropletHalf2;
  exports.IconDropletOff = IconDropletOff;
  exports.IconEar = IconEar;
  exports.IconEarOff = IconEarOff;
  exports.IconEdit = IconEdit;
  exports.IconEditCircle = IconEditCircle;
  exports.IconEgg = IconEgg;
  exports.IconEmphasis = IconEmphasis;
  exports.IconEqual = IconEqual;
  exports.IconEqualNot = IconEqualNot;
  exports.IconEraser = IconEraser;
  exports.IconExchange = IconExchange;
  exports.IconExposure = IconExposure;
  exports.IconExternalLink = IconExternalLink;
  exports.IconEye = IconEye;
  exports.IconEyeCheck = IconEyeCheck;
  exports.IconEyeOff = IconEyeOff;
  exports.IconEyeglass = IconEyeglass;
  exports.IconEyeglass2 = IconEyeglass2;
  exports.IconFaceId = IconFaceId;
  exports.IconFall = IconFall;
  exports.IconFeather = IconFeather;
  exports.IconFile = IconFile;
  exports.IconFileAlert = IconFileAlert;
  exports.IconFileAnalytics = IconFileAnalytics;
  exports.IconFileCertificate = IconFileCertificate;
  exports.IconFileCheck = IconFileCheck;
  exports.IconFileCode = IconFileCode;
  exports.IconFileCode2 = IconFileCode2;
  exports.IconFileDiff = IconFileDiff;
  exports.IconFileDislike = IconFileDislike;
  exports.IconFileDownload = IconFileDownload;
  exports.IconFileExport = IconFileExport;
  exports.IconFileHorizontal = IconFileHorizontal;
  exports.IconFileImport = IconFileImport;
  exports.IconFileInfo = IconFileInfo;
  exports.IconFileInvoice = IconFileInvoice;
  exports.IconFileLike = IconFileLike;
  exports.IconFileMinus = IconFileMinus;
  exports.IconFileMusic = IconFileMusic;
  exports.IconFileOff = IconFileOff;
  exports.IconFilePhone = IconFilePhone;
  exports.IconFilePlus = IconFilePlus;
  exports.IconFileReport = IconFileReport;
  exports.IconFileSearch = IconFileSearch;
  exports.IconFileShredder = IconFileShredder;
  exports.IconFileSymlink = IconFileSymlink;
  exports.IconFileText = IconFileText;
  exports.IconFileUpload = IconFileUpload;
  exports.IconFileX = IconFileX;
  exports.IconFileZip = IconFileZip;
  exports.IconFiles = IconFiles;
  exports.IconFilesOff = IconFilesOff;
  exports.IconFilter = IconFilter;
  exports.IconFilterOff = IconFilterOff;
  exports.IconFingerprint = IconFingerprint;
  exports.IconFiretruck = IconFiretruck;
  exports.IconFlag = IconFlag;
  exports.IconFlag2 = IconFlag2;
  exports.IconFlag3 = IconFlag3;
  exports.IconFlame = IconFlame;
  exports.IconFlare = IconFlare;
  exports.IconFlask = IconFlask;
  exports.IconFlipHorizontal = IconFlipHorizontal;
  exports.IconFlipVertical = IconFlipVertical;
  exports.IconFloatCenter = IconFloatCenter;
  exports.IconFloatLeft = IconFloatLeft;
  exports.IconFloatNone = IconFloatNone;
  exports.IconFloatRight = IconFloatRight;
  exports.IconFocus = IconFocus;
  exports.IconFocus2 = IconFocus2;
  exports.IconFold = IconFold;
  exports.IconFoldDown = IconFoldDown;
  exports.IconFoldUp = IconFoldUp;
  exports.IconFolder = IconFolder;
  exports.IconFolderMinus = IconFolderMinus;
  exports.IconFolderOff = IconFolderOff;
  exports.IconFolderPlus = IconFolderPlus;
  exports.IconFolderX = IconFolderX;
  exports.IconFolders = IconFolders;
  exports.IconForbid = IconForbid;
  exports.IconForbid2 = IconForbid2;
  exports.IconForklift = IconForklift;
  exports.IconForms = IconForms;
  exports.IconFrame = IconFrame;
  exports.IconFriends = IconFriends;
  exports.IconGasStation = IconGasStation;
  exports.IconGauge = IconGauge;
  exports.IconGeometry = IconGeometry;
  exports.IconGhost = IconGhost;
  exports.IconGift = IconGift;
  exports.IconGitBranch = IconGitBranch;
  exports.IconGitCommit = IconGitCommit;
  exports.IconGitCompare = IconGitCompare;
  exports.IconGitFork = IconGitFork;
  exports.IconGitMerge = IconGitMerge;
  exports.IconGitPullRequest = IconGitPullRequest;
  exports.IconGlass = IconGlass;
  exports.IconGlassFull = IconGlassFull;
  exports.IconGlassOff = IconGlassOff;
  exports.IconGlobe = IconGlobe;
  exports.IconGolf = IconGolf;
  exports.IconGps = IconGps;
  exports.IconGrain = IconGrain;
  exports.IconGridDots = IconGridDots;
  exports.IconGripHorizontal = IconGripHorizontal;
  exports.IconGripVertical = IconGripVertical;
  exports.IconGrowth = IconGrowth;
  exports.IconH1 = IconH1;
  exports.IconH2 = IconH2;
  exports.IconH3 = IconH3;
  exports.IconH4 = IconH4;
  exports.IconH5 = IconH5;
  exports.IconH6 = IconH6;
  exports.IconHandFinger = IconHandFinger;
  exports.IconHandLittleFinger = IconHandLittleFinger;
  exports.IconHandMiddleFinger = IconHandMiddleFinger;
  exports.IconHandOff = IconHandOff;
  exports.IconHandRingFinger = IconHandRingFinger;
  exports.IconHandRock = IconHandRock;
  exports.IconHandStop = IconHandStop;
  exports.IconHandThreeFingers = IconHandThreeFingers;
  exports.IconHandTwoFingers = IconHandTwoFingers;
  exports.IconHanger = IconHanger;
  exports.IconHash = IconHash;
  exports.IconHeading = IconHeading;
  exports.IconHeadphones = IconHeadphones;
  exports.IconHeadphonesOff = IconHeadphonesOff;
  exports.IconHeadset = IconHeadset;
  exports.IconHeart = IconHeart;
  exports.IconHeartBroken = IconHeartBroken;
  exports.IconHelicopter = IconHelicopter;
  exports.IconHelicopterLanding = IconHelicopterLanding;
  exports.IconHelp = IconHelp;
  exports.IconHexagon = IconHexagon;
  exports.IconHexagonOff = IconHexagonOff;
  exports.IconHierarchy = IconHierarchy;
  exports.IconHierarchy2 = IconHierarchy2;
  exports.IconHistory = IconHistory;
  exports.IconHome = IconHome;
  exports.IconHome2 = IconHome2;
  exports.IconIceCream = IconIceCream;
  exports.IconIceCream2 = IconIceCream2;
  exports.IconId = IconId;
  exports.IconInbox = IconInbox;
  exports.IconIndentDecrease = IconIndentDecrease;
  exports.IconIndentIncrease = IconIndentIncrease;
  exports.IconInfinity = IconInfinity;
  exports.IconInfoCircle = IconInfoCircle;
  exports.IconInfoSquare = IconInfoSquare;
  exports.IconItalic = IconItalic;
  exports.IconJumpRope = IconJumpRope;
  exports.IconKarate = IconKarate;
  exports.IconKey = IconKey;
  exports.IconKeyboard = IconKeyboard;
  exports.IconKeyboardHide = IconKeyboardHide;
  exports.IconKeyboardOff = IconKeyboardOff;
  exports.IconKeyboardShow = IconKeyboardShow;
  exports.IconLanguage = IconLanguage;
  exports.IconLayersDifference = IconLayersDifference;
  exports.IconLayersIntersect = IconLayersIntersect;
  exports.IconLayersLinked = IconLayersLinked;
  exports.IconLayersSubtract = IconLayersSubtract;
  exports.IconLayersUnion = IconLayersUnion;
  exports.IconLayout = IconLayout;
  exports.IconLayout2 = IconLayout2;
  exports.IconLayoutAlignBottom = IconLayoutAlignBottom;
  exports.IconLayoutAlignCenter = IconLayoutAlignCenter;
  exports.IconLayoutAlignLeft = IconLayoutAlignLeft;
  exports.IconLayoutAlignMiddle = IconLayoutAlignMiddle;
  exports.IconLayoutAlignRight = IconLayoutAlignRight;
  exports.IconLayoutAlignTop = IconLayoutAlignTop;
  exports.IconLayoutBottombar = IconLayoutBottombar;
  exports.IconLayoutCards = IconLayoutCards;
  exports.IconLayoutColumns = IconLayoutColumns;
  exports.IconLayoutDistributeHorizontal = IconLayoutDistributeHorizontal;
  exports.IconLayoutDistributeVertical = IconLayoutDistributeVertical;
  exports.IconLayoutGrid = IconLayoutGrid;
  exports.IconLayoutGridAdd = IconLayoutGridAdd;
  exports.IconLayoutKanban = IconLayoutKanban;
  exports.IconLayoutList = IconLayoutList;
  exports.IconLayoutNavbar = IconLayoutNavbar;
  exports.IconLayoutRows = IconLayoutRows;
  exports.IconLayoutSidebar = IconLayoutSidebar;
  exports.IconLayoutSidebarRight = IconLayoutSidebarRight;
  exports.IconLeaf = IconLeaf;
  exports.IconLego = IconLego;
  exports.IconLetterA = IconLetterA;
  exports.IconLetterB = IconLetterB;
  exports.IconLetterC = IconLetterC;
  exports.IconLetterCase = IconLetterCase;
  exports.IconLetterCaseLower = IconLetterCaseLower;
  exports.IconLetterCaseToggle = IconLetterCaseToggle;
  exports.IconLetterCaseUpper = IconLetterCaseUpper;
  exports.IconLetterD = IconLetterD;
  exports.IconLetterE = IconLetterE;
  exports.IconLetterF = IconLetterF;
  exports.IconLetterG = IconLetterG;
  exports.IconLetterH = IconLetterH;
  exports.IconLetterI = IconLetterI;
  exports.IconLetterJ = IconLetterJ;
  exports.IconLetterK = IconLetterK;
  exports.IconLetterL = IconLetterL;
  exports.IconLetterM = IconLetterM;
  exports.IconLetterN = IconLetterN;
  exports.IconLetterO = IconLetterO;
  exports.IconLetterP = IconLetterP;
  exports.IconLetterQ = IconLetterQ;
  exports.IconLetterR = IconLetterR;
  exports.IconLetterS = IconLetterS;
  exports.IconLetterSpacing = IconLetterSpacing;
  exports.IconLetterT = IconLetterT;
  exports.IconLetterU = IconLetterU;
  exports.IconLetterV = IconLetterV;
  exports.IconLetterW = IconLetterW;
  exports.IconLetterX = IconLetterX;
  exports.IconLetterY = IconLetterY;
  exports.IconLetterZ = IconLetterZ;
  exports.IconLettersCase = IconLettersCase;
  exports.IconLicense = IconLicense;
  exports.IconLifebuoy = IconLifebuoy;
  exports.IconLine = IconLine;
  exports.IconLineDashed = IconLineDashed;
  exports.IconLineDotted = IconLineDotted;
  exports.IconLineHeight = IconLineHeight;
  exports.IconLink = IconLink;
  exports.IconList = IconList;
  exports.IconListCheck = IconListCheck;
  exports.IconListSearch = IconListSearch;
  exports.IconLivePhoto = IconLivePhoto;
  exports.IconLiveView = IconLiveView;
  exports.IconLoader = IconLoader;
  exports.IconLoaderQuarter = IconLoaderQuarter;
  exports.IconLocation = IconLocation;
  exports.IconLock = IconLock;
  exports.IconLockAccess = IconLockAccess;
  exports.IconLockOff = IconLockOff;
  exports.IconLockOpen = IconLockOpen;
  exports.IconLogin = IconLogin;
  exports.IconLogout = IconLogout;
  exports.IconMacro = IconMacro;
  exports.IconMagnet = IconMagnet;
  exports.IconMail = IconMail;
  exports.IconMailForward = IconMailForward;
  exports.IconMailOpened = IconMailOpened;
  exports.IconMailbox = IconMailbox;
  exports.IconMan = IconMan;
  exports.IconManualGearbox = IconManualGearbox;
  exports.IconMap = IconMap;
  exports.IconMap2 = IconMap2;
  exports.IconMapPin = IconMapPin;
  exports.IconMapPinOff = IconMapPinOff;
  exports.IconMapPins = IconMapPins;
  exports.IconMarkdown = IconMarkdown;
  exports.IconMarquee = IconMarquee;
  exports.IconMarquee2 = IconMarquee2;
  exports.IconMars = IconMars;
  exports.IconMask = IconMask;
  exports.IconMaskOff = IconMaskOff;
  exports.IconMassage = IconMassage;
  exports.IconMath = IconMath;
  exports.IconMathFunction = IconMathFunction;
  exports.IconMathSymbols = IconMathSymbols;
  exports.IconMaximize = IconMaximize;
  exports.IconMedal = IconMedal;
  exports.IconMedicalCross = IconMedicalCross;
  exports.IconMenu = IconMenu;
  exports.IconMenu2 = IconMenu2;
  exports.IconMessage = IconMessage;
  exports.IconMessage2 = IconMessage2;
  exports.IconMessageCircle = IconMessageCircle;
  exports.IconMessageCircle2 = IconMessageCircle2;
  exports.IconMessageCircleOff = IconMessageCircleOff;
  exports.IconMessageDots = IconMessageDots;
  exports.IconMessageOff = IconMessageOff;
  exports.IconMessagePlus = IconMessagePlus;
  exports.IconMessageReport = IconMessageReport;
  exports.IconMessages = IconMessages;
  exports.IconMessagesOff = IconMessagesOff;
  exports.IconMicrophone = IconMicrophone;
  exports.IconMicrophoneOff = IconMicrophoneOff;
  exports.IconMinimize = IconMinimize;
  exports.IconMinus = IconMinus;
  exports.IconMinusVertical = IconMinusVertical;
  exports.IconMist = IconMist;
  exports.IconMoodBoy = IconMoodBoy;
  exports.IconMoodConfuzed = IconMoodConfuzed;
  exports.IconMoodCrazyHappy = IconMoodCrazyHappy;
  exports.IconMoodCry = IconMoodCry;
  exports.IconMoodEmpty = IconMoodEmpty;
  exports.IconMoodHappy = IconMoodHappy;
  exports.IconMoodKid = IconMoodKid;
  exports.IconMoodNeutral = IconMoodNeutral;
  exports.IconMoodSad = IconMoodSad;
  exports.IconMoodSmile = IconMoodSmile;
  exports.IconMoodSuprised = IconMoodSuprised;
  exports.IconMoodTongue = IconMoodTongue;
  exports.IconMoon = IconMoon;
  exports.IconMoon2 = IconMoon2;
  exports.IconMoonStars = IconMoonStars;
  exports.IconMoped = IconMoped;
  exports.IconMotorbike = IconMotorbike;
  exports.IconMouse = IconMouse;
  exports.IconMovie = IconMovie;
  exports.IconMug = IconMug;
  exports.IconMusic = IconMusic;
  exports.IconNewSection = IconNewSection;
  exports.IconNews = IconNews;
  exports.IconNfc = IconNfc;
  exports.IconNote = IconNote;
  exports.IconNotebook = IconNotebook;
  exports.IconNotes = IconNotes;
  exports.IconNotification = IconNotification;
  exports.IconNumber0 = IconNumber0;
  exports.IconNumber1 = IconNumber1;
  exports.IconNumber2 = IconNumber2;
  exports.IconNumber3 = IconNumber3;
  exports.IconNumber4 = IconNumber4;
  exports.IconNumber5 = IconNumber5;
  exports.IconNumber6 = IconNumber6;
  exports.IconNumber7 = IconNumber7;
  exports.IconNumber8 = IconNumber8;
  exports.IconNumber9 = IconNumber9;
  exports.IconOctagon = IconOctagon;
  exports.IconOctagonOff = IconOctagonOff;
  exports.IconOld = IconOld;
  exports.IconOlympics = IconOlympics;
  exports.IconOmega = IconOmega;
  exports.IconOutlet = IconOutlet;
  exports.IconOverline = IconOverline;
  exports.IconPackage = IconPackage;
  exports.IconPacman = IconPacman;
  exports.IconPageBreak = IconPageBreak;
  exports.IconPaint = IconPaint;
  exports.IconPalette = IconPalette;
  exports.IconPanoramaHorizontal = IconPanoramaHorizontal;
  exports.IconPanoramaVertical = IconPanoramaVertical;
  exports.IconPaperclip = IconPaperclip;
  exports.IconParachute = IconParachute;
  exports.IconParentheses = IconParentheses;
  exports.IconParking = IconParking;
  exports.IconPeace = IconPeace;
  exports.IconPencil = IconPencil;
  exports.IconPennant = IconPennant;
  exports.IconPercentage = IconPercentage;
  exports.IconPerspective = IconPerspective;
  exports.IconPhone = IconPhone;
  exports.IconPhoneCall = IconPhoneCall;
  exports.IconPhoneCalling = IconPhoneCalling;
  exports.IconPhoneCheck = IconPhoneCheck;
  exports.IconPhoneIncoming = IconPhoneIncoming;
  exports.IconPhoneOff = IconPhoneOff;
  exports.IconPhoneOutgoing = IconPhoneOutgoing;
  exports.IconPhonePause = IconPhonePause;
  exports.IconPhonePlus = IconPhonePlus;
  exports.IconPhoneX = IconPhoneX;
  exports.IconPhoto = IconPhoto;
  exports.IconPhotoOff = IconPhotoOff;
  exports.IconPhysotherapist = IconPhysotherapist;
  exports.IconPictureInPicture = IconPictureInPicture;
  exports.IconPictureInPictureOff = IconPictureInPictureOff;
  exports.IconPictureInPictureOn = IconPictureInPictureOn;
  exports.IconPill = IconPill;
  exports.IconPin = IconPin;
  exports.IconPinned = IconPinned;
  exports.IconPinnedOff = IconPinnedOff;
  exports.IconPizza = IconPizza;
  exports.IconPlane = IconPlane;
  exports.IconPlaneArrival = IconPlaneArrival;
  exports.IconPlaneDeparture = IconPlaneDeparture;
  exports.IconPlanet = IconPlanet;
  exports.IconPlant = IconPlant;
  exports.IconPlant2 = IconPlant2;
  exports.IconPlayCard = IconPlayCard;
  exports.IconPlayerPause = IconPlayerPause;
  exports.IconPlayerPlay = IconPlayerPlay;
  exports.IconPlayerRecord = IconPlayerRecord;
  exports.IconPlayerSkipBack = IconPlayerSkipBack;
  exports.IconPlayerSkipForward = IconPlayerSkipForward;
  exports.IconPlayerStop = IconPlayerStop;
  exports.IconPlayerTrackNext = IconPlayerTrackNext;
  exports.IconPlayerTrackPrev = IconPlayerTrackPrev;
  exports.IconPlaylist = IconPlaylist;
  exports.IconPlug = IconPlug;
  exports.IconPlus = IconPlus;
  exports.IconPoint = IconPoint;
  exports.IconPokeball = IconPokeball;
  exports.IconPolaroid = IconPolaroid;
  exports.IconPool = IconPool;
  exports.IconPower = IconPower;
  exports.IconPray = IconPray;
  exports.IconPresentation = IconPresentation;
  exports.IconPresentationAnalytics = IconPresentationAnalytics;
  exports.IconPrinter = IconPrinter;
  exports.IconPrompt = IconPrompt;
  exports.IconPropeller = IconPropeller;
  exports.IconPuzzle = IconPuzzle;
  exports.IconPyramid = IconPyramid;
  exports.IconQrcode = IconQrcode;
  exports.IconQuestionMark = IconQuestionMark;
  exports.IconRadioactive = IconRadioactive;
  exports.IconRadiusBottomLeft = IconRadiusBottomLeft;
  exports.IconRadiusBottomRight = IconRadiusBottomRight;
  exports.IconRadiusTopLeft = IconRadiusTopLeft;
  exports.IconRadiusTopRight = IconRadiusTopRight;
  exports.IconRainbow = IconRainbow;
  exports.IconReceipt = IconReceipt;
  exports.IconReceipt2 = IconReceipt2;
  exports.IconReceiptOff = IconReceiptOff;
  exports.IconReceiptRefund = IconReceiptRefund;
  exports.IconReceiptTax = IconReceiptTax;
  exports.IconRecharging = IconRecharging;
  exports.IconRecordMail = IconRecordMail;
  exports.IconRectangle = IconRectangle;
  exports.IconRectangleVertical = IconRectangleVertical;
  exports.IconRecycle = IconRecycle;
  exports.IconRefresh = IconRefresh;
  exports.IconRefreshAlert = IconRefreshAlert;
  exports.IconRegistered = IconRegistered;
  exports.IconRelationManyToMany = IconRelationManyToMany;
  exports.IconRelationOneToMany = IconRelationOneToMany;
  exports.IconRelationOneToOne = IconRelationOneToOne;
  exports.IconRepeat = IconRepeat;
  exports.IconRepeatOnce = IconRepeatOnce;
  exports.IconReplace = IconReplace;
  exports.IconReport = IconReport;
  exports.IconReportAnalytics = IconReportAnalytics;
  exports.IconReportMedical = IconReportMedical;
  exports.IconReportMoney = IconReportMoney;
  exports.IconResize = IconResize;
  exports.IconRipple = IconRipple;
  exports.IconRoadSign = IconRoadSign;
  exports.IconRocket = IconRocket;
  exports.IconRotate = IconRotate;
  exports.IconRotate2 = IconRotate2;
  exports.IconRotateClockwise = IconRotateClockwise;
  exports.IconRotateClockwise2 = IconRotateClockwise2;
  exports.IconRotateRectangle = IconRotateRectangle;
  exports.IconRoute = IconRoute;
  exports.IconRouter = IconRouter;
  exports.IconRowInsertBottom = IconRowInsertBottom;
  exports.IconRowInsertTop = IconRowInsertTop;
  exports.IconRss = IconRss;
  exports.IconRuler = IconRuler;
  exports.IconRuler2 = IconRuler2;
  exports.IconRun = IconRun;
  exports.IconSailboat = IconSailboat;
  exports.IconSatellite = IconSatellite;
  exports.IconScale = IconScale;
  exports.IconScan = IconScan;
  exports.IconSchool = IconSchool;
  exports.IconScissors = IconScissors;
  exports.IconScooter = IconScooter;
  exports.IconScooterElectric = IconScooterElectric;
  exports.IconScreenShare = IconScreenShare;
  exports.IconScreenShareOff = IconScreenShareOff;
  exports.IconScubaMask = IconScubaMask;
  exports.IconSearch = IconSearch;
  exports.IconSection = IconSection;
  exports.IconSeeding = IconSeeding;
  exports.IconSelect = IconSelect;
  exports.IconSelector = IconSelector;
  exports.IconSend = IconSend;
  exports.IconSeparator = IconSeparator;
  exports.IconSeparatorHorizontal = IconSeparatorHorizontal;
  exports.IconSeparatorVertical = IconSeparatorVertical;
  exports.IconServer = IconServer;
  exports.IconServicemark = IconServicemark;
  exports.IconSettings = IconSettings;
  exports.IconSettingsAutomation = IconSettingsAutomation;
  exports.IconShadow = IconShadow;
  exports.IconShadowOff = IconShadowOff;
  exports.IconShape = IconShape;
  exports.IconShape2 = IconShape2;
  exports.IconShape3 = IconShape3;
  exports.IconShare = IconShare;
  exports.IconShield = IconShield;
  exports.IconShieldCheck = IconShieldCheck;
  exports.IconShieldLock = IconShieldLock;
  exports.IconShieldOff = IconShieldOff;
  exports.IconShieldX = IconShieldX;
  exports.IconShip = IconShip;
  exports.IconShirt = IconShirt;
  exports.IconShoppingCart = IconShoppingCart;
  exports.IconShoppingCartDiscount = IconShoppingCartDiscount;
  exports.IconShoppingCartOff = IconShoppingCartOff;
  exports.IconShoppingCartPlus = IconShoppingCartPlus;
  exports.IconShoppingCartX = IconShoppingCartX;
  exports.IconShredder = IconShredder;
  exports.IconSignature = IconSignature;
  exports.IconSitemap = IconSitemap;
  exports.IconSkateboard = IconSkateboard;
  exports.IconSlice = IconSlice;
  exports.IconSlideshow = IconSlideshow;
  exports.IconSmartHome = IconSmartHome;
  exports.IconSmoking = IconSmoking;
  exports.IconSmokingNo = IconSmokingNo;
  exports.IconSnowflake = IconSnowflake;
  exports.IconSoccerField = IconSoccerField;
  exports.IconSocial = IconSocial;
  exports.IconSock = IconSock;
  exports.IconSortAscending = IconSortAscending;
  exports.IconSortAscending2 = IconSortAscending2;
  exports.IconSortDescending = IconSortDescending;
  exports.IconSortDescending2 = IconSortDescending2;
  exports.IconSpace = IconSpace;
  exports.IconSpeakerphone = IconSpeakerphone;
  exports.IconSpeedboat = IconSpeedboat;
  exports.IconSportBillard = IconSportBillard;
  exports.IconSquare = IconSquare;
  exports.IconSquare0 = IconSquare0;
  exports.IconSquare1 = IconSquare1;
  exports.IconSquare2 = IconSquare2;
  exports.IconSquare3 = IconSquare3;
  exports.IconSquare4 = IconSquare4;
  exports.IconSquare5 = IconSquare5;
  exports.IconSquare6 = IconSquare6;
  exports.IconSquare7 = IconSquare7;
  exports.IconSquare8 = IconSquare8;
  exports.IconSquare9 = IconSquare9;
  exports.IconSquareCheck = IconSquareCheck;
  exports.IconSquareDot = IconSquareDot;
  exports.IconSquareForbid = IconSquareForbid;
  exports.IconSquareForbid2 = IconSquareForbid2;
  exports.IconSquareMinus = IconSquareMinus;
  exports.IconSquareOff = IconSquareOff;
  exports.IconSquarePlus = IconSquarePlus;
  exports.IconSquareRoot = IconSquareRoot;
  exports.IconSquareRoot2 = IconSquareRoot2;
  exports.IconSquareRotated = IconSquareRotated;
  exports.IconSquareRotatedOff = IconSquareRotatedOff;
  exports.IconSquareToggle = IconSquareToggle;
  exports.IconSquareToggleHorizontal = IconSquareToggleHorizontal;
  exports.IconSquareX = IconSquareX;
  exports.IconSquaresDiagonal = IconSquaresDiagonal;
  exports.IconSquaresFilled = IconSquaresFilled;
  exports.IconStack = IconStack;
  exports.IconStack2 = IconStack2;
  exports.IconStairs = IconStairs;
  exports.IconStairsDown = IconStairsDown;
  exports.IconStairsUp = IconStairsUp;
  exports.IconStar = IconStar;
  exports.IconStarHalf = IconStarHalf;
  exports.IconStarOff = IconStarOff;
  exports.IconStars = IconStars;
  exports.IconSteeringWheel = IconSteeringWheel;
  exports.IconStepInto = IconStepInto;
  exports.IconStepOut = IconStepOut;
  exports.IconStethoscope = IconStethoscope;
  exports.IconSticker = IconSticker;
  exports.IconStrikethrough = IconStrikethrough;
  exports.IconSubmarine = IconSubmarine;
  exports.IconSubscript = IconSubscript;
  exports.IconSubtask = IconSubtask;
  exports.IconSum = IconSum;
  exports.IconSun = IconSun;
  exports.IconSunOff = IconSunOff;
  exports.IconSunset = IconSunset;
  exports.IconSunshine = IconSunshine;
  exports.IconSuperscript = IconSuperscript;
  exports.IconSwimming = IconSwimming;
  exports.IconSwitch = IconSwitch;
  exports.IconSwitch2 = IconSwitch2;
  exports.IconSwitch3 = IconSwitch3;
  exports.IconSwitchHorizontal = IconSwitchHorizontal;
  exports.IconSwitchVertical = IconSwitchVertical;
  exports.IconTable = IconTable;
  exports.IconTableExport = IconTableExport;
  exports.IconTableImport = IconTableImport;
  exports.IconTableOff = IconTableOff;
  exports.IconTag = IconTag;
  exports.IconTallymark1 = IconTallymark1;
  exports.IconTallymark2 = IconTallymark2;
  exports.IconTallymark3 = IconTallymark3;
  exports.IconTallymark4 = IconTallymark4;
  exports.IconTallymarks = IconTallymarks;
  exports.IconTank = IconTank;
  exports.IconTarget = IconTarget;
  exports.IconTemperature = IconTemperature;
  exports.IconTemperatureCelsius = IconTemperatureCelsius;
  exports.IconTemperatureFahrenheit = IconTemperatureFahrenheit;
  exports.IconTemperatureMinus = IconTemperatureMinus;
  exports.IconTemperaturePlus = IconTemperaturePlus;
  exports.IconTemplate = IconTemplate;
  exports.IconTent = IconTent;
  exports.IconTerminal = IconTerminal;
  exports.IconTerminal2 = IconTerminal2;
  exports.IconTestPipe = IconTestPipe;
  exports.IconTextDirectionLtr = IconTextDirectionLtr;
  exports.IconTextDirectionRtl = IconTextDirectionRtl;
  exports.IconTextWrap = IconTextWrap;
  exports.IconTextWrapDisabled = IconTextWrapDisabled;
  exports.IconThumbDown = IconThumbDown;
  exports.IconThumbUp = IconThumbUp;
  exports.IconTicket = IconTicket;
  exports.IconTiltShift = IconTiltShift;
  exports.IconTir = IconTir;
  exports.IconToggleLeft = IconToggleLeft;
  exports.IconToggleRight = IconToggleRight;
  exports.IconTool = IconTool;
  exports.IconTools = IconTools;
  exports.IconToolsKitchen = IconToolsKitchen;
  exports.IconToolsKitchen2 = IconToolsKitchen2;
  exports.IconTornado = IconTornado;
  exports.IconTournament = IconTournament;
  exports.IconTrack = IconTrack;
  exports.IconTractor = IconTractor;
  exports.IconTrademark = IconTrademark;
  exports.IconTrafficCone = IconTrafficCone;
  exports.IconTrafficLights = IconTrafficLights;
  exports.IconTrain = IconTrain;
  exports.IconTrash = IconTrash;
  exports.IconTrashOff = IconTrashOff;
  exports.IconTree = IconTree;
  exports.IconTrees = IconTrees;
  exports.IconTrendingDown = IconTrendingDown;
  exports.IconTrendingDown2 = IconTrendingDown2;
  exports.IconTrendingDown3 = IconTrendingDown3;
  exports.IconTrendingUp = IconTrendingUp;
  exports.IconTrendingUp2 = IconTrendingUp2;
  exports.IconTrendingUp3 = IconTrendingUp3;
  exports.IconTriangle = IconTriangle;
  exports.IconTriangleOff = IconTriangleOff;
  exports.IconTriangleSquareCircle = IconTriangleSquareCircle;
  exports.IconTrident = IconTrident;
  exports.IconTrophy = IconTrophy;
  exports.IconTruck = IconTruck;
  exports.IconTruckDelivery = IconTruckDelivery;
  exports.IconTruckOff = IconTruckOff;
  exports.IconTruckReturn = IconTruckReturn;
  exports.IconTypography = IconTypography;
  exports.IconUmbrella = IconUmbrella;
  exports.IconUnderline = IconUnderline;
  exports.IconUnlink = IconUnlink;
  exports.IconUpload = IconUpload;
  exports.IconUrgent = IconUrgent;
  exports.IconUser = IconUser;
  exports.IconUserCheck = IconUserCheck;
  exports.IconUserExclamation = IconUserExclamation;
  exports.IconUserMinus = IconUserMinus;
  exports.IconUserOff = IconUserOff;
  exports.IconUserPlus = IconUserPlus;
  exports.IconUserX = IconUserX;
  exports.IconUsers = IconUsers;
  exports.IconVaccine = IconVaccine;
  exports.IconVariable = IconVariable;
  exports.IconVector = IconVector;
  exports.IconVectorBeizer = IconVectorBeizer;
  exports.IconVectorBeizer2 = IconVectorBeizer2;
  exports.IconVectorTriangle = IconVectorTriangle;
  exports.IconVenus = IconVenus;
  exports.IconVersions = IconVersions;
  exports.IconVideo = IconVideo;
  exports.IconVideoMinus = IconVideoMinus;
  exports.IconVideoOff = IconVideoOff;
  exports.IconVideoPlus = IconVideoPlus;
  exports.IconView360 = IconView360;
  exports.IconViewfinder = IconViewfinder;
  exports.IconViewportNarrow = IconViewportNarrow;
  exports.IconViewportWide = IconViewportWide;
  exports.IconVirus = IconVirus;
  exports.IconVirusOff = IconVirusOff;
  exports.IconVirusSearch = IconVirusSearch;
  exports.IconVolume = IconVolume;
  exports.IconVolume2 = IconVolume2;
  exports.IconVolume3 = IconVolume3;
  exports.IconWalk = IconWalk;
  exports.IconWallet = IconWallet;
  exports.IconWand = IconWand;
  exports.IconWaveSawTool = IconWaveSawTool;
  exports.IconWaveSine = IconWaveSine;
  exports.IconWaveSquare = IconWaveSquare;
  exports.IconWifi = IconWifi;
  exports.IconWifi0 = IconWifi0;
  exports.IconWifi1 = IconWifi1;
  exports.IconWifi2 = IconWifi2;
  exports.IconWifiOff = IconWifiOff;
  exports.IconWind = IconWind;
  exports.IconWindmill = IconWindmill;
  exports.IconWindow = IconWindow;
  exports.IconWiper = IconWiper;
  exports.IconWiperWash = IconWiperWash;
  exports.IconWoman = IconWoman;
  exports.IconWorld = IconWorld;
  exports.IconWorldLatitude = IconWorldLatitude;
  exports.IconWorldLongitude = IconWorldLongitude;
  exports.IconWreckingBall = IconWreckingBall;
  exports.IconWriting = IconWriting;
  exports.IconWritingSign = IconWritingSign;
  exports.IconX = IconX;
  exports.IconYinYang = IconYinYang;
  exports.IconZodiacAquarius = IconZodiacAquarius;
  exports.IconZodiacAries = IconZodiacAries;
  exports.IconZodiacCancer = IconZodiacCancer;
  exports.IconZodiacCapricorn = IconZodiacCapricorn;
  exports.IconZodiacGemini = IconZodiacGemini;
  exports.IconZodiacLeo = IconZodiacLeo;
  exports.IconZodiacLibra = IconZodiacLibra;
  exports.IconZodiacPisces = IconZodiacPisces;
  exports.IconZodiacSagittarius = IconZodiacSagittarius;
  exports.IconZodiacScorpio = IconZodiacScorpio;
  exports.IconZodiacTaurus = IconZodiacTaurus;
  exports.IconZodiacVirgo = IconZodiacVirgo;
  exports.IconZoomCancel = IconZoomCancel;
  exports.IconZoomCheck = IconZoomCheck;
  exports.IconZoomIn = IconZoomIn;
  exports.IconZoomMoney = IconZoomMoney;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map
